{
  "level": "mt03a",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt03a",
    "objects": "AREAS.E3:mt03a.e3",
    "mesh": "TREES.E3:mt03a.e3"
  },
  "spawn_point": {
    "position": [
      -1035.380408951479,
      -2737.769840332942,
      522.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1035.380408951479,
      -2637.769840332942,
      522.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1208.0,
      -2978.0,
      498.0
    ],
    "bbox_max": [
      -575.7611694335938,
      -2152.899169921875,
      863.8005981445312
    ],
    "vertex_count": 1609,
    "vertices": [
      [
        -1085.0,
        -2686.0,
        696.0
      ],
      [
        -1090.0,
        -2686.0,
        696.0
      ],
      [
        -1090.0,
        -2686.0,
        698.0
      ],
      [
        -1085.0,
        -2686.0,
        698.0
      ],
      [
        -1085.0,
        -2800.0,
        698.0
      ],
      [
        -1090.0,
        -2800.0,
        698.0
      ],
      [
        -1090.0,
        -2800.0,
        696.0
      ],
      [
        -1085.0,
        -2800.0,
        696.0
      ],
      [
        -1072.0,
        -2741.39990234375,
        697.5
      ],
      [
        -1072.0,
        -2741.39990234375,
        696.5
      ],
      [
        -1070.9014892578125,
        -2744.39990234375,
        696.5
      ],
      [
        -1070.9014892578125,
        -2744.39990234375,
        697.5
      ],
      [
        -1083.0001220703125,
        -2705.89990234375,
        696.5
      ],
      [
        -1083.0001220703125,
        -2705.89990234375,
        697.5
      ],
      [
        -1084.0986328125,
        -2702.89990234375,
        697.5
      ],
      [
        -1084.0986328125,
        -2702.89990234375,
        696.5
      ],
      [
        -1070.0,
        -2686.0,
        697.5
      ],
      [
        -1070.0,
        -2686.0,
        696.5
      ],
      [
        -1085.0,
        -2686.0,
        696.5
      ],
      [
        -1085.0,
        -2686.0,
        697.5
      ],
      [
        -1083.0,
        -2780.0,
        697.5
      ],
      [
        -1083.0,
        -2780.0,
        696.5
      ],
      [
        -1084.095458984375,
        -2783.0,
        696.5
      ],
      [
        -1084.095458984375,
        -2783.0,
        697.5
      ],
      [
        -1072.0,
        -2744.39990234375,
        696.5
      ],
      [
        -1072.0,
        -2744.39990234375,
        697.5
      ],
      [
        -1070.0,
        -2800.0,
        696.5
      ],
      [
        -1070.0,
        -2800.0,
        697.5
      ],
      [
        -1085.0,
        -2800.0,
        697.5
      ],
      [
        -1085.0,
        -2800.0,
        696.5
      ],
      [
        -1070.0,
        -2686.0,
        698.0
      ],
      [
        -1070.0,
        -2800.0,
        698.0
      ],
      [
        -1070.0,
        -2686.0,
        696.0
      ],
      [
        -1070.0,
        -2800.0,
        696.0
      ],
      [
        -1105.0,
        -2686.0,
        696.0
      ],
      [
        -1110.0,
        -2686.0,
        696.0
      ],
      [
        -1110.0,
        -2686.0,
        698.0
      ],
      [
        -1105.0,
        -2686.0,
        698.0
      ],
      [
        -1105.0,
        -2800.0,
        698.0
      ],
      [
        -1110.0,
        -2800.0,
        698.0
      ],
      [
        -1110.0,
        -2800.0,
        696.0
      ],
      [
        -1105.0,
        -2800.0,
        696.0
      ],
      [
        -1102.9998779296875,
        -2741.39990234375,
        697.5
      ],
      [
        -1102.9998779296875,
        -2741.39990234375,
        696.5
      ],
      [
        -1104.0985107421875,
        -2744.39990234375,
        696.5
      ],
      [
        -1104.0985107421875,
        -2744.39990234375,
        697.5
      ],
      [
        -1091.9998779296875,
        -2705.89990234375,
        696.5
      ],
      [
        -1091.9998779296875,
        -2705.89990234375,
        697.5
      ],
      [
        -1090.9013671875,
        -2702.89990234375,
        697.5
      ],
      [
        -1090.9013671875,
        -2702.89990234375,
        696.5
      ],
      [
        -1105.0,
        -2686.0,
        696.5
      ],
      [
        -1105.0,
        -2686.0,
        697.5
      ],
      [
        -1090.0,
        -2686.0,
        697.5
      ],
      [
        -1090.0,
        -2686.0,
        696.5
      ],
      [
        -1091.9998779296875,
        -2780.0,
        697.5
      ],
      [
        -1091.9998779296875,
        -2780.0,
        696.5
      ],
      [
        -1090.904541015625,
        -2783.0,
        696.5
      ],
      [
        -1090.904541015625,
        -2783.0,
        697.5
      ],
      [
        -1103.0,
        -2744.39990234375,
        696.5
      ],
      [
        -1103.0,
        -2744.39990234375,
        697.5
      ],
      [
        -1105.0,
        -2800.0,
        697.5
      ],
      [
        -1105.0,
        -2800.0,
        696.5
      ],
      [
        -1090.0,
        -2800.0,
        696.5
      ],
      [
        -1090.0,
        -2800.0,
        697.5
      ],
      [
        -1145.0,
        -2686.0,
        696.0
      ],
      [
        -1150.0,
        -2686.0,
        696.0
      ],
      [
        -1150.0,
        -2686.0,
        698.0
      ],
      [
        -1145.0,
        -2686.0,
        698.0
      ],
      [
        -1145.0,
        -2800.0,
        698.0
      ],
      [
        -1150.0,
        -2800.0,
        698.0
      ],
      [
        -1150.0,
        -2800.0,
        696.0
      ],
      [
        -1145.0,
        -2800.0,
        696.0
      ],
      [
        -1162.0,
        -2777.261474609375,
        697.5
      ],
      [
        -1162.0,
        -2777.261474609375,
        696.5
      ],
      [
        -1162.0,
        -2708.630859375,
        696.5
      ],
      [
        -1162.0,
        -2708.630859375,
        697.5
      ],
      [
        -1162.0,
        -2744.39990234375,
        696.5
      ],
      [
        -1162.0,
        -2741.39990234375,
        696.5
      ],
      [
        -1162.0,
        -2708.630859375,
        696.5
      ],
      [
        -1162.0,
        -2714.09228515625,
        696.5
      ],
      [
        -1162.0,
        -2771.78466796875,
        696.5
      ],
      [
        -1162.0,
        -2777.261474609375,
        696.5
      ],
      [
        -1162.0,
        -2741.39990234375,
        697.5
      ],
      [
        -1162.0,
        -2744.39990234375,
        697.5
      ],
      [
        -1162.0,
        -2708.630859375,
        697.5
      ],
      [
        -1162.0,
        -2714.09228515625,
        697.5
      ],
      [
        -1162.0,
        -2771.78466796875,
        697.5
      ],
      [
        -1162.0,
        -2777.261474609375,
        697.5
      ],
      [
        -1162.0,
        -2771.78466796875,
        696.5
      ],
      [
        -1162.0,
        -2771.78466796875,
        697.5
      ],
      [
        -1152.0,
        -2744.39990234375,
        697.5
      ],
      [
        -1152.0,
        -2744.39990234375,
        696.5
      ],
      [
        -1150.904541015625,
        -2741.39990234375,
        696.5
      ],
      [
        -1150.904541015625,
        -2741.39990234375,
        697.5
      ],
      [
        -1162.0,
        -2714.09228515625,
        697.5
      ],
      [
        -1162.0,
        -2714.09228515625,
        696.5
      ],
      [
        -1152.0,
        -2741.39990234375,
        696.5
      ],
      [
        -1152.0,
        -2741.39990234375,
        697.5
      ],
      [
        -1162.0,
        -2744.39990234375,
        697.5
      ],
      [
        -1162.0,
        -2744.39990234375,
        696.5
      ],
      [
        -1162.0,
        -2741.39990234375,
        696.5
      ],
      [
        -1162.0,
        -2741.39990234375,
        697.5
      ],
      [
        -1162.0,
        -2686.0,
        696.0
      ],
      [
        -1162.0,
        -2686.0,
        698.0
      ],
      [
        -1162.0,
        -2705.89990234375,
        696.5
      ],
      [
        -1162.0,
        -2702.89990234375,
        696.5
      ],
      [
        -1162.0,
        -2702.89990234375,
        697.5
      ],
      [
        -1162.0,
        -2705.89990234375,
        697.5
      ],
      [
        -1162.0,
        -2705.89990234375,
        697.5
      ],
      [
        -1162.0,
        -2705.89990234375,
        696.5
      ],
      [
        -1162.0,
        -2702.89990234375,
        696.5
      ],
      [
        -1162.0,
        -2702.89990234375,
        697.5
      ],
      [
        -1162.0,
        -2800.0,
        698.0
      ],
      [
        -1162.0,
        -2800.0,
        696.0
      ],
      [
        -1162.0,
        -2783.0,
        696.5
      ],
      [
        -1162.0,
        -2780.0,
        696.5
      ],
      [
        -1162.0,
        -2780.0,
        697.5
      ],
      [
        -1162.0,
        -2783.0,
        697.5
      ],
      [
        -1162.0,
        -2780.0,
        696.5
      ],
      [
        -1162.0,
        -2780.0,
        697.5
      ],
      [
        -1162.0,
        -2783.0,
        697.5
      ],
      [
        -1162.0,
        -2783.0,
        696.5
      ],
      [
        -1125.0,
        -2800.0,
        698.0
      ],
      [
        -1130.0,
        -2800.0,
        698.0
      ],
      [
        -1130.0,
        -2800.0,
        696.0
      ],
      [
        -1125.0,
        -2800.0,
        696.0
      ],
      [
        -1125.0,
        -2686.0,
        696.0
      ],
      [
        -1130.0,
        -2686.0,
        696.0
      ],
      [
        -1130.0,
        -2686.0,
        698.0
      ],
      [
        -1125.0,
        -2686.0,
        698.0
      ],
      [
        -1142.9998779296875,
        -2741.39990234375,
        697.5
      ],
      [
        -1142.9998779296875,
        -2741.39990234375,
        696.5
      ],
      [
        -1144.098388671875,
        -2744.39990234375,
        696.5
      ],
      [
        -1144.098388671875,
        -2744.39990234375,
        697.5
      ],
      [
        -1131.9998779296875,
        -2705.89990234375,
        696.5
      ],
      [
        -1131.9998779296875,
        -2705.89990234375,
        697.5
      ],
      [
        -1130.9012451171875,
        -2702.89990234375,
        697.5
      ],
      [
        -1130.9012451171875,
        -2702.89990234375,
        696.5
      ],
      [
        -1145.0,
        -2686.0,
        696.5
      ],
      [
        -1145.0,
        -2686.0,
        697.5
      ],
      [
        -1130.0,
        -2686.0,
        697.5
      ],
      [
        -1130.0,
        -2686.0,
        696.5
      ],
      [
        -1132.0,
        -2780.0,
        697.5
      ],
      [
        -1132.0,
        -2780.0,
        696.5
      ],
      [
        -1130.9046630859375,
        -2783.0,
        696.5
      ],
      [
        -1130.9046630859375,
        -2783.0,
        697.5
      ],
      [
        -1143.0,
        -2744.39990234375,
        696.5
      ],
      [
        -1143.0,
        -2744.39990234375,
        697.5
      ],
      [
        -1145.0,
        -2800.0,
        697.5
      ],
      [
        -1145.0,
        -2800.0,
        696.5
      ],
      [
        -1130.0,
        -2800.0,
        696.5
      ],
      [
        -1130.0,
        -2800.0,
        697.5
      ],
      [
        -1112.0,
        -2741.39990234375,
        696.5
      ],
      [
        -1112.0,
        -2741.39990234375,
        697.5
      ],
      [
        -1110.9014892578125,
        -2744.39990234375,
        697.5
      ],
      [
        -1110.9014892578125,
        -2744.39990234375,
        696.5
      ],
      [
        -1123.0001220703125,
        -2705.89990234375,
        697.5
      ],
      [
        -1123.0001220703125,
        -2705.89990234375,
        696.5
      ],
      [
        -1124.0987548828125,
        -2702.89990234375,
        696.5
      ],
      [
        -1124.0987548828125,
        -2702.89990234375,
        697.5
      ],
      [
        -1125.0,
        -2686.0,
        696.5
      ],
      [
        -1125.0,
        -2686.0,
        697.5
      ],
      [
        -1110.0,
        -2686.0,
        697.5
      ],
      [
        -1110.0,
        -2686.0,
        696.5
      ],
      [
        -1123.0,
        -2780.0,
        696.5
      ],
      [
        -1123.0,
        -2780.0,
        697.5
      ],
      [
        -1124.095458984375,
        -2783.0,
        697.5
      ],
      [
        -1124.095458984375,
        -2783.0,
        696.5
      ],
      [
        -1112.0,
        -2744.39990234375,
        697.5
      ],
      [
        -1112.0,
        -2744.39990234375,
        696.5
      ],
      [
        -1125.0,
        -2800.0,
        697.5
      ],
      [
        -1125.0,
        -2800.0,
        696.5
      ],
      [
        -1110.0,
        -2800.0,
        696.5
      ],
      [
        -1110.0,
        -2800.0,
        697.5
      ],
      [
        -1162.0,
        -2770.0,
        708.0
      ],
      [
        -1162.0,
        -2800.0,
        708.0
      ],
      [
        -1162.0,
        -2716.0,
        708.0
      ],
      [
        -1162.0,
        -2686.0,
        708.0
      ],
      [
        -1162.0,
        -2716.0,
        708.0
      ],
      [
        -1162.0,
        -2770.0,
        708.0
      ],
      [
        -1162.0,
        -2805.0,
        800.0
      ],
      [
        -1162.0,
        -2795.0,
        800.0
      ],
      [
        -1162.0,
        -2795.0,
        800.0
      ],
      [
        -1162.0,
        -2785.0,
        800.0
      ],
      [
        -1162.0,
        -2805.0,
        795.0
      ],
      [
        -1162.0,
        -2795.0,
        795.0
      ],
      [
        -1162.0,
        -2795.0,
        795.0
      ],
      [
        -1162.0,
        -2785.0,
        795.0
      ],
      [
        -1162.0,
        -2805.0,
        800.0
      ],
      [
        -1162.0,
        -2805.0,
        795.0
      ],
      [
        -1070.0,
        -2830.0,
        822.7142944335938
      ],
      [
        -1070.0,
        -2822.0,
        822.7142944335938
      ],
      [
        -1070.0,
        -2822.0,
        827.7142944335938
      ],
      [
        -1070.0,
        -2830.0,
        827.7142944335938
      ],
      [
        -1070.0,
        -2830.0,
        827.7142944335938
      ],
      [
        -1070.0,
        -2830.0,
        822.7142944335938
      ],
      [
        -1070.0,
        -2822.0,
        822.7142944335938
      ],
      [
        -1070.0,
        -2822.0,
        827.7142944335938
      ],
      [
        -1090.0,
        -2830.0,
        822.1621704101562
      ],
      [
        -1080.0,
        -2830.0,
        822.1621704101562
      ],
      [
        -1162.0,
        -2775.0,
        800.0
      ],
      [
        -1162.0,
        -2785.0,
        800.0
      ],
      [
        -1162.0,
        -2775.0,
        799.5714111328125
      ],
      [
        -1162.0,
        -2775.0,
        800.0
      ],
      [
        -1162.0,
        -2775.0,
        795.0
      ],
      [
        -1080.0,
        -2775.0,
        812.142822265625
      ],
      [
        -1080.0,
        -2785.0,
        812.142822265625
      ],
      [
        -1162.0,
        -2785.0,
        795.0
      ],
      [
        -1162.0,
        -2775.0,
        795.0
      ],
      [
        -1162.0,
        -2686.0,
        708.0
      ],
      [
        -1162.0,
        -2800.0,
        708.0
      ],
      [
        -1122.0,
        -2708.0,
        704.5
      ],
      [
        -1122.0,
        -2708.0,
        699.5
      ],
      [
        -1122.0,
        -2708.0,
        704.5
      ],
      [
        -1122.0,
        -2708.0,
        699.5
      ],
      [
        -1110.0,
        -2780.0,
        704.5
      ],
      [
        -1110.0,
        -2780.0,
        699.5
      ],
      [
        -1105.0,
        -2780.0,
        699.5
      ],
      [
        -1105.0,
        -2780.0,
        704.5
      ],
      [
        -1110.0,
        -2783.0,
        699.5
      ],
      [
        -1110.0,
        -2783.0,
        704.5
      ],
      [
        -1105.0,
        -2783.0,
        704.5
      ],
      [
        -1105.0,
        -2783.0,
        699.5
      ],
      [
        -1105.0,
        -2783.0,
        699.5
      ],
      [
        -1105.0,
        -2783.0,
        704.5
      ],
      [
        -1105.0,
        -2780.0,
        704.5
      ],
      [
        -1105.0,
        -2780.0,
        699.5
      ],
      [
        -1110.0,
        -2780.0,
        699.5
      ],
      [
        -1110.0,
        -2780.0,
        704.5
      ],
      [
        -1110.0,
        -2783.0,
        704.5
      ],
      [
        -1110.0,
        -2783.0,
        699.5
      ],
      [
        -1130.0,
        -2708.0,
        704.5
      ],
      [
        -1130.0,
        -2717.5,
        704.5
      ],
      [
        -1130.0,
        -2708.0,
        699.5
      ],
      [
        -1130.0,
        -2717.5,
        699.5
      ],
      [
        -1139.5,
        -2717.5,
        700.6142578125
      ],
      [
        -1139.5,
        -2708.0,
        700.6142578125
      ],
      [
        -1139.5,
        -2717.5,
        701.8740844726562
      ],
      [
        -1139.5,
        -2717.5,
        700.6142578125
      ],
      [
        -1139.5,
        -2717.5,
        704.5
      ],
      [
        -1139.5,
        -2717.5,
        701.8740844726562
      ],
      [
        -1130.0,
        -2717.5,
        699.5
      ],
      [
        -1130.0,
        -2717.5,
        704.5
      ],
      [
        -1139.5,
        -2708.0,
        701.8740844726562
      ],
      [
        -1139.5,
        -2708.0,
        700.6142578125
      ],
      [
        -1139.5,
        -2708.0,
        704.5
      ],
      [
        -1139.5,
        -2708.0,
        701.8740844726562
      ],
      [
        -1130.0,
        -2708.0,
        704.5
      ],
      [
        -1130.0,
        -2708.0,
        699.5
      ],
      [
        -1150.0,
        -2780.0,
        704.5
      ],
      [
        -1150.0,
        -2780.0,
        699.5
      ],
      [
        -1145.0,
        -2780.0,
        699.5
      ],
      [
        -1145.0,
        -2780.0,
        704.5
      ],
      [
        -1150.0,
        -2783.0,
        699.5
      ],
      [
        -1150.0,
        -2783.0,
        704.5
      ],
      [
        -1145.0,
        -2783.0,
        704.5
      ],
      [
        -1145.0,
        -2783.0,
        699.5
      ],
      [
        -1145.0,
        -2783.0,
        699.5
      ],
      [
        -1145.0,
        -2783.0,
        704.5
      ],
      [
        -1145.0,
        -2780.0,
        704.5
      ],
      [
        -1145.0,
        -2780.0,
        699.5
      ],
      [
        -1150.0,
        -2780.0,
        699.5
      ],
      [
        -1150.0,
        -2780.0,
        704.5
      ],
      [
        -1150.0,
        -2783.0,
        704.5
      ],
      [
        -1150.0,
        -2783.0,
        699.5
      ],
      [
        -1162.0,
        -2686.0,
        665.3999633789062
      ],
      [
        -1162.0,
        -2800.0,
        665.3999633789062
      ],
      [
        -1162.0,
        -2800.0,
        665.8999633789062
      ],
      [
        -1162.0,
        -2686.0,
        665.8999633789062
      ],
      [
        -1162.0,
        -2686.0,
        665.3999633789062
      ],
      [
        -1162.0,
        -2686.0,
        665.8999633789062
      ],
      [
        -1160.0,
        -2686.0,
        665.8999633789062
      ],
      [
        -1160.0,
        -2686.0,
        665.3999633789062
      ],
      [
        -1162.0,
        -2800.0,
        665.8999633789062
      ],
      [
        -1162.0,
        -2800.0,
        665.3999633789062
      ],
      [
        -1160.0,
        -2800.0,
        665.3999633789062
      ],
      [
        -1160.0,
        -2800.0,
        665.8999633789062
      ],
      [
        -1160.0,
        -2686.0,
        696.0
      ],
      [
        -1160.0,
        -2800.0,
        696.0
      ],
      [
        -1162.0,
        -2770.0,
        650.0
      ],
      [
        -1160.0,
        -2770.0,
        650.0
      ],
      [
        -1160.0,
        -2800.0,
        650.0
      ],
      [
        -1162.0,
        -2800.0,
        650.0
      ],
      [
        -1160.0,
        -2716.0,
        650.0
      ],
      [
        -1162.0,
        -2716.0,
        650.0
      ],
      [
        -1162.0,
        -2686.0,
        650.0
      ],
      [
        -1160.0,
        -2686.0,
        650.0
      ],
      [
        -1160.0,
        -2770.0,
        650.0
      ],
      [
        -1162.0,
        -2770.0,
        650.0
      ],
      [
        -1162.0,
        -2716.0,
        650.0
      ],
      [
        -1160.0,
        -2716.0,
        650.0
      ],
      [
        -1160.0,
        -2686.0,
        650.0
      ],
      [
        -1162.0,
        -2686.0,
        650.0
      ],
      [
        -1162.0,
        -2800.0,
        650.0
      ],
      [
        -1160.0,
        -2800.0,
        650.0
      ],
      [
        -1100.0,
        -2786.5,
        680.0
      ],
      [
        -1100.0,
        -2786.5,
        650.0
      ],
      [
        -1120.0,
        -2786.5,
        650.0
      ],
      [
        -1120.0,
        -2786.5,
        670.0
      ],
      [
        -1110.0,
        -2786.5,
        670.0
      ],
      [
        -1110.0,
        -2786.5,
        680.0
      ],
      [
        -1110.0,
        -2786.5,
        680.0
      ],
      [
        -1100.0,
        -2786.5,
        680.0
      ],
      [
        -1120.0,
        -2786.5,
        670.0
      ],
      [
        -1110.0,
        -2786.5,
        670.0
      ],
      [
        -1130.0,
        -2766.5,
        670.0
      ],
      [
        -1120.0,
        -2766.5,
        670.0
      ],
      [
        -1154.0,
        -2775.0,
        670.0
      ],
      [
        -1134.0,
        -2775.0,
        670.0
      ],
      [
        -1134.0,
        -2775.0,
        670.0
      ],
      [
        -1134.0,
        -2775.0,
        650.0
      ],
      [
        -1154.0,
        -2775.0,
        650.0
      ],
      [
        -1154.0,
        -2775.0,
        670.0
      ],
      [
        -1130.0,
        -2766.5,
        650.0
      ],
      [
        -1130.0,
        -2766.5,
        670.0
      ],
      [
        -1120.0,
        -2766.5,
        670.0
      ],
      [
        -1120.0,
        -2766.5,
        690.0
      ],
      [
        -1120.0,
        -2766.5,
        690.0
      ],
      [
        -1110.0,
        -2766.5,
        690.0
      ],
      [
        -1146.0,
        -2717.0,
        670.0
      ],
      [
        -1146.0,
        -2717.0,
        650.0
      ],
      [
        -1156.0,
        -2717.0,
        650.0
      ],
      [
        -1156.0,
        -2717.0,
        670.0
      ],
      [
        -1156.0,
        -2717.0,
        670.0
      ],
      [
        -1146.0,
        -2717.0,
        670.0
      ],
      [
        -1164.0,
        -2686.0,
        665.8999633789062
      ],
      [
        -1162.0,
        -2686.0,
        665.8999633789062
      ],
      [
        -1162.0,
        -2686.0,
        665.3999633789062
      ],
      [
        -1164.0,
        -2686.0,
        665.3999633789062
      ],
      [
        -1164.0,
        -2800.0,
        665.3999633789062
      ],
      [
        -1162.0,
        -2800.0,
        665.3999633789062
      ],
      [
        -1162.0,
        -2800.0,
        665.8999633789062
      ],
      [
        -1164.0,
        -2800.0,
        665.8999633789062
      ],
      [
        -1165.0,
        -2686.0,
        665.3999633789062
      ],
      [
        -1165.0,
        -2686.0,
        665.8999633789062
      ],
      [
        -1165.0,
        -2800.0,
        665.8999633789062
      ],
      [
        -1165.0,
        -2800.0,
        665.3999633789062
      ],
      [
        -1165.0,
        -2805.0,
        800.0
      ],
      [
        -1165.0,
        -2795.0,
        800.0
      ],
      [
        -1165.0,
        -2795.0,
        800.0
      ],
      [
        -1165.0,
        -2785.0,
        800.0
      ],
      [
        -1165.0,
        -2775.0,
        800.0
      ],
      [
        -1165.0,
        -2785.0,
        800.0
      ],
      [
        -1165.0,
        -2805.0,
        795.0
      ],
      [
        -1165.0,
        -2795.0,
        795.0
      ],
      [
        -1165.0,
        -2795.0,
        795.0
      ],
      [
        -1165.0,
        -2785.0,
        795.0
      ],
      [
        -1165.0,
        -2785.0,
        795.0
      ],
      [
        -1165.0,
        -2775.0,
        795.0
      ],
      [
        -1165.0,
        -2805.0,
        800.0
      ],
      [
        -1165.0,
        -2805.0,
        795.0
      ],
      [
        -1165.0,
        -2775.0,
        795.0
      ],
      [
        -1165.0,
        -2775.0,
        800.0
      ],
      [
        -1182.5,
        -2800.0,
        795.0
      ],
      [
        -1190.0,
        -2800.0,
        795.0
      ],
      [
        -1190.0,
        -2800.0,
        795.0
      ],
      [
        -1200.0,
        -2800.0,
        795.0
      ],
      [
        -1170.0,
        -2800.0,
        795.0
      ],
      [
        -1165.0,
        -2800.0,
        795.0
      ],
      [
        -1182.5,
        -2800.0,
        795.0
      ],
      [
        -1170.0,
        -2800.0,
        795.0
      ],
      [
        -1182.5,
        -2800.0,
        800.0
      ],
      [
        -1190.0,
        -2800.0,
        800.0
      ],
      [
        -1190.0,
        -2800.0,
        800.0
      ],
      [
        -1200.0,
        -2800.0,
        800.0
      ],
      [
        -1170.0,
        -2800.0,
        800.0
      ],
      [
        -1165.0,
        -2800.0,
        800.0
      ],
      [
        -1182.5,
        -2800.0,
        800.0
      ],
      [
        -1170.0,
        -2800.0,
        800.0
      ],
      [
        -1200.0,
        -2800.0,
        795.0
      ],
      [
        -1200.0,
        -2800.0,
        800.0
      ],
      [
        -1190.9820556640625,
        -2716.0,
        708.0
      ],
      [
        -1181.417724609375,
        -2716.0,
        708.0
      ],
      [
        -1174.6513671875,
        -2709.2333984375,
        708.0
      ],
      [
        -1174.6514892578125,
        -2699.666748046875,
        708.0
      ],
      [
        -1181.4166259765625,
        -2692.9013671875,
        708.0
      ],
      [
        -1190.983642578125,
        -2692.9013671875,
        708.0
      ],
      [
        -1197.74853515625,
        -2699.66650390625,
        708.0
      ],
      [
        -1197.7484130859375,
        -2709.2333984375,
        708.0
      ],
      [
        -1181.417724609375,
        -2716.0,
        498.0
      ],
      [
        -1190.9820556640625,
        -2716.0,
        498.0
      ],
      [
        -1197.7484130859375,
        -2709.2333984375,
        498.0
      ],
      [
        -1197.74853515625,
        -2699.66650390625,
        498.0
      ],
      [
        -1190.983642578125,
        -2692.9013671875,
        498.0
      ],
      [
        -1181.4166259765625,
        -2692.9013671875,
        498.0
      ],
      [
        -1174.6514892578125,
        -2699.666748046875,
        498.0
      ],
      [
        -1174.6513671875,
        -2709.2333984375,
        498.0
      ],
      [
        -1202.53173828125,
        -2704.449951171875,
        498.0
      ],
      [
        -1202.53173828125,
        -2704.449951171875,
        708.0
      ],
      [
        -1174.6512451171875,
        -2716.0,
        498.0
      ],
      [
        -1174.6512451171875,
        -2716.0,
        708.0
      ],
      [
        -1208.0,
        -2692.9013671875,
        708.0
      ],
      [
        -1208.0,
        -2698.9814453125,
        708.0
      ],
      [
        -1208.0,
        -2698.9814453125,
        498.0
      ],
      [
        -1208.0,
        -2692.9013671875,
        498.0
      ],
      [
        -1188.3177490234375,
        -2686.0,
        708.0
      ],
      [
        -1188.3177490234375,
        -2686.0,
        498.0
      ],
      [
        -1174.651611328125,
        -2686.0,
        708.0
      ],
      [
        -1174.651611328125,
        -2686.0,
        498.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        695.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        697.5
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        697.5
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        708.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        650.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        695.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        650.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        498.0
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        695.0
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        697.5
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        697.5
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        708.0
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        650.0
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        695.0
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        650.0
      ],
      [
        -1180.9163818359375,
        -2770.50146484375,
        498.0
      ],
      [
        -1190.9820556640625,
        -2770.0,
        498.0
      ],
      [
        -1181.417724609375,
        -2770.0,
        498.0
      ],
      [
        -1180.9161376953125,
        -2770.50146484375,
        498.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        498.0
      ],
      [
        -1180.936767578125,
        -2770.480712890625,
        708.0
      ],
      [
        -1180.9161376953125,
        -2770.50146484375,
        708.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        708.0
      ],
      [
        -1191.4635009765625,
        -2770.4814453125,
        708.0
      ],
      [
        -1181.417724609375,
        -2770.0,
        708.0
      ],
      [
        -1190.9820556640625,
        -2770.0,
        708.0
      ],
      [
        -1191.4635009765625,
        -2770.4814453125,
        708.0
      ],
      [
        -1180.936767578125,
        -2770.480712890625,
        708.0
      ],
      [
        -1165.72998046875,
        -2770.50146484375,
        708.0
      ],
      [
        -1165.0,
        -2770.50146484375,
        708.0
      ],
      [
        -1165.72998046875,
        -2770.50146484375,
        708.0
      ],
      [
        -1165.0,
        -2770.50146484375,
        498.0
      ],
      [
        -1207.2269287109375,
        -2770.50146484375,
        708.0
      ],
      [
        -1207.2269287109375,
        -2770.50146484375,
        708.0
      ],
      [
        -1208.0,
        -2770.50146484375,
        708.0
      ],
      [
        -1208.0,
        -2770.50146484375,
        498.0
      ],
      [
        -1190.9835205078125,
        -2754.5986328125,
        708.0
      ],
      [
        -1181.41650390625,
        -2754.5986328125,
        708.0
      ],
      [
        -1174.6512451171875,
        -2747.833251953125,
        708.0
      ],
      [
        -1174.6513671875,
        -2738.266357421875,
        708.0
      ],
      [
        -1181.416259765625,
        -2731.50146484375,
        708.0
      ],
      [
        -1190.9835205078125,
        -2731.50146484375,
        708.0
      ],
      [
        -1197.7484130859375,
        -2738.266357421875,
        708.0
      ],
      [
        -1197.7484130859375,
        -2747.83349609375,
        708.0
      ],
      [
        -1197.7484130859375,
        -2738.266357421875,
        498.0
      ],
      [
        -1190.9835205078125,
        -2731.50146484375,
        498.0
      ],
      [
        -1181.416259765625,
        -2731.50146484375,
        498.0
      ],
      [
        -1174.6513671875,
        -2738.266357421875,
        498.0
      ],
      [
        -1174.6512451171875,
        -2747.833251953125,
        498.0
      ],
      [
        -1181.41650390625,
        -2754.5986328125,
        498.0
      ],
      [
        -1190.9835205078125,
        -2754.5986328125,
        498.0
      ],
      [
        -1197.7484130859375,
        -2747.83349609375,
        498.0
      ],
      [
        -1202.5318603515625,
        -2743.0498046875,
        708.0
      ],
      [
        -1202.5318603515625,
        -2743.0498046875,
        498.0
      ],
      [
        -1174.6512451171875,
        -2754.5986328125,
        708.0
      ],
      [
        -1174.6512451171875,
        -2754.5986328125,
        498.0
      ],
      [
        -1208.0,
        -2748.51806640625,
        708.0
      ],
      [
        -1208.0,
        -2754.5986328125,
        708.0
      ],
      [
        -1208.0,
        -2754.5986328125,
        498.0
      ],
      [
        -1208.0,
        -2748.51806640625,
        498.0
      ],
      [
        -1208.0,
        -2731.50146484375,
        708.0
      ],
      [
        -1208.0,
        -2731.50146484375,
        498.0
      ],
      [
        -1174.6514892578125,
        -2731.50146484375,
        708.0
      ],
      [
        -1174.6514892578125,
        -2731.50146484375,
        498.0
      ],
      [
        -1174.6510009765625,
        -2770.0,
        708.0
      ],
      [
        -1174.6510009765625,
        -2770.0,
        498.0
      ],
      [
        -1174.6517333984375,
        -2716.0,
        708.0
      ],
      [
        -1174.6517333984375,
        -2716.0,
        498.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        695.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        697.5
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        697.5
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        708.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        650.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        695.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        650.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        498.0
      ],
      [
        -1197.74853515625,
        -2776.7666015625,
        498.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        498.0
      ],
      [
        -1190.7762451171875,
        -2770.50146484375,
        498.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        498.0
      ],
      [
        -1197.677490234375,
        -2776.695556640625,
        708.0
      ],
      [
        -1191.4835205078125,
        -2770.50146484375,
        708.0
      ],
      [
        -1197.677490234375,
        -2776.695556640625,
        708.0
      ],
      [
        -1197.74853515625,
        -2776.7666015625,
        708.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        708.0
      ],
      [
        -1208.0,
        -2787.018310546875,
        708.0
      ],
      [
        -1208.0,
        -2787.725341796875,
        708.0
      ],
      [
        -1208.0,
        -2787.725341796875,
        498.0
      ],
      [
        -1208.0,
        -2787.018310546875,
        498.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        695.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        697.5
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        697.5
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        708.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        650.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        695.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        650.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        498.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        498.0
      ],
      [
        -1197.2484130859375,
        -2776.9736328125,
        498.0
      ],
      [
        -1197.248291015625,
        -2786.833740234375,
        498.0
      ],
      [
        -1197.7484130859375,
        -2786.33349609375,
        498.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        708.0
      ],
      [
        -1197.55712890625,
        -2786.52490234375,
        708.0
      ],
      [
        -1197.74853515625,
        -2777.4736328125,
        708.0
      ],
      [
        -1197.7484130859375,
        -2786.33349609375,
        708.0
      ],
      [
        -1197.55712890625,
        -2786.52490234375,
        708.0
      ],
      [
        -1202.1783447265625,
        -2781.903564453125,
        708.0
      ],
      [
        -1202.1783447265625,
        -2781.903564453125,
        498.0
      ],
      [
        -1197.248291015625,
        -2795.379638671875,
        708.0
      ],
      [
        -1197.2481689453125,
        -2800.0,
        708.0
      ],
      [
        -1197.248291015625,
        -2795.379638671875,
        708.0
      ],
      [
        -1197.2481689453125,
        -2800.0,
        795.0
      ],
      [
        -1197.248291015625,
        -2795.0,
        795.0
      ],
      [
        -1197.248291015625,
        -2795.0,
        800.0
      ],
      [
        -1197.2481689453125,
        -2800.0,
        800.0
      ],
      [
        -1197.248291015625,
        -2795.0,
        795.0
      ],
      [
        -1197.248291015625,
        -2795.0,
        800.0
      ],
      [
        -1197.2481689453125,
        -2800.0,
        498.0
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        695.0
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        697.5
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        697.5
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        708.0
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        650.0
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        695.0
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        650.0
      ],
      [
        -1190.2764892578125,
        -2793.0986328125,
        498.0
      ],
      [
        -1197.248291015625,
        -2786.833984375,
        498.0
      ],
      [
        -1197.248291015625,
        -2786.12646484375,
        498.0
      ],
      [
        -1190.2762451171875,
        -2793.0986328125,
        498.0
      ],
      [
        -1190.983642578125,
        -2793.0986328125,
        498.0
      ],
      [
        -1191.271240234375,
        -2792.811279296875,
        708.0
      ],
      [
        -1197.2484130859375,
        -2786.83349609375,
        708.0
      ],
      [
        -1190.2763671875,
        -2793.0986328125,
        708.0
      ],
      [
        -1191.271240234375,
        -2792.811279296875,
        708.0
      ],
      [
        -1190.98388671875,
        -2793.0986328125,
        708.0
      ],
      [
        -1197.2481689453125,
        -2793.0986328125,
        498.0
      ],
      [
        -1191.93994140625,
        -2793.0986328125,
        708.0
      ],
      [
        -1197.248291015625,
        -2793.0986328125,
        708.0
      ],
      [
        -1191.93994140625,
        -2793.0986328125,
        708.0
      ],
      [
        -1183.375,
        -2800.0,
        498.0
      ],
      [
        -1183.375,
        -2800.0,
        708.0
      ],
      [
        -1190.0,
        -2793.374755859375,
        800.0
      ],
      [
        -1190.0,
        -2793.374755859375,
        795.0
      ],
      [
        -1190.0,
        -2793.374755859375,
        800.0
      ],
      [
        -1188.3748779296875,
        -2795.0,
        800.0
      ],
      [
        -1188.3748779296875,
        -2795.0,
        795.0
      ],
      [
        -1190.0,
        -2793.374755859375,
        795.0
      ],
      [
        -1183.3748779296875,
        -2800.0,
        795.0
      ],
      [
        -1188.3748779296875,
        -2795.0,
        795.0
      ],
      [
        -1188.3748779296875,
        -2795.0,
        800.0
      ],
      [
        -1183.3748779296875,
        -2800.0,
        800.0
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        695.0
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        697.5
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        697.5
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        708.0
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        650.0
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        695.0
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        650.0
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        498.0
      ],
      [
        -1190.2762451171875,
        -2793.0986328125,
        498.0
      ],
      [
        -1190.7762451171875,
        -2792.5986328125,
        498.0
      ],
      [
        -1180.9163818359375,
        -2792.5986328125,
        498.0
      ],
      [
        -1181.4163818359375,
        -2793.0986328125,
        498.0
      ],
      [
        -1180.916259765625,
        -2792.5986328125,
        708.0
      ],
      [
        -1181.1341552734375,
        -2792.81640625,
        708.0
      ],
      [
        -1181.1341552734375,
        -2792.81640625,
        708.0
      ],
      [
        -1190.2763671875,
        -2793.0986328125,
        708.0
      ],
      [
        -1181.4163818359375,
        -2793.0986328125,
        708.0
      ],
      [
        -1182.5,
        -2793.0986328125,
        800.0
      ],
      [
        -1190.0,
        -2793.0986328125,
        800.0
      ],
      [
        -1182.5,
        -2793.0986328125,
        795.0
      ],
      [
        -1190.0,
        -2793.0986328125,
        795.0
      ],
      [
        -1190.0,
        -2793.0986328125,
        800.0
      ],
      [
        -1190.0,
        -2793.0986328125,
        795.0
      ],
      [
        -1182.5,
        -2793.0986328125,
        795.0
      ],
      [
        -1182.5,
        -2793.0986328125,
        800.0
      ],
      [
        -1185.8463134765625,
        -2797.528564453125,
        708.0
      ],
      [
        -1182.5,
        -2794.182373046875,
        800.0
      ],
      [
        -1183.3177490234375,
        -2795.0,
        800.0
      ],
      [
        -1183.3177490234375,
        -2795.0,
        800.0
      ],
      [
        -1185.8463134765625,
        -2797.528564453125,
        800.0
      ],
      [
        -1182.5,
        -2794.182373046875,
        795.0
      ],
      [
        -1183.3177490234375,
        -2795.0,
        795.0
      ],
      [
        -1185.8463134765625,
        -2797.528564453125,
        795.0
      ],
      [
        -1183.3177490234375,
        -2795.0,
        795.0
      ],
      [
        -1182.5,
        -2794.182373046875,
        795.0
      ],
      [
        -1182.5,
        -2794.182373046875,
        800.0
      ],
      [
        -1185.8463134765625,
        -2797.528564453125,
        498.0
      ],
      [
        -1170.4156494140625,
        -2792.5986328125,
        708.0
      ],
      [
        -1165.0,
        -2792.5986328125,
        708.0
      ],
      [
        -1170.4156494140625,
        -2792.5986328125,
        708.0
      ],
      [
        -1170.0,
        -2792.5986328125,
        795.0
      ],
      [
        -1170.0,
        -2792.5986328125,
        800.0
      ],
      [
        -1170.0,
        -2792.5986328125,
        800.0
      ],
      [
        -1165.0,
        -2792.5986328125,
        800.0
      ],
      [
        -1170.0,
        -2792.5986328125,
        795.0
      ],
      [
        -1165.0,
        -2792.5986328125,
        795.0
      ],
      [
        -1165.0,
        -2792.5986328125,
        498.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        650.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        695.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        650.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        498.0
      ],
      [
        -1180.916259765625,
        -2792.5986328125,
        498.0
      ],
      [
        -1181.62353515625,
        -2792.5986328125,
        498.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        498.0
      ],
      [
        -1174.6513671875,
        -2786.33349609375,
        498.0
      ],
      [
        -1174.8526611328125,
        -2786.53466796875,
        708.0
      ],
      [
        -1180.916259765625,
        -2792.5986328125,
        708.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        708.0
      ],
      [
        -1174.8526611328125,
        -2786.53466796875,
        708.0
      ],
      [
        -1174.6513671875,
        -2786.33349609375,
        708.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        697.5
      ],
      [
        -1174.6512451171875,
        -2792.5986328125,
        498.0
      ],
      [
        -1174.6513671875,
        -2786.809814453125,
        708.0
      ],
      [
        -1174.6512451171875,
        -2792.5986328125,
        708.0
      ],
      [
        -1174.6513671875,
        -2786.809814453125,
        708.0
      ],
      [
        -1165.0,
        -2775.97509765625,
        498.0
      ],
      [
        -1165.0,
        -2775.97509765625,
        708.0
      ],
      [
        -1170.0,
        -2780.97509765625,
        800.0
      ],
      [
        -1165.0,
        -2775.97509765625,
        800.0
      ],
      [
        -1170.0,
        -2780.97509765625,
        795.0
      ],
      [
        -1165.0,
        -2775.97509765625,
        795.0
      ],
      [
        -1170.0,
        -2780.97509765625,
        800.0
      ],
      [
        -1170.0,
        -2780.97509765625,
        795.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        695.0
      ],
      [
        -1165.7913818359375,
        -2776.766357421875,
        695.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        697.5
      ],
      [
        -1165.7913818359375,
        -2776.766357421875,
        697.5
      ],
      [
        -1165.7913818359375,
        -2776.766357421875,
        695.0
      ],
      [
        -1165.7913818359375,
        -2776.766357421875,
        697.5
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        650.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        695.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        650.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        498.0
      ],
      [
        -1174.6513671875,
        -2777.4736328125,
        498.0
      ],
      [
        -1181.62353515625,
        -2770.50146484375,
        498.0
      ],
      [
        -1180.9161376953125,
        -2770.50146484375,
        498.0
      ],
      [
        -1174.6513671875,
        -2776.766845703125,
        498.0
      ],
      [
        -1174.7322998046875,
        -2776.685546875,
        708.0
      ],
      [
        -1180.9161376953125,
        -2770.50146484375,
        708.0
      ],
      [
        -1174.7322998046875,
        -2776.685546875,
        708.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        708.0
      ],
      [
        -1174.6514892578125,
        -2776.7666015625,
        708.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        697.5
      ],
      [
        -1174.6514892578125,
        -2770.50146484375,
        498.0
      ],
      [
        -1174.6514892578125,
        -2776.630126953125,
        708.0
      ],
      [
        -1174.6514892578125,
        -2770.50146484375,
        708.0
      ],
      [
        -1174.6514892578125,
        -2776.630126953125,
        708.0
      ],
      [
        -1170.5750732421875,
        -2781.550048828125,
        498.0
      ],
      [
        -1170.5750732421875,
        -2781.550048828125,
        708.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        695.0
      ],
      [
        -1170.5750732421875,
        -2781.550048828125,
        695.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        697.5
      ],
      [
        -1170.5750732421875,
        -2781.550048828125,
        697.5
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        498.0
      ],
      [
        -1175.1513671875,
        -2786.12646484375,
        498.0
      ],
      [
        -1175.1514892578125,
        -2776.9736328125,
        498.0
      ],
      [
        -1174.6513671875,
        -2777.4736328125,
        498.0
      ],
      [
        -1174.6513671875,
        -2785.62646484375,
        708.0
      ],
      [
        -1174.6514892578125,
        -2777.4736328125,
        708.0
      ],
      [
        -656.0,
        -2164.501953125,
        498.3907775878906
      ],
      [
        -656.0,
        -2152.899169921875,
        694.83642578125
      ],
      [
        -612.2839965820312,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -575.7611694335938,
        -2246.5771484375,
        639.28125
      ],
      [
        -615.3544921875,
        -2201.833251953125,
        641.6248779296875
      ],
      [
        -612.2088623046875,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -612.2088623046875,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -612.2839965820312,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -656.0,
        -2236.7548828125,
        639.2813110351562
      ],
      [
        -656.0,
        -2305.515380859375,
        639.28125
      ],
      [
        -656.0,
        -2236.7548828125,
        641.6248779296875
      ],
      [
        -656.0,
        -2236.7548828125,
        639.2813110351562
      ],
      [
        -656.0,
        -2230.853271484375,
        641.6248779296875
      ],
      [
        -656.0,
        -2236.7548828125,
        641.6248779296875
      ],
      [
        -732.0,
        -2291.21142578125,
        639.28125
      ],
      [
        -732.0,
        -2322.6015625,
        639.28125
      ],
      [
        -732.0,
        -2285.115966796875,
        641.6248779296875
      ],
      [
        -732.0,
        -2291.21142578125,
        641.6248779296875
      ],
      [
        -732.0,
        -2291.21142578125,
        641.6248779296875
      ],
      [
        -732.0,
        -2291.21142578125,
        639.28125
      ],
      [
        -732.0,
        -2322.6015625,
        639.28125
      ],
      [
        -732.0,
        -2370.76171875,
        639.57861328125
      ],
      [
        -732.0,
        -2374.3623046875,
        667.65771484375
      ],
      [
        -732.0,
        -2377.76953125,
        673.1868896484375
      ],
      [
        -824.0,
        -2397.08740234375,
        641.1480712890625
      ],
      [
        -824.0,
        -2384.8837890625,
        661.5189208984375
      ],
      [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      [
        -753.8582153320312,
        -2300.75,
        641.6248779296875
      ],
      [
        -769.4964599609375,
        -2328.412109375,
        639.5219116210938
      ],
      [
        -824.0,
        -2397.85009765625,
        640.2296142578125
      ],
      [
        -824.0,
        -2397.08740234375,
        641.1480712890625
      ],
      [
        -824.0,
        -2384.8837890625,
        661.5189208984375
      ],
      [
        -824.0,
        -2384.304443359375,
        665.7431030273438
      ],
      [
        -819.0576171875,
        -2414.220703125,
        640.3125
      ],
      [
        -824.0,
        -2410.626220703125,
        640.3125
      ],
      [
        -824.0,
        -2397.85009765625,
        640.2296142578125
      ],
      [
        -769.4964599609375,
        -2328.412109375,
        639.5219116210938
      ],
      [
        -824.0,
        -2409.20263671875,
        687.1771240234375
      ],
      [
        -819.720703125,
        -2403.696533203125,
        687.14501953125
      ],
      [
        -789.2903442382812,
        -2353.5068359375,
        676.6459350585938
      ],
      [
        -824.0,
        -2387.8603515625,
        667.3145751953125
      ],
      [
        -824.0,
        -2410.626220703125,
        640.3125
      ],
      [
        -819.0576171875,
        -2414.220703125,
        640.3125
      ],
      [
        -824.0,
        -2422.7626953125,
        640.4518432617188
      ],
      [
        -732.0,
        -2318.593017578125,
        639.28125
      ],
      [
        -824.0,
        -2508.8759765625,
        665.5243530273438
      ],
      [
        -824.0,
        -2496.4072265625,
        648.3512573242188
      ],
      [
        -824.0,
        -2491.637939453125,
        641.2958374023438
      ],
      [
        -824.0,
        -2496.4072265625,
        648.3512573242188
      ],
      [
        -824.0,
        -2491.637939453125,
        641.2958374023438
      ],
      [
        -824.0,
        -2491.281005859375,
        641.2911987304688
      ],
      [
        -793.7870483398438,
        -2442.447265625,
        640.4312744140625
      ],
      [
        -824.0,
        -2484.419189453125,
        641.202392578125
      ],
      [
        -824.0,
        -2455.29345703125,
        640.8253784179688
      ],
      [
        -824.0,
        -2455.29345703125,
        640.8253784179688
      ],
      [
        -743.6061401367188,
        -2293.402587890625,
        641.6248779296875
      ],
      [
        -751.685302734375,
        -2303.782470703125,
        641.6248779296875
      ],
      [
        -824.0,
        -2737.0,
        721.0
      ],
      [
        -824.0,
        -2737.0,
        740.0
      ],
      [
        -795.0,
        -2745.0,
        721.0
      ],
      [
        -824.0,
        -2745.0,
        721.0
      ],
      [
        -824.0,
        -2737.0,
        721.0
      ],
      [
        -795.0,
        -2745.0,
        721.0
      ],
      [
        -795.0,
        -2745.0,
        740.0
      ],
      [
        -824.0,
        -2753.0,
        721.0
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -913.3468627929688,
        -2572.969482421875,
        723.5732421875
      ],
      [
        -928.4061279296875,
        -2585.4599609375,
        716.2435302734375
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -928.4061279296875,
        -2585.4599609375,
        716.2435302734375
      ],
      [
        -947.58984375,
        -2580.97021484375,
        688.7578735351562
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -824.0,
        -2384.376953125,
        665.213623046875
      ],
      [
        -913.3468627929688,
        -2572.969482421875,
        723.5732421875
      ],
      [
        -920.77587890625,
        -2636.0,
        770.546875
      ],
      [
        -920.77587890625,
        -2636.0,
        770.546875
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -922.527099609375,
        -2640.0,
        771.9608154296875
      ],
      [
        -915.2293090820312,
        -2636.0,
        770.546875
      ],
      [
        -915.2293090820312,
        -2636.0,
        770.546875
      ],
      [
        -916.80810546875,
        -2640.0,
        771.9608154296875
      ],
      [
        -912.8217163085938,
        -2636.0,
        770.546875
      ],
      [
        -912.8217163085938,
        -2636.0,
        770.546875
      ],
      [
        -914.9521484375,
        -2640.0,
        771.9608154296875
      ],
      [
        -891.3015747070312,
        -2562.72216796875,
        715.9363403320312
      ],
      [
        -904.1224975585938,
        -2499.389404296875,
        668.7374267578125
      ],
      [
        -903.125732421875,
        -2497.905517578125,
        667.6315307617188
      ],
      [
        -889.9989624023438,
        -2587.13720703125,
        731.292236328125
      ],
      [
        -892.94775390625,
        -2570.603515625,
        719.03125
      ],
      [
        -892.94775390625,
        -2570.603515625,
        719.03125
      ],
      [
        -906.3084716796875,
        -2503.815185546875,
        669.7528686523438
      ],
      [
        -905.145751953125,
        -2502.209716796875,
        668.3117065429688
      ],
      [
        -932.1755981445312,
        -2559.8056640625,
        677.4135131835938
      ],
      [
        -889.9989624023438,
        -2587.13720703125,
        731.292236328125
      ],
      [
        -892.0723266601562,
        -2637.68701171875,
        758.7876586914062
      ],
      [
        -892.0723266601562,
        -2637.68701171875,
        758.7876586914062
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -891.8818969726562,
        -2640.0,
        760.302978515625
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -897.95458984375,
        -2640.0,
        770.9197387695312
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -957.8712158203125,
        -2640.0,
        666.6993408203125
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.090576171875,
        -2640.0,
        666.505859375
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -883.9585571289062,
        -2517.393310546875,
        645.1510009765625
      ],
      [
        -879.0,
        -2498.308837890625,
        641.796875
      ],
      [
        -883.9585571289062,
        -2517.393310546875,
        645.1510009765625
      ],
      [
        -841.05712890625,
        -2520.411376953125,
        643.9255981445312
      ],
      [
        -832.8280639648438,
        -2505.729736328125,
        641.5447998046875
      ],
      [
        -833.508544921875,
        -2505.56494140625,
        641.5477905273438
      ],
      [
        -832.8280639648438,
        -2505.729736328125,
        641.5447998046875
      ],
      [
        -838.2353515625,
        -2515.308837890625,
        643.0996704101562
      ],
      [
        -841.05712890625,
        -2520.411376953125,
        643.9255981445312
      ],
      [
        -838.2353515625,
        -2515.308837890625,
        643.0996704101562
      ],
      [
        -879.0,
        -2498.308837890625,
        641.796875
      ],
      [
        -865.96435546875,
        -2497.705078125,
        641.6907958984375
      ],
      [
        -878.090576171875,
        -2640.0,
        666.505859375
      ],
      [
        -868.9373168945312,
        -2577.1015625,
        655.6448364257812
      ],
      [
        -878.0274047851562,
        -2640.0,
        666.6993408203125
      ],
      [
        -840.451171875,
        -2520.764404296875,
        645.7434692382812
      ],
      [
        -865.4737548828125,
        -2570.660888671875,
        654.5128784179688
      ],
      [
        -826.6605834960938,
        -2495.885009765625,
        641.370849609375
      ],
      [
        -835.4375610351562,
        -2511.593994140625,
        644.1317749023438
      ],
      [
        -840.451171875,
        -2520.764404296875,
        645.7434692382812
      ],
      [
        -835.4375610351562,
        -2511.593994140625,
        644.1317749023438
      ],
      [
        -826.6605834960938,
        -2495.885009765625,
        641.370849609375
      ],
      [
        -833.508544921875,
        -2505.56494140625,
        641.5477905273438
      ],
      [
        -828.005615234375,
        -2495.947265625,
        641.3817749023438
      ],
      [
        -857.8703002929688,
        -2499.665283203125,
        641.6551513671875
      ],
      [
        -857.4056396484375,
        -2497.308837890625,
        641.6211547851562
      ],
      [
        -865.4737548828125,
        -2570.660888671875,
        654.5128784179688
      ],
      [
        -868.9373168945312,
        -2577.1015625,
        655.6448364257812
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -862.9345092773438,
        -2640.0,
        705.8839111328125
      ],
      [
        -860.8434448242188,
        -2585.10986328125,
        684.7120361328125
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -824.0,
        -2504.115966796875,
        658.9685668945312
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -827.136474609375,
        -2409.507568359375,
        683.728759765625
      ],
      [
        -824.0,
        -2403.040283203125,
        681.442138671875
      ],
      [
        -860.8434448242188,
        -2585.10986328125,
        684.7120361328125
      ],
      [
        -862.9345092773438,
        -2640.0,
        705.8839111328125
      ],
      [
        -863.10595703125,
        -2640.0,
        705.4423828125
      ],
      [
        -862.9396362304688,
        -2596.27880859375,
        684.7179565429688
      ],
      [
        -871.1453247070312,
        -2640.0,
        684.7410888671875
      ],
      [
        -891.8812866210938,
        -2576.5830078125,
        723.4655151367188
      ],
      [
        -873.3709716796875,
        -2640.0,
        679.010009765625
      ],
      [
        -891.8904418945312,
        -2576.531494140625,
        723.4274291992188
      ],
      [
        -824.0,
        -2384.515869140625,
        664.2017822265625
      ],
      [
        -833.6382446289062,
        -2403.61669921875,
        651.4063110351562
      ],
      [
        -824.0,
        -2393.66357421875,
        646.86328125
      ],
      [
        -832.4124145507812,
        -2404.50830078125,
        647.2273559570312
      ],
      [
        -824.0,
        -2396.299072265625,
        642.4641723632812
      ],
      [
        -865.96435546875,
        -2497.705078125,
        641.6907958984375
      ],
      [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -877.9636840820312,
        -2920.0,
        788.0
      ],
      [
        -902.3636474609375,
        -2930.0,
        792.4444580078125
      ],
      [
        -906.0615234375,
        -2930.0,
        790.5328369140625
      ],
      [
        -904.2719116210938,
        -2930.0,
        792.4444580078125
      ],
      [
        -932.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -871.1350708007812,
        -2920.0,
        801.7215576171875
      ],
      [
        -887.615478515625,
        -2920.0,
        825.2523803710938
      ],
      [
        -902.0224609375,
        -2920.0,
        845.8228759765625
      ],
      [
        -887.615478515625,
        -2920.0,
        825.2523803710938
      ],
      [
        -914.6135864257812,
        -2920.0,
        863.8005981445312
      ],
      [
        -902.0224609375,
        -2920.0,
        845.8228759765625
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -871.22314453125,
        -2859.5,
        792.14794921875
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -869.8526611328125,
        -2859.5,
        790.1911010742188
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -886.1357421875,
        -2920.0,
        800.3511962890625
      ],
      [
        -889.6334228515625,
        -2920.0,
        788.0
      ],
      [
        -881.5404052734375,
        -2920.0,
        816.5783081054688
      ],
      [
        -886.1357421875,
        -2920.0,
        800.3511962890625
      ],
      [
        -871.61669921875,
        -2859.5,
        784.3419189453125
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -891.4382934570312,
        -2930.0,
        792.7470703125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -883.5030517578125,
        -2930.0,
        820.7681884765625
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -889.681884765625,
        -2920.0,
        788.0
      ],
      [
        -888.96728515625,
        -2920.0,
        790.3522338867188
      ],
      [
        -908.3773803710938,
        -2930.0,
        845.7208251953125
      ],
      [
        -886.190185546875,
        -2930.0,
        823.2562255859375
      ],
      [
        -883.9012451171875,
        -2920.0,
        819.9491577148438
      ],
      [
        -888.56396484375,
        -2920.0,
        824.670166015625
      ],
      [
        -904.548583984375,
        -2920.0,
        840.8545532226562
      ],
      [
        -888.56396484375,
        -2920.0,
        824.670166015625
      ],
      [
        -927.2113037109375,
        -2920.0,
        863.8005981445312
      ],
      [
        -904.548583984375,
        -2920.0,
        840.8545532226562
      ],
      [
        -883.5282592773438,
        -2930.0,
        820.9566040039062
      ],
      [
        -886.190185546875,
        -2930.0,
        823.2562255859375
      ],
      [
        -883.5282592773438,
        -2930.0,
        820.9566040039062
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -932.0,
        -2925.0,
        844.0625
      ],
      [
        -932.0,
        -2920.0,
        863.8005981445312
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -906.88134765625,
        -2920.0,
        843.2164916992188
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -932.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -904.9830932617188,
        -2920.0,
        840.0
      ],
      [
        -903.70458984375,
        -2920.0,
        840.0
      ],
      [
        -932.0,
        -2920.0,
        840.0
      ],
      [
        -904.9830932617188,
        -2920.0,
        840.0
      ],
      [
        -892.25634765625,
        -2863.125,
        822.7603149414062
      ],
      [
        -889.454833984375,
        -2863.125,
        818.7603149414062
      ],
      [
        -889.0310668945312,
        -2859.5,
        817.4066162109375
      ],
      [
        -891.8325805664062,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -932.0,
        -2930.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -901.729248046875,
        -2920.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -884.0911865234375,
        -2920.0,
        807.571044921875
      ],
      [
        -894.0,
        -2923.890625,
        789.7291870117188
      ],
      [
        -894.0,
        -2930.0,
        792.794677734375
      ],
      [
        -901.9560546875,
        -2930.0,
        792.9425659179688
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -940.6522827148438,
        -2920.0,
        843.216552734375
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -990.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -970.0,
        -2677.65380859375,
        680.2904663085938
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -1040.0,
        -2712.0,
        650.0
      ],
      [
        -1068.0,
        -2712.0,
        650.0
      ],
      [
        -1040.0,
        -2712.0,
        665.0
      ],
      [
        -1068.0,
        -2712.0,
        665.0
      ],
      [
        -1040.0,
        -2712.0,
        650.0
      ],
      [
        -1040.0,
        -2712.0,
        665.0
      ],
      [
        -1068.0,
        -2712.0,
        650.0
      ],
      [
        -1068.0,
        -2712.0,
        661.6666870117188
      ],
      [
        -1068.0,
        -2712.0,
        661.6666870117188
      ],
      [
        -1068.0,
        -2712.0,
        665.0
      ],
      [
        -1056.75,
        -2712.0,
        652.5
      ],
      [
        -1043.050048828125,
        -2712.0,
        652.5
      ],
      [
        -1056.75,
        -2712.0,
        652.0
      ],
      [
        -1043.050048828125,
        -2712.0,
        652.0
      ],
      [
        -1056.75,
        -2712.0,
        652.0
      ],
      [
        -1056.75,
        -2712.0,
        652.5
      ],
      [
        -1043.050048828125,
        -2712.0,
        652.5
      ],
      [
        -1043.050048828125,
        -2712.0,
        652.0
      ],
      [
        -1042.62548828125,
        -2712.0,
        655.607421875
      ],
      [
        -1046.4786376953125,
        -2712.0,
        656.2249755859375
      ],
      [
        -1046.4786376953125,
        -2712.0,
        656.2249755859375
      ],
      [
        -1046.478759765625,
        -2712.0,
        653.6484985351562
      ],
      [
        -1043.5660400390625,
        -2712.0,
        653.1817016601562
      ],
      [
        -1042.62548828125,
        -2712.0,
        655.607421875
      ],
      [
        -1045.7022705078125,
        -2709.35009765625,
        654.0
      ],
      [
        -1046.283935546875,
        -2709.35009765625,
        652.5
      ],
      [
        -1044.7860107421875,
        -2709.35009765625,
        653.88330078125
      ],
      [
        -1044.785888671875,
        -2709.35009765625,
        656.3633422851562
      ],
      [
        -1045.7498779296875,
        -2712.0,
        654.7000122070312
      ],
      [
        -1045.7498779296875,
        -2712.0,
        653.0999755859375
      ],
      [
        -1045.7498779296875,
        -2712.0,
        653.5316772460938
      ],
      [
        -1043.5660400390625,
        -2712.0,
        653.1817016601562
      ],
      [
        -1044.7860107421875,
        -2709.35009765625,
        653.88330078125
      ],
      [
        -1045.6912841796875,
        -2709.35009765625,
        654.0283813476562
      ],
      [
        -1045.7498779296875,
        -2709.399169921875,
        654.0283813476562
      ],
      [
        -1044.4500732421875,
        -2712.0,
        653.3234252929688
      ],
      [
        -1044.4500732421875,
        -2712.0,
        654.7000122070312
      ],
      [
        -1044.4500732421875,
        -2710.75,
        653.5621337890625
      ],
      [
        -1044.4500732421875,
        -2710.75,
        653.5621337890625
      ],
      [
        -1045.7498779296875,
        -2710.75,
        653.7703857421875
      ],
      [
        -1045.7498779296875,
        -2709.75,
        652.5
      ],
      [
        -1044.450439453125,
        -2709.75,
        652.5
      ],
      [
        -1043.9940185546875,
        -2710.2939453125,
        652.8263549804688
      ],
      [
        -1044.4500732421875,
        -2712.0,
        653.0999755859375
      ],
      [
        -1043.9940185546875,
        -2710.2939453125,
        652.8263549804688
      ],
      [
        -1043.4500732421875,
        -2710.9423828125,
        652.5
      ],
      [
        -1043.4500732421875,
        -2711.6806640625,
        652.5
      ],
      [
        -1043.7587890625,
        -2712.0,
        652.6851806640625
      ],
      [
        -1044.4500732421875,
        -2712.0,
        653.0999755859375
      ],
      [
        -1044.4500732421875,
        -2711.334228515625,
        653.4505615234375
      ],
      [
        -1046.478759765625,
        -2712.0,
        653.6484985351562
      ],
      [
        -1045.7498779296875,
        -2712.0,
        653.0999755859375
      ],
      [
        -1046.4786376953125,
        -2712.0,
        652.6627807617188
      ],
      [
        -1046.7498779296875,
        -2711.6767578125,
        652.5
      ],
      [
        -1043.4500732421875,
        -2712.0,
        652.5
      ],
      [
        -1046.7498779296875,
        -2712.0,
        652.5
      ],
      [
        -972.8922729492188,
        -2710.0,
        748.4310302734375
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -971.9118041992188,
        -2712.0,
        752.3527221679688
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -865.0618896484375,
        -2712.0,
        695.5555419921875
      ],
      [
        -968.076904296875,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        670.0
      ],
      [
        -894.0,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -870.0,
        -2712.0,
        720.0
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -856.3112182617188,
        -2697.0,
        720.0
      ],
      [
        -864.9321899414062,
        -2682.35205078125,
        694.219482421875
      ],
      [
        -856.40234375,
        -2695.500244140625,
        720.0
      ],
      [
        -864.9321899414062,
        -2682.35205078125,
        694.219482421875
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -872.3709716796875,
        -2712.0,
        752.3528442382812
      ],
      [
        -872.3709716796875,
        -2712.0,
        720.0
      ],
      [
        -868.5,
        -2700.0,
        728.8235473632812
      ],
      [
        -865.2177734375,
        -2712.0,
        752.3527221679688
      ],
      [
        -853.125,
        -2712.0,
        735.8872680664062
      ],
      [
        -853.125,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -868.5,
        -2700.0,
        728.8235473632812
      ],
      [
        -855.4293823242188,
        -2697.0,
        722.940673828125
      ],
      [
        -856.3504028320312,
        -2696.355224609375,
        720.0
      ],
      [
        -855.9296264648438,
        -2696.22900390625,
        721.4287109375
      ],
      [
        -858.5,
        -2650.0,
        668.0
      ],
      [
        -932.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -862.1634521484375,
        -2650.0,
        710.0059814453125
      ],
      [
        -888.2786865234375,
        -2650.0,
        761.384521484375
      ],
      [
        -863.10595703125,
        -2640.0,
        705.4423828125
      ],
      [
        -863.4918212890625,
        -2640.0,
        704.4489135742188
      ],
      [
        -932.0,
        -2645.0,
        667.578125
      ],
      [
        -932.0,
        -2640.0,
        666.6993408203125
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -932.0,
        -2650.0,
        668.0
      ],
      [
        -932.0,
        -2647.400634765625,
        668.0
      ],
      [
        -878.0274047851562,
        -2640.0,
        666.6993408203125
      ],
      [
        -875.80322265625,
        -2650.0,
        668.0
      ],
      [
        -876.2950439453125,
        -2645.0,
        667.578125
      ],
      [
        -875.9871215820312,
        -2647.400390625,
        668.0
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -894.743408203125,
        -2650.0,
        668.4568481445312
      ],
      [
        -875.6536865234375,
        -2650.0,
        668.4568481445312
      ],
      [
        -863.366943359375,
        -2650.0,
        705.992919921875
      ],
      [
        -862.1634521484375,
        -2650.0,
        710.0059814453125
      ],
      [
        -863.366943359375,
        -2650.0,
        705.992919921875
      ],
      [
        -932.0,
        -2640.0,
        748.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -898.6423950195312,
        -2650.0,
        775.49560546875
      ],
      [
        -932.0,
        -2640.0,
        771.9608154296875
      ],
      [
        -932.0,
        -2650.0,
        775.49560546875
      ],
      [
        -915.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -927.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -888.2786865234375,
        -2650.0,
        761.384521484375
      ],
      [
        -898.6423950195312,
        -2650.0,
        775.49560546875
      ],
      [
        -932.0,
        -2640.0,
        668.0
      ],
      [
        -860.2403564453125,
        -2660.0,
        714.3930053710938
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      [
        -873.6409912109375,
        -2660.0,
        672.4444580078125
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        750.0
      ],
      [
        -860.2403564453125,
        -2660.0,
        714.3930053710938
      ],
      [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      [
        -853.5,
        -2695.5,
        730.5896606445312
      ],
      [
        -868.5,
        -2700.0,
        752.6513061523438
      ],
      [
        -872.3709716796875,
        -2712.0,
        792.0
      ],
      [
        -872.3709716796875,
        -2712.0,
        762.2891845703125
      ],
      [
        -868.5,
        -2700.0,
        752.6513061523438
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -858.5,
        -2697.0,
        737.9435424804688
      ],
      [
        -868.5,
        -2700.0,
        752.6119384765625
      ],
      [
        -872.3709716796875,
        -2712.0,
        762.09228515625
      ],
      [
        -868.5,
        -2700.0,
        752.6119384765625
      ],
      [
        -853.5,
        -2695.5,
        730.1375122070312
      ],
      [
        -854.1096801757812,
        -2695.682861328125,
        731.486328125
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -853.5,
        -2695.5,
        729.67822265625
      ],
      [
        -855.9295654296875,
        -2696.228759765625,
        721.4291381835938
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2668.288818359375,
        750.0
      ],
      [
        -914.0,
        -2668.288818359375,
        750.0
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.4685668945312
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.468505859375
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -952.901611328125,
        -2647.400634765625,
        668.0
      ],
      [
        -932.0,
        -2647.400634765625,
        668.0
      ],
      [
        -953.0830078125,
        -2650.0,
        775.49560546875
      ],
      [
        -932.0,
        -2650.0,
        775.49560546875
      ],
      [
        -940.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.468505859375
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -873.5,
        -2712.0,
        695.5555419921875
      ],
      [
        -863.1127319335938,
        -2762.5,
        718.0
      ],
      [
        -873.5,
        -2762.5,
        718.0
      ],
      [
        -871.5,
        -2830.819580078125,
        748.3642578125
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -871.5,
        -2762.5,
        718.0
      ],
      [
        -871.5,
        -2781.199951171875,
        720.0
      ],
      [
        -873.5,
        -2775.0,
        723.555419921875
      ],
      [
        -871.5,
        -2781.199951171875,
        726.3109741210938
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -871.5,
        -2859.5,
        792.4702758789062
      ],
      [
        -871.5,
        -2788.75,
        784.2052612304688
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -873.5,
        -2775.0,
        784.9275512695312
      ],
      [
        -871.5,
        -2781.199951171875,
        792.0
      ],
      [
        -871.5,
        -2781.199951171875,
        783.3233032226562
      ],
      [
        -873.5,
        -2859.5,
        795.2313232421875
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -871.5,
        -2751.4150390625,
        774.7340087890625
      ],
      [
        -871.5,
        -2712.0,
        760.906494140625
      ],
      [
        -872.3709106445312,
        -2712.0,
        762.0923461914062
      ],
      [
        -873.5,
        -2715.5,
        764.8575439453125
      ],
      [
        -871.5,
        -2781.199951171875,
        782.2899780273438
      ],
      [
        -871.5,
        -2751.4150390625,
        774.7340087890625
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -873.5,
        -2775.000244140625,
        783.045654296875
      ],
      [
        -873.5,
        -2735.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        721.0
      ],
      [
        -871.5,
        -2713.5,
        720.0
      ],
      [
        -872.3709106445312,
        -2712.0,
        720.0
      ],
      [
        -871.5,
        -2712.0,
        720.0
      ],
      [
        -873.5,
        -2754.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        735.0
      ],
      [
        -871.5,
        -2859.5,
        784.7289428710938
      ],
      [
        -873.5,
        -2859.5,
        778.097412109375
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -871.5,
        -2830.819580078125,
        748.3642578125
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -871.5,
        -2788.75,
        784.2052612304688
      ],
      [
        -873.5,
        -2712.0,
        763.6296997070312
      ],
      [
        -873.5,
        -2712.0,
        720.0
      ],
      [
        -830.288330078125,
        -2753.0,
        721.0
      ],
      [
        -824.0,
        -2751.18994140625,
        721.0
      ],
      [
        -853.0,
        -2742.0,
        731.0
      ],
      [
        -853.0,
        -2748.0,
        731.0
      ],
      [
        -868.5,
        -2790.5,
        780.9170532226562
      ],
      [
        -853.5,
        -2795.0,
        763.9791870117188
      ],
      [
        -868.5,
        -2790.5,
        780.9170532226562
      ],
      [
        -871.5,
        -2781.199951171875,
        783.3233032226562
      ],
      [
        -854.5233764648438,
        -2794.69287109375,
        765.134765625
      ],
      [
        -864.6350708007812,
        -2791.659423828125,
        720.0
      ],
      [
        -855.143798828125,
        -2794.5068359375,
        762.859619140625
      ],
      [
        -862.2526245117188,
        -2784.784912109375,
        727.9044799804688
      ],
      [
        -871.5,
        -2826.99072265625,
        746.6624755859375
      ],
      [
        -866.8314208984375,
        -2791.00048828125,
        720.0
      ],
      [
        -863.8129272460938,
        -2791.906005859375,
        731.0692138671875
      ],
      [
        -862.1342163085938,
        -2792.40966796875,
        731.2930297851562
      ],
      [
        -869.0645141601562,
        -2788.75,
        781.3698120117188
      ],
      [
        -871.5,
        -2781.199951171875,
        782.2899780273438
      ],
      [
        -863.8129272460938,
        -2791.90625,
        731.0694580078125
      ],
      [
        -868.4998779296875,
        -2790.500244140625,
        730.444580078125
      ],
      [
        -871.5,
        -2781.199951171875,
        726.3110961914062
      ],
      [
        -865.5252685546875,
        -2799.7216796875,
        734.54296875
      ],
      [
        -970.0,
        -2844.0,
        844.0
      ],
      [
        -970.0,
        -2852.0,
        844.0
      ],
      [
        -970.0,
        -2852.0,
        839.0
      ],
      [
        -970.0,
        -2844.0,
        839.0
      ],
      [
        -970.0,
        -2844.0,
        839.0
      ],
      [
        -970.0,
        -2844.0,
        844.0
      ],
      [
        -970.0,
        -2852.0,
        844.0
      ],
      [
        -970.0,
        -2852.0,
        839.0
      ],
      [
        -991.579345703125,
        -2822.0,
        844.0
      ],
      [
        -991.579345703125,
        -2830.0,
        844.0
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -990.0,
        -2774.0,
        723.111083984375
      ],
      [
        -970.0,
        -2774.0,
        723.111083984375
      ],
      [
        -1045.0,
        -2774.0,
        723.1111450195312
      ],
      [
        -1045.0,
        -2800.0,
        734.6666870117188
      ],
      [
        -1045.0,
        -2800.0,
        734.6666870117188
      ],
      [
        -1070.0,
        -2800.0,
        734.666748046875
      ],
      [
        -1052.5,
        -2797.374755859375,
        733.5
      ],
      [
        -1047.0,
        -2797.374755859375,
        733.5
      ],
      [
        -1052.5,
        -2800.0,
        734.6666870117188
      ],
      [
        -1052.5,
        -2797.374755859375,
        733.5
      ],
      [
        -1047.0,
        -2797.374755859375,
        733.5
      ],
      [
        -1047.0,
        -2800.0,
        734.6666870117188
      ],
      [
        -1066.5,
        -2798.499755859375,
        734.0
      ],
      [
        -1064.0,
        -2798.499755859375,
        734.0
      ],
      [
        -1064.0,
        -2800.0,
        734.666748046875
      ],
      [
        -1064.0,
        -2798.499755859375,
        734.0
      ],
      [
        -1066.5,
        -2798.499755859375,
        734.0
      ],
      [
        -1066.5,
        -2800.0,
        734.666748046875
      ],
      [
        -1053.0,
        -2775.5,
        722.5
      ],
      [
        -1053.0,
        -2775.5,
        723.0
      ],
      [
        -1053.0,
        -2776.5,
        723.0
      ],
      [
        -1053.0,
        -2776.5,
        722.5
      ],
      [
        -1053.0,
        -2775.5,
        723.0
      ],
      [
        -1053.0,
        -2775.5,
        722.5
      ],
      [
        -1052.0,
        -2775.5,
        722.5
      ],
      [
        -1052.0,
        -2775.5,
        723.0
      ],
      [
        -1052.0,
        -2776.5,
        722.5
      ],
      [
        -1052.0,
        -2776.5,
        723.0
      ],
      [
        -1052.0,
        -2775.5,
        723.0
      ],
      [
        -1052.0,
        -2775.5,
        722.5
      ],
      [
        -1053.0,
        -2776.5,
        722.5
      ],
      [
        -1053.0,
        -2776.5,
        723.0
      ],
      [
        -1052.0,
        -2776.5,
        723.0
      ],
      [
        -1052.0,
        -2776.5,
        722.5
      ],
      [
        -1066.1177978515625,
        -2778.0,
        724.8889770507812
      ],
      [
        -1065.010986328125,
        -2777.188720703125,
        724.5283813476562
      ],
      [
        -1065.9779052734375,
        -2778.0,
        724.5283813476562
      ],
      [
        -1069.0,
        -2776.5,
        724.2223510742188
      ],
      [
        -1069.0,
        -2775.5,
        723.7779541015625
      ],
      [
        -1070.0,
        -2776.5,
        724.2223510742188
      ],
      [
        -1069.0,
        -2776.5,
        724.2223510742188
      ],
      [
        -1070.0,
        -2775.5,
        723.7779541015625
      ],
      [
        -1069.0,
        -2775.5,
        723.7779541015625
      ],
      [
        -1068.0238037109375,
        -2775.283447265625,
        723.6817016601562
      ],
      [
        -1066.679931640625,
        -2778.0,
        724.4158935546875
      ],
      [
        -1065.9779052734375,
        -2778.0,
        724.5283813476562
      ],
      [
        -1065.010986328125,
        -2777.188720703125,
        724.5283813476562
      ],
      [
        -1066.679931640625,
        -2778.0,
        724.4158935546875
      ],
      [
        -1068.60302734375,
        -2775.7080078125,
        723.8704223632812
      ],
      [
        -1066.679931640625,
        -2778.0,
        724.8889770507812
      ],
      [
        -1067.0999755859375,
        -2775.86767578125,
        723.9412841796875
      ],
      [
        -1067.0999755859375,
        -2776.5,
        724.222412109375
      ],
      [
        -1067.0999755859375,
        -2776.5,
        724.0620727539062
      ],
      [
        -1067.0999755859375,
        -2776.5,
        724.0620727539062
      ],
      [
        -1067.0999755859375,
        -2776.5,
        724.222412109375
      ],
      [
        -1066.0994873046875,
        -2776.5,
        724.222412109375
      ],
      [
        -1068.0238037109375,
        -2775.283447265625,
        723.6817016601562
      ],
      [
        -1068.60302734375,
        -2775.7080078125,
        723.8704223632812
      ],
      [
        -1066.449951171875,
        -2776.5,
        723.9899291992188
      ],
      [
        -1067.0999755859375,
        -2775.486328125,
        723.7718505859375
      ],
      [
        -1066.681884765625,
        -2776.5,
        724.1290893554688
      ],
      [
        -1067.0999755859375,
        -2775.199951171875,
        723.64453125
      ],
      [
        -1065.874267578125,
        -2775.199951171875,
        723.64453125
      ],
      [
        -1067.0999755859375,
        -2775.199951171875,
        723.64453125
      ],
      [
        -1065.800048828125,
        -2776.5,
        724.222412109375
      ],
      [
        -1065.800048828125,
        -2775.199951171875,
        723.64453125
      ],
      [
        -1065.800048828125,
        -2776.5,
        724.222412109375
      ],
      [
        -1065.800048828125,
        -2775.199951171875,
        723.64453125
      ],
      [
        -1053.0,
        -2776.5,
        724.2222900390625
      ],
      [
        -1052.0,
        -2776.5,
        724.2222900390625
      ],
      [
        -1052.0,
        -2776.5,
        724.2222900390625
      ],
      [
        -1052.0,
        -2775.5,
        723.7778930664062
      ],
      [
        -1053.0,
        -2775.5,
        723.7778930664062
      ],
      [
        -1053.0,
        -2776.5,
        724.2222900390625
      ],
      [
        -1053.0,
        -2775.5,
        723.7778930664062
      ],
      [
        -1052.0,
        -2775.5,
        723.7778930664062
      ],
      [
        -1066.4658203125,
        -2778.255126953125,
        725.0023803710938
      ],
      [
        -1066.4658203125,
        -2778.255126953125,
        725.0023803710938
      ],
      [
        -1054.469970703125,
        -2775.5,
        734.4000244140625
      ],
      [
        -1055.6400146484375,
        -2775.5,
        734.4000244140625
      ],
      [
        -1055.6400146484375,
        -2776.5,
        734.4000244140625
      ],
      [
        -1054.469970703125,
        -2776.5,
        734.4000244140625
      ],
      [
        -1055.6400146484375,
        -2775.5,
        734.4000244140625
      ],
      [
        -1055.6400146484375,
        -2776.5,
        734.4000244140625
      ],
      [
        -1054.469970703125,
        -2776.5,
        734.4000244140625
      ],
      [
        -1054.469970703125,
        -2775.5,
        734.4000244140625
      ],
      [
        -1054.4000244140625,
        -2775.5,
        733.2727661132812
      ],
      [
        -1054.4000244140625,
        -2776.5,
        733.2727661132812
      ],
      [
        -1054.4000244140625,
        -2775.5,
        734.3333740234375
      ],
      [
        -1054.4000244140625,
        -2775.5,
        733.2727661132812
      ],
      [
        -1054.4000244140625,
        -2776.5,
        733.2727661132812
      ],
      [
        -1054.4000244140625,
        -2776.5,
        734.3333740234375
      ],
      [
        -1054.4000244140625,
        -2776.5,
        734.3333740234375
      ],
      [
        -1054.4000244140625,
        -2775.5,
        734.3333740234375
      ],
      [
        -1062.5,
        -2795.0,
        734.0
      ],
      [
        -1062.5,
        -2795.0,
        734.0
      ],
      [
        -1062.5,
        -2795.0,
        735.0
      ],
      [
        -1067.43505859375,
        -2774.0,
        726.107421875
      ],
      [
        -1066.1201171875,
        -2774.0,
        726.3181762695312
      ],
      [
        -1066.1201171875,
        -2774.0,
        726.3181762695312
      ],
      [
        -1066.1202392578125,
        -2774.0,
        723.7416381835938
      ],
      [
        -1066.4940185546875,
        -2774.0,
        723.6817016601562
      ],
      [
        -1067.43505859375,
        -2774.0,
        726.107421875
      ],
      [
        -1065.800048828125,
        -2775.199951171875,
        724.0221557617188
      ],
      [
        -1067.0999755859375,
        -2775.199951171875,
        723.8138427734375
      ],
      [
        -1067.0999755859375,
        -2775.86767578125,
        723.9413452148438
      ],
      [
        -1065.800048828125,
        -2776.689697265625,
        724.306640625
      ],
      [
        -1065.800048828125,
        -2776.5,
        724.2703857421875
      ],
      [
        -1066.0994873046875,
        -2776.5,
        724.222412109375
      ],
      [
        -1067.92431640625,
        -2775.199951171875,
        723.6817016601562
      ],
      [
        -1065.11328125,
        -2775.199951171875,
        724.1322021484375
      ],
      [
        -1066.1202392578125,
        -2774.0,
        723.7416381835938
      ],
      [
        -1066.4940185546875,
        -2774.0,
        723.6817016601562
      ],
      [
        -990.0,
        -2767.0,
        720.0
      ],
      [
        -970.0,
        -2767.0,
        720.0
      ],
      [
        -1068.0,
        -2722.5,
        760.0
      ],
      [
        -1060.0,
        -2722.5,
        760.0
      ],
      [
        -1060.0,
        -2720.5,
        758.0
      ],
      [
        -1068.0,
        -2720.5,
        758.0
      ],
      [
        -1060.0,
        -2763.5,
        760.0
      ],
      [
        -1068.0,
        -2763.5,
        760.0
      ],
      [
        -1068.0,
        -2765.5,
        758.0
      ],
      [
        -1060.0,
        -2765.5,
        758.0
      ],
      [
        -1070.0,
        -2720.5,
        758.0
      ],
      [
        -1070.0,
        -2765.5,
        758.0
      ],
      [
        -1068.0,
        -2757.5,
        720.0
      ],
      [
        -1067.0,
        -2756.0,
        720.0
      ],
      [
        -1068.0,
        -2728.5,
        720.0
      ],
      [
        -1067.0,
        -2730.0,
        720.0
      ],
      [
        -1067.0,
        -2733.5,
        720.0
      ],
      [
        -1067.0,
        -2730.0,
        720.0
      ],
      [
        -1067.0,
        -2756.0,
        720.0
      ],
      [
        -1067.0,
        -2752.5,
        720.0
      ],
      [
        -1068.0,
        -2735.0,
        720.0
      ],
      [
        -1067.0,
        -2733.5,
        720.0
      ],
      [
        -1068.0,
        -2735.0,
        720.0
      ],
      [
        -1068.0,
        -2728.5,
        720.0
      ],
      [
        -1069.0001220703125,
        -2736.5,
        731.3333129882812
      ],
      [
        -1069.0001220703125,
        -2736.5,
        727.6666870117188
      ],
      [
        -1069.0001220703125,
        -2736.5,
        727.6666870117188
      ],
      [
        -1070.0,
        -2738.0,
        728.0
      ],
      [
        -1070.0,
        -2738.0,
        731.0
      ],
      [
        -1069.0001220703125,
        -2736.5,
        731.3333129882812
      ],
      [
        -1068.0,
        -2751.0,
        720.0
      ],
      [
        -1067.0,
        -2752.5,
        720.0
      ],
      [
        -1068.0,
        -2757.5,
        720.0
      ],
      [
        -1068.0,
        -2751.0,
        720.0
      ],
      [
        -1069.0,
        -2749.5,
        727.6666870117188
      ],
      [
        -1069.0,
        -2749.5,
        731.3333129882812
      ],
      [
        -1069.0,
        -2749.5,
        731.3333129882812
      ],
      [
        -1070.0,
        -2748.0,
        731.0
      ],
      [
        -1070.0,
        -2748.0,
        728.0
      ],
      [
        -1069.0,
        -2749.5,
        727.6666870117188
      ],
      [
        -1060.0,
        -2712.0,
        754.5
      ],
      [
        -1060.0,
        -2717.0,
        754.5
      ],
      [
        -1060.0,
        -2717.0,
        754.5
      ],
      [
        -1060.0,
        -2769.0,
        754.5
      ],
      [
        -1060.0,
        -2774.0,
        754.5
      ],
      [
        -1060.0,
        -2769.0,
        754.5
      ],
      [
        -1020.0,
        -2771.5,
        756.5
      ],
      [
        -1020.0,
        -2769.5,
        756.5
      ],
      [
        -1020.0,
        -2769.5,
        760.0
      ],
      [
        -1020.0,
        -2771.5,
        760.0
      ],
      [
        -1008.0,
        -2771.5,
        760.0
      ],
      [
        -1008.0,
        -2769.5,
        760.0
      ],
      [
        -1008.0,
        -2769.5,
        756.5
      ],
      [
        -1008.0,
        -2771.5,
        756.5
      ],
      [
        -1058.0,
        -2771.5,
        760.0
      ],
      [
        -1058.0,
        -2769.5,
        760.0
      ],
      [
        -1058.0,
        -2769.5,
        756.5
      ],
      [
        -1058.0,
        -2771.5,
        756.5
      ],
      [
        -1020.0,
        -2774.0,
        756.5
      ],
      [
        -1008.0,
        -2774.0,
        756.5
      ],
      [
        -1058.0,
        -2774.0,
        756.5
      ],
      [
        -1018.5,
        -2770.5,
        754.5
      ],
      [
        -1018.5,
        -2774.0,
        754.5
      ],
      [
        -1009.5,
        -2774.0,
        754.5
      ],
      [
        -1009.5,
        -2770.5,
        754.5
      ],
      [
        -1009.5,
        -2774.0,
        725.5
      ],
      [
        -1018.5,
        -2774.0,
        725.5
      ],
      [
        -1018.5,
        -2770.5,
        725.5
      ],
      [
        -1009.5,
        -2770.5,
        725.5
      ],
      [
        -1009.5,
        -2769.5,
        754.5
      ],
      [
        -1018.5,
        -2769.5,
        754.5
      ],
      [
        -1018.5,
        -2769.5,
        725.5
      ],
      [
        -1009.5,
        -2769.5,
        725.5
      ],
      [
        -1008.0,
        -2769.5,
        725.5
      ],
      [
        -1008.0,
        -2769.5,
        720.0
      ],
      [
        -1008.0,
        -2769.5,
        754.5
      ],
      [
        -1008.0,
        -2769.5,
        754.5
      ],
      [
        -1008.0,
        -2769.5,
        725.5
      ],
      [
        -1058.0,
        -2769.5,
        754.5
      ],
      [
        -1060.0,
        -2769.5,
        754.5
      ],
      [
        -1058.0,
        -2769.5,
        754.5
      ],
      [
        -1020.0,
        -2769.5,
        754.5
      ],
      [
        -1020.0,
        -2769.5,
        720.0
      ],
      [
        -1020.0,
        -2769.5,
        725.5
      ],
      [
        -1020.0,
        -2769.5,
        754.5
      ],
      [
        -1020.0,
        -2769.5,
        725.5
      ],
      [
        -1058.0,
        -2712.0,
        758.0
      ],
      [
        -1058.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2765.5,
        758.0
      ],
      [
        -1058.0,
        -2769.5,
        758.0
      ],
      [
        -1060.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2765.5,
        758.0
      ],
      [
        -1060.0,
        -2765.5,
        758.0
      ],
      [
        -1034.5,
        -2714.5,
        736.0
      ],
      [
        -1034.5,
        -2714.5,
        720.0
      ],
      [
        -1034.5,
        -2714.5,
        758.0
      ],
      [
        -1034.5,
        -2714.5,
        756.5
      ],
      [
        -1034.5,
        -2716.5,
        756.5
      ],
      [
        -1034.5,
        -2716.5,
        758.0
      ],
      [
        -1034.5,
        -2714.5,
        756.5
      ],
      [
        -1034.5,
        -2716.5,
        756.5
      ],
      [
        -1058.0,
        -2716.5,
        756.5
      ],
      [
        -1058.0,
        -2716.5,
        758.0
      ],
      [
        -1058.0,
        -2714.5,
        758.0
      ],
      [
        -1058.0,
        -2714.5,
        756.5
      ],
      [
        -1060.0,
        -2714.5,
        754.5
      ],
      [
        -1060.0,
        -2716.5,
        754.5
      ],
      [
        -1058.0,
        -2716.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2716.5,
        754.5
      ],
      [
        -1034.5,
        -2712.0,
        740.0
      ],
      [
        -1034.5,
        -2714.5,
        736.0
      ],
      [
        -1018.0,
        -2722.5,
        760.0
      ],
      [
        -1010.0,
        -2722.5,
        760.0
      ],
      [
        -1010.0,
        -2720.5,
        758.0
      ],
      [
        -1018.0,
        -2720.5,
        758.0
      ],
      [
        -1010.0,
        -2763.5,
        760.0
      ],
      [
        -1018.0,
        -2763.5,
        760.0
      ],
      [
        -1018.0,
        -2765.5,
        758.0
      ],
      [
        -1010.0,
        -2765.5,
        758.0
      ],
      [
        -1008.0,
        -2712.0,
        758.0
      ],
      [
        -1008.0,
        -2720.5,
        758.0
      ],
      [
        -1008.0,
        -2765.5,
        758.0
      ],
      [
        -1008.0,
        -2769.5,
        758.0
      ],
      [
        -1008.0,
        -2720.5,
        758.0
      ],
      [
        -1008.0,
        -2765.5,
        758.0
      ],
      [
        -1020.0,
        -2720.5,
        758.0
      ],
      [
        -1020.0,
        -2712.0,
        758.0
      ],
      [
        -1020.0,
        -2765.5,
        758.0
      ],
      [
        -1020.0,
        -2769.5,
        758.0
      ],
      [
        -1020.0,
        -2720.5,
        758.0
      ],
      [
        -1020.0,
        -2765.5,
        758.0
      ],
      [
        -1009.5,
        -2712.0,
        754.5
      ],
      [
        -1018.5,
        -2712.0,
        754.5
      ],
      [
        -1018.5,
        -2715.5,
        754.5
      ],
      [
        -1009.5,
        -2715.5,
        754.5
      ],
      [
        -1009.5,
        -2715.5,
        725.5
      ],
      [
        -1018.5,
        -2715.5,
        725.5
      ],
      [
        -1018.5,
        -2712.0,
        725.5
      ],
      [
        -1009.5,
        -2712.0,
        725.5
      ],
      [
        -1008.0,
        -2715.5,
        720.0
      ],
      [
        -1008.0,
        -2715.5,
        725.5
      ],
      [
        -1008.0,
        -2715.5,
        754.5
      ],
      [
        -1008.0,
        -2715.5,
        758.0
      ],
      [
        -1008.0,
        -2715.5,
        754.5
      ],
      [
        -1008.0,
        -2715.5,
        725.5
      ],
      [
        -1020.0,
        -2715.5,
        754.5
      ],
      [
        -1020.0,
        -2715.5,
        758.0
      ],
      [
        -1020.0,
        -2715.5,
        725.5
      ],
      [
        -1020.0,
        -2715.5,
        720.0
      ],
      [
        -1034.5,
        -2715.5,
        756.5
      ],
      [
        -1020.0,
        -2715.5,
        756.5
      ],
      [
        -1020.0,
        -2715.5,
        754.5
      ],
      [
        -1020.0,
        -2715.5,
        725.5
      ],
      [
        -1020.0,
        -2715.5,
        756.5
      ],
      [
        -1020.0,
        -2716.5,
        758.0
      ],
      [
        -1020.0,
        -2716.5,
        756.5
      ],
      [
        -1008.0,
        -2716.5,
        756.5
      ],
      [
        -1008.0,
        -2716.5,
        758.0
      ],
      [
        -1008.0,
        -2715.5,
        756.5
      ],
      [
        -1020.0,
        -2716.5,
        754.5
      ],
      [
        -1008.0,
        -2716.5,
        754.5
      ],
      [
        -1042.5,
        -2757.5,
        680.0
      ],
      [
        -1042.5,
        -2728.5,
        680.0
      ],
      [
        -1042.5,
        -2728.5,
        720.0
      ],
      [
        -1042.5,
        -2757.5,
        720.0
      ],
      [
        -1042.5,
        -2757.500244140625,
        650.0
      ],
      [
        -1043.5,
        -2756.000244140625,
        650.0
      ],
      [
        -1043.5,
        -2752.5,
        650.0
      ],
      [
        -1042.5,
        -2751.0,
        650.0
      ],
      [
        -1043.5,
        -2733.5,
        650.0
      ],
      [
        -1043.5,
        -2730.0,
        650.0
      ],
      [
        -1042.5,
        -2728.5,
        650.0
      ],
      [
        -1042.5,
        -2735.0,
        650.0
      ],
      [
        -1052.166748046875,
        -2743.000244140625,
        650.0
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -1040.0,
        -2761.250244140625,
        650.0
      ],
      [
        -1040.0,
        -2724.75,
        650.0
      ],
      [
        -1040.0,
        -2724.75,
        680.0
      ],
      [
        -1040.0,
        -2761.250244140625,
        680.0
      ],
      [
        -1040.0,
        -2724.75,
        650.0
      ],
      [
        -1040.0,
        -2761.250244140625,
        650.0
      ],
      [
        -1040.0,
        -2761.250244140625,
        680.0
      ],
      [
        -1040.0,
        -2724.75,
        680.0
      ],
      [
        -1042.5,
        -2728.5,
        680.0
      ],
      [
        -1042.5,
        -2757.5,
        680.0
      ],
      [
        -1044.1231689453125,
        -2712.376953125,
        652.9038696289062
      ],
      [
        -1045.08203125,
        -2713.050048828125,
        652.5
      ],
      [
        -1045.59765625,
        -2713.050048828125,
        652.5
      ],
      [
        -1046.1231689453125,
        -2712.42333984375,
        652.8759765625
      ],
      [
        -1046.1231689453125,
        -2712.42333984375,
        652.8759765625
      ],
      [
        -1046.4786376953125,
        -2712.0,
        652.6627807617188
      ],
      [
        -1043.7587890625,
        -2712.0,
        652.6851806640625
      ],
      [
        -1044.1231689453125,
        -2712.376953125,
        652.9038696289062
      ],
      [
        -1044.4500732421875,
        -2712.0,
        653.1300048828125
      ],
      [
        -1045.7498779296875,
        -2712.0,
        653.1300048828125
      ],
      [
        -1045.7498779296875,
        -2712.050048828125,
        653.5220947265625
      ],
      [
        -1043.625732421875,
        -2712.050048828125,
        653.1817016601562
      ],
      [
        -1045.7498779296875,
        -2712.0,
        653.5316772460938
      ],
      [
        -1044.4500732421875,
        -2712.050048828125,
        653.3138427734375
      ],
      [
        -1044.4500732421875,
        -2712.0,
        653.3233642578125
      ],
      [
        -1046.436767578125,
        -2712.050048828125,
        653.6322021484375
      ],
      [
        -1040.0,
        -2722.0,
        650.0
      ],
      [
        -1040.0,
        -2722.0,
        680.0
      ],
      [
        -1040.0,
        -2722.0,
        650.0
      ],
      [
        -1066.1669921875,
        -2722.0,
        650.0
      ],
      [
        -1070.0,
        -2716.25048828125,
        650.0
      ],
      [
        -1069.928466796875,
        -2716.357666015625,
        680.0
      ],
      [
        -1066.166748046875,
        -2722.0,
        680.0
      ],
      [
        -1041.5,
        -2722.0,
        680.0
      ],
      [
        -1070.0,
        -2716.25048828125,
        680.0
      ],
      [
        -1069.928466796875,
        -2716.357666015625,
        680.0
      ],
      [
        -1040.0,
        -2722.0,
        680.0
      ],
      [
        -1041.5,
        -2722.0,
        680.0
      ],
      [
        -1065.300048828125,
        -2723.300048828125,
        720.0
      ],
      [
        -1065.300048828125,
        -2723.300048828125,
        680.0
      ],
      [
        -1065.3001708984375,
        -2723.30029296875,
        650.0
      ],
      [
        -1063.9998779296875,
        -2722.0,
        650.0
      ],
      [
        -1065.300048828125,
        -2723.300048828125,
        680.0
      ],
      [
        -1041.5,
        -2727.0,
        650.0
      ],
      [
        -1046.500244140625,
        -2722.0,
        650.0
      ],
      [
        -1041.5,
        -2727.0,
        680.0
      ],
      [
        -1042.5,
        -2728.5,
        650.0
      ],
      [
        -1042.5,
        -2726.0,
        650.0
      ],
      [
        -1068.0,
        -2719.250244140625,
        680.0
      ],
      [
        -1068.0,
        -2768.0,
        680.0
      ],
      [
        -1068.0,
        -2770.0,
        680.0
      ],
      [
        -1068.0,
        -2768.0,
        680.0
      ],
      [
        -1068.0,
        -2770.0,
        680.0
      ],
      [
        -1068.0,
        -2770.0,
        650.0
      ],
      [
        -1040.0,
        -2764.0,
        650.0
      ],
      [
        -1040.0,
        -2764.0,
        680.0
      ],
      [
        -1068.0,
        -2764.0,
        680.0
      ],
      [
        -1041.5,
        -2764.0,
        680.0
      ],
      [
        -1040.0,
        -2764.0,
        680.0
      ],
      [
        -1041.5,
        -2764.0,
        680.0
      ],
      [
        -1041.5,
        -2759.0,
        680.0
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -880.5184326171875,
        -2766.999755859375,
        720.0
      ],
      [
        -887.5,
        -2766.999755859375,
        720.0
      ],
      [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -894.0,
        -2712.0,
        790.9302978515625
      ],
      [
        -894.0,
        -2859.5,
        824.5013427734375
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -884.5225219726562,
        -2724.955322265625,
        783.182861328125
      ],
      [
        -873.5,
        -2719.897216796875,
        766.4002075195312
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2712.0,
        720.0
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2762.8076171875,
        720.0
      ],
      [
        -878.5,
        -2722.191650390625,
        774.0131225585938
      ],
      [
        -878.5,
        -2712.0,
        770.4376831054688
      ],
      [
        -878.5,
        -2754.5,
        720.0
      ],
      [
        -878.5,
        -2735.5,
        720.0
      ],
      [
        -932.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -914.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -928.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -918.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -927.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -932.0,
        -2852.0,
        839.0
      ],
      [
        -932.0,
        -2844.0,
        839.0
      ],
      [
        -928.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -928.0,
        -2853.0,
        830.743408203125
      ],
      [
        -932.0,
        -2844.0,
        844.0
      ],
      [
        -932.0,
        -2852.0,
        844.0
      ],
      [
        -932.0,
        -2844.0,
        839.0
      ],
      [
        -932.0,
        -2844.0,
        844.0
      ],
      [
        -932.0,
        -2852.0,
        844.0
      ],
      [
        -932.0,
        -2852.0,
        839.0
      ],
      [
        -927.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -919.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -891.4109497070312,
        -2978.0,
        816.8317260742188
      ],
      [
        -893.0887451171875,
        -2978.0,
        816.8629150390625
      ],
      [
        -906.3569946289062,
        -2978.0,
        802.6903076171875
      ],
      [
        -893.0887451171875,
        -2978.0,
        816.8629150390625
      ],
      [
        -891.4109497070312,
        -2978.0,
        816.8317260742188
      ],
      [
        -890.463623046875,
        -2978.0,
        820.1769409179688
      ],
      [
        -890.463623046875,
        -2978.0,
        820.1769409179688
      ],
      [
        -892.9408569335938,
        -2978.0,
        838.7080078125
      ],
      [
        -892.9408569335938,
        -2978.0,
        838.7080078125
      ],
      [
        -893.0785522460938,
        -2978.0,
        841.7567138671875
      ],
      [
        -893.3917236328125,
        -2978.0,
        842.0806884765625
      ],
      [
        -893.377685546875,
        -2978.0,
        842.0687866210938
      ],
      [
        -893.0785522460938,
        -2978.0,
        841.7567138671875
      ],
      [
        -893.377685546875,
        -2978.0,
        842.0687866210938
      ],
      [
        -914.2279052734375,
        -2978.0,
        859.777587890625
      ],
      [
        -890.670654296875,
        -2978.0,
        819.4458618164062
      ],
      [
        -890.571044921875,
        -2978.0,
        820.98046875
      ],
      [
        -891.6133422851562,
        -2978.0,
        828.7775268554688
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        -1208.0,
        -3073.32177734375,
        466.048828125
      ],
      "bbox_max": [
        -563.099609375,
        -2128.6962890625,
        960.462158203125
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1208.0,
      "bbox_min": [
        -1208.0,
        -2830.0,
        498.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        827.7142944335938
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1165.0,
      "bbox_min": [
        -1208.0,
        -2830.0,
        498.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        827.7142944335938
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1162.0,
      "bbox_min": [
        -1165.0,
        -2830.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        827.7142944335938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 696.0,
      "bbox_min": [
        -1162.0,
        -2830.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        827.7142944335938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -698.0,
      "bbox_min": [
        -1162.0,
        -2830.0,
        696.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        827.7142944335938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        -1110.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1085.0,
      "bbox_min": [
        -1090.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1090.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1085.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1090.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1085.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1085.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1085.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9393306374549866,
        -0.34301304817199707,
        0.0
      ],
      "plane_d": 63.718807220458984,
      "bbox_min": [
        -1085.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.939019501209259,
        -0.34386393427848816,
        -0.0
      ],
      "plane_d": -1949.2974853515625,
      "bbox_min": [
        -1085.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9390179514884949,
        0.34386810660362244,
        -0.0
      ],
      "plane_d": 1947.42919921875,
      "bbox_min": [
        -1085.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1085.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1070.9014892578125,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1085.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1083.0001220703125,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1085.0,
        -2702.89990234375,
        696.5
      ],
      "bbox_max": [
        -1084.0986328125,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1085.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1084.0986328125,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1083.0001220703125,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2705.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9393306374549866,
        0.34301304817199707,
        0.0
      ],
      "plane_d": -65.59746551513672,
      "bbox_min": [
        -1085.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1070.9014892578125,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1085.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1070.9014892578125,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1085.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1084.095458984375,
        -2783.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1072.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1070.9014892578125,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1085.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1072.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1085.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1072.0,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1085.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1084.095458984375,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1083.0,
        -2780.0,
        696.5
      ],
      "bbox_max": [
        -1070.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1085.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1085.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1070.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1085.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1085.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1070.0,
        -2800.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1105.0,
      "bbox_min": [
        -1110.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1110.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1105.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1110.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1105.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1105.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1105.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9393306374549866,
        -0.34301304817199707,
        0.0
      ],
      "plane_d": -1979.3253173828125,
      "bbox_min": [
        -1105.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939019501209259,
        -0.34386393427848816,
        0.0
      ],
      "plane_d": 93.06986999511719,
      "bbox_min": [
        -1105.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390179514884949,
        0.34386810660362244,
        0.0
      ],
      "plane_d": -94.93484497070312,
      "bbox_min": [
        -1105.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1105.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1105.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1104.0985107421875,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1091.9998779296875,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1090.9013671875,
        -2702.89990234375,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1105.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1105.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1090.9013671875,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1105.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1091.9998779296875,
        -2705.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9393306374549866,
        0.34301304817199707,
        0.0
      ],
      "plane_d": 1977.4466552734375,
      "bbox_min": [
        -1104.0985107421875,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1104.0985107421875,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1090.904541015625,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2783.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1104.0985107421875,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1103.0,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1103.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1102.9998779296875,
        -2741.39990234375,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1105.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1090.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1105.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1090.904541015625,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1105.0,
        -2780.0,
        696.5
      ],
      "bbox_max": [
        -1091.9998779296875,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1105.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1105.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1090.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1105.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1090.0,
        -2686.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1105.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1090.0,
        -2800.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1145.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1150.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1145.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1150.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1145.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9393306374549866,
        -0.34301304817199707,
        0.0
      ],
      "plane_d": 138.86526489257812,
      "bbox_min": [
        -1162.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1150.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9390179514884949,
        0.34386810660362244,
        -0.0
      ],
      "plane_d": 2022.5506591796875,
      "bbox_min": [
        -1162.0,
        -2777.261474609375,
        696.0
      ],
      "bbox_max": [
        -1150.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1162.0,
        -2777.261474609375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2708.630859375,
        697.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1162.0,
        -2777.261474609375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2708.630859375,
        697.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9393306374549866,
        0.34301304817199707,
        0.0
      ],
      "plane_d": -140.74391174316406,
      "bbox_min": [
        -1162.0,
        -2771.78466796875,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2714.09228515625,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1152.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1150.904541015625,
        -2741.39990234375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.939019501209259,
        -0.34386393427848816,
        -0.0
      ],
      "plane_d": -2024.4190673828125,
      "bbox_min": [
        -1162.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1150.904541015625,
        -2714.09228515625,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1152.0,
        -2741.39990234375,
        696.5
      ],
      "bbox_max": [
        -1150.904541015625,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1162.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1152.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1162.0,
        -2741.39990234375,
        696.5
      ],
      "bbox_max": [
        -1152.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1162.0,
        -2705.89990234375,
        696.0
      ],
      "bbox_max": [
        -1150.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1162.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1162.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1162.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1162.0,
        -2702.89990234375,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1150.0,
        -2780.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1162.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1162.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1162.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1162.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1150.0,
        -2783.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1125.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1130.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1125.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1130.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1125.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1130.0,
        -2686.0,
        696.0
      ],
      "bbox_max": [
        -1125.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9393306374549866,
        -0.34301304817199707,
        0.0
      ],
      "plane_d": -2016.8985595703125,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939019501209259,
        -0.34386393427848816,
        0.0
      ],
      "plane_d": 130.63064575195312,
      "bbox_min": [
        -1145.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390179514884949,
        0.34386810660362244,
        0.0
      ],
      "plane_d": -132.4955596923828,
      "bbox_min": [
        -1145.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1145.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1145.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1144.098388671875,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1131.9998779296875,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1130.9012451171875,
        -2702.89990234375,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1145.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1145.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1130.9012451171875,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1145.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1131.9998779296875,
        -2705.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9393306374549866,
        0.34301304817199707,
        0.0
      ],
      "plane_d": 2015.0198974609375,
      "bbox_min": [
        -1144.098388671875,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1144.098388671875,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1130.9046630859375,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2783.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1144.098388671875,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1143.0,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1143.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1142.9998779296875,
        -2741.39990234375,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1130.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1145.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1130.9046630859375,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1145.0,
        -2780.0,
        696.5
      ],
      "bbox_max": [
        -1132.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1145.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1145.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1130.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1130.0,
        -2686.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1145.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1130.0,
        -2800.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1125.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1125.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        698.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9393306374549866,
        -0.34301304817199707,
        0.0
      ],
      "plane_d": 101.29203033447266,
      "bbox_min": [
        -1125.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.939019501209259,
        -0.34386393427848816,
        -0.0
      ],
      "plane_d": -1986.8582763671875,
      "bbox_min": [
        -1125.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9390179514884949,
        0.34386810660362244,
        -0.0
      ],
      "plane_d": 1984.9898681640625,
      "bbox_min": [
        -1125.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1125.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1110.9014892578125,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1125.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1123.0001220703125,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1125.0,
        -2702.89990234375,
        696.5
      ],
      "bbox_max": [
        -1124.0987548828125,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1125.0,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1124.0987548828125,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1123.0001220703125,
        -2705.89990234375,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2705.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9393306374549866,
        0.34301304817199707,
        0.0
      ],
      "plane_d": -103.17069244384766,
      "bbox_min": [
        -1125.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1110.9014892578125,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1125.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1110.9014892578125,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1125.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1124.095458984375,
        -2783.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1112.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1110.9014892578125,
        -2744.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1125.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1112.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1125.0,
        -2741.39990234375,
        696.5
      ],
      "bbox_max": [
        -1112.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1125.0,
        -2800.0,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1124.095458984375,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1123.0,
        -2780.0,
        696.5
      ],
      "bbox_max": [
        -1110.0,
        -2780.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1125.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1125.0,
        -2800.0,
        697.5
      ],
      "bbox_max": [
        -1110.0,
        -2800.0,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1125.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1110.0,
        -2686.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1125.0,
        -2800.0,
        696.0
      ],
      "bbox_max": [
        -1110.0,
        -2800.0,
        696.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1162.0,
        -2830.0,
        698.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        827.7142944335938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -1162.0,
        -2830.0,
        795.0
      ],
      "bbox_max": [
        -1070.0,
        -2775.0,
        827.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1089.9998779296875,
      "bbox_min": [
        -1162.0,
        -2830.0,
        795.0
      ],
      "bbox_max": [
        -1070.0,
        -2785.0,
        827.7142944335938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        -1162.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1160.0,
        -2785.0,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1162.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1160.0,
        -2785.0,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1162.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1160.0,
        -2785.0,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2805.0,
      "bbox_min": [
        -1162.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1160.0,
        -2805.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1079.9998779296875,
      "bbox_min": [
        -1090.0,
        -2830.0,
        810.0
      ],
      "bbox_max": [
        -1070.0,
        -2785.0,
        827.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26195064187049866,
        0.0,
        0.9650813341140747
      ],
      "plane_d": -1074.2734375,
      "bbox_min": [
        -1080.0,
        -2830.0,
        820.0
      ],
      "bbox_max": [
        -1070.0,
        -2822.0,
        827.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26195064187049866,
        0.0,
        -0.9650813341140747
      ],
      "plane_d": 1079.0987548828125,
      "bbox_min": [
        -1080.0,
        -2830.0,
        820.0
      ],
      "bbox_max": [
        -1070.0,
        -2822.0,
        827.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2829.999755859375,
      "bbox_min": [
        -1080.0,
        -2830.0,
        820.0
      ],
      "bbox_max": [
        -1070.0,
        -2822.0,
        827.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2821.999755859375,
      "bbox_min": [
        -1080.0,
        -2822.0,
        820.0
      ],
      "bbox_max": [
        -1070.0,
        -2822.0,
        827.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2609090507030487,
        -0.9653634428977966
      ],
      "plane_d": 60.1395263671875,
      "bbox_min": [
        -1090.0,
        -2830.0,
        810.0
      ],
      "bbox_max": [
        -1080.0,
        -2785.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.2609090507030487,
        0.9653634428977966
      ],
      "plane_d": -55.31268310546875,
      "bbox_min": [
        -1090.0,
        -2830.0,
        810.0
      ],
      "bbox_max": [
        -1080.0,
        -2785.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        -1090.0,
        -2830.0,
        820.0
      ],
      "bbox_max": [
        -1080.0,
        -2822.0,
        822.1621704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2830.0,
      "bbox_min": [
        -1090.0,
        -2830.0,
        820.0
      ],
      "bbox_max": [
        -1080.0,
        -2830.0,
        822.1621704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        -1090.0,
        -2830.0,
        822.1621704101562
      ],
      "bbox_max": [
        -1080.0,
        -2822.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2830.0,
      "bbox_min": [
        -1090.0,
        -2830.0,
        822.1621704101562
      ],
      "bbox_max": [
        -1080.0,
        -2830.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2095290869474411,
        0.0,
        -0.9778023958206177
      ],
      "plane_d": 1025.295654296875,
      "bbox_min": [
        -1162.0,
        -2785.0,
        795.0
      ],
      "bbox_max": [
        -1080.0,
        -2775.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1162.0,
        -2785.0,
        799.5714111328125
      ],
      "bbox_max": [
        -1160.0,
        -2775.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -1162.0,
        -2775.0,
        799.5714111328125
      ],
      "bbox_max": [
        -1160.0,
        -2775.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -1162.0,
        -2785.0,
        795.0
      ],
      "bbox_max": [
        -1080.0,
        -2775.0,
        815.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2095290869474411,
        0.0,
        0.9778023958206177
      ],
      "plane_d": -1020.4066162109375,
      "bbox_min": [
        -1162.0,
        -2785.0,
        795.0
      ],
      "bbox_max": [
        -1080.0,
        -2775.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        -1090.0,
        -2785.0,
        810.0
      ],
      "bbox_max": [
        -1080.0,
        -2775.0,
        812.142822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -1080.0,
        -2785.0,
        810.0
      ],
      "bbox_max": [
        -1080.0,
        -2775.0,
        812.142822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 815.0,
      "bbox_min": [
        -1162.0,
        -2785.0,
        795.0
      ],
      "bbox_max": [
        -1080.0,
        -2775.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -1162.0,
        -2785.0,
        795.0
      ],
      "bbox_max": [
        -1080.0,
        -2775.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1162.0,
        -2785.0,
        795.0
      ],
      "bbox_max": [
        -1160.0,
        -2775.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        698.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -704.5,
      "bbox_min": [
        -1122.0,
        -2800.0,
        698.0
      ],
      "bbox_max": [
        -1092.5,
        -2708.0,
        708.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 699.5,
      "bbox_min": [
        -1122.0,
        -2800.0,
        698.0
      ],
      "bbox_max": [
        -1092.5,
        -2708.0,
        704.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1092.5,
      "bbox_min": [
        -1122.0,
        -2800.0,
        699.5
      ],
      "bbox_max": [
        -1092.5,
        -2708.0,
        704.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1112.5,
      "bbox_min": [
        -1122.0,
        -2800.0,
        699.5
      ],
      "bbox_max": [
        -1092.5,
        -2708.0,
        704.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2708.0,
      "bbox_min": [
        -1122.0,
        -2774.5,
        699.5
      ],
      "bbox_max": [
        -1112.5,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238805770874023,
        -0.3826809525489807,
        0.0
      ],
      "plane_d": -2094.706787109375,
      "bbox_min": [
        -1122.0,
        -2774.5,
        699.5
      ],
      "bbox_max": [
        -1112.5,
        -2765.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826809525489807,
        -0.9238805770874023,
        0.0
      ],
      "plane_d": -2989.039306640625,
      "bbox_min": [
        -1119.217529296875,
        -2774.5,
        699.5
      ],
      "bbox_max": [
        -1112.5,
        -2771.717529296875,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1102.0,
      "bbox_min": [
        -1112.5,
        -2800.0,
        699.5
      ],
      "bbox_max": [
        -1092.5,
        -2722.5,
        704.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.34817615151405334,
        -0.9374291300773621
      ],
      "plane_d": 1615.6533203125,
      "bbox_min": [
        -1102.0,
        -2757.0,
        699.5
      ],
      "bbox_max": [
        -1092.5,
        -2722.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9205604791641235,
        -0.3905999958515167
      ],
      "plane_d": 2808.099853515625,
      "bbox_min": [
        -1102.0,
        -2752.989501953125,
        700.9895629882812
      ],
      "bbox_max": [
        -1092.5,
        -2751.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34817615151405334,
        0.0,
        -0.9374291300773621
      ],
      "plane_d": 1039.4217529296875,
      "bbox_min": [
        -1102.0,
        -2732.0,
        699.5
      ],
      "bbox_max": [
        -1096.5,
        -2722.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9205604791641235,
        0.0,
        -0.3905999958515167
      ],
      "plane_d": 1284.572265625,
      "bbox_min": [
        -1102.0,
        -2732.0,
        699.5
      ],
      "bbox_max": [
        -1096.5,
        -2722.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2732.0,
      "bbox_min": [
        -1102.0,
        -2732.0,
        699.5
      ],
      "bbox_max": [
        -1096.5,
        -2722.5,
        704.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2722.5,
      "bbox_min": [
        -1102.0,
        -2722.5,
        699.5
      ],
      "bbox_max": [
        -1096.5,
        -2722.5,
        704.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2774.5,
      "bbox_min": [
        -1112.5,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1102.0,
        -2722.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2732.0,
      "bbox_min": [
        -1112.5,
        -2765.0,
        699.5
      ],
      "bbox_max": [
        -1102.0,
        -2722.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2722.5,
      "bbox_min": [
        -1112.5,
        -2722.5,
        699.5
      ],
      "bbox_max": [
        -1102.0,
        -2722.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        -1112.5,
        -2765.0,
        699.5
      ],
      "bbox_max": [
        -1102.0,
        -2765.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1105.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1110.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1105.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1110.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1102.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1092.5,
        -2722.5,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2751.5,
      "bbox_min": [
        -1102.0,
        -2757.0,
        704.5
      ],
      "bbox_max": [
        -1092.5,
        -2722.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2757.0,
      "bbox_min": [
        -1102.0,
        -2757.0,
        704.5
      ],
      "bbox_max": [
        -1092.5,
        -2751.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1092.5,
      "bbox_min": [
        -1092.5,
        -2757.0,
        704.5
      ],
      "bbox_max": [
        -1092.5,
        -2751.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1096.5,
      "bbox_min": [
        -1102.0,
        -2732.0,
        704.5
      ],
      "bbox_max": [
        -1096.5,
        -2722.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2732.0,
      "bbox_min": [
        -1102.0,
        -2732.0,
        704.5
      ],
      "bbox_max": [
        -1096.5,
        -2722.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2722.5,
      "bbox_min": [
        -1102.0,
        -2722.5,
        704.5
      ],
      "bbox_max": [
        -1096.5,
        -2722.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1105.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1105.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -1110.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1110.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        -1155.5,
        -2800.0,
        698.0
      ],
      "bbox_max": [
        -1122.0,
        -2702.89990234375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -704.5,
      "bbox_min": [
        -1155.5,
        -2800.0,
        698.0
      ],
      "bbox_max": [
        -1130.0,
        -2708.0,
        708.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 699.5,
      "bbox_min": [
        -1155.5,
        -2800.0,
        698.0
      ],
      "bbox_max": [
        -1130.0,
        -2708.0,
        704.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1139.5,
      "bbox_min": [
        -1155.5,
        -2800.0,
        699.5
      ],
      "bbox_max": [
        -1130.0,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238805770874023,
        0.3826809525489807,
        -0.0
      ],
      "plane_d": 2106.307373046875,
      "bbox_min": [
        -1139.5,
        -2776.0,
        699.5
      ],
      "bbox_max": [
        -1130.0,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826809525489807,
        0.9238805770874023,
        -0.0
      ],
      "plane_d": 2991.98046875,
      "bbox_min": [
        -1139.5,
        -2769.282470703125,
        699.5
      ],
      "bbox_max": [
        -1132.782470703125,
        -2766.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34817615151405334,
        0.0,
        -0.9374291300773621
      ],
      "plane_d": 260.02947998046875,
      "bbox_min": [
        -1139.5,
        -2717.5,
        699.5
      ],
      "bbox_max": [
        -1130.0,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2717.5,
      "bbox_min": [
        -1139.5,
        -2717.5,
        699.5
      ],
      "bbox_max": [
        -1130.0,
        -2708.0,
        704.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2708.0,
      "bbox_min": [
        -1139.5,
        -2708.0,
        699.5
      ],
      "bbox_max": [
        -1130.0,
        -2708.0,
        704.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.5,
      "bbox_min": [
        -1155.5,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1139.5,
        -2708.0,
        704.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1155.5,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1139.5,
        -2766.5,
        704.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.34817615151405334,
        0.0,
        -0.9374291300773621
      ],
      "plane_d": 255.3291015625,
      "bbox_min": [
        -1155.5,
        -2776.0,
        699.5
      ],
      "bbox_max": [
        -1150.0,
        -2766.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205604791641235,
        0.0,
        -0.3905999958515167
      ],
      "plane_d": -788.5299072265625,
      "bbox_min": [
        -1155.5,
        -2776.0,
        700.9895629882812
      ],
      "bbox_max": [
        -1154.010498046875,
        -2766.5,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        699.5
      ],
      "bbox_max": [
        -1150.0,
        -2780.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205604791641235,
        0.0,
        -0.3905999958515167
      ],
      "plane_d": -776.1023559570312,
      "bbox_min": [
        -1142.0,
        -2717.5,
        700.6142578125
      ],
      "bbox_max": [
        -1139.5,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34817615151405334,
        0.0,
        -0.9374291300773621
      ],
      "plane_d": 260.02947998046875,
      "bbox_min": [
        -1142.0,
        -2717.5,
        700.6142578125
      ],
      "bbox_max": [
        -1139.5,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2717.5,
      "bbox_min": [
        -1142.0,
        -2717.5,
        700.6142578125
      ],
      "bbox_max": [
        -1139.5,
        -2708.0,
        704.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2708.0,
      "bbox_min": [
        -1142.0,
        -2708.0,
        700.6142578125
      ],
      "bbox_max": [
        -1139.5,
        -2708.0,
        704.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1150.0,
        -2780.0,
        699.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        -1155.5,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1136.5,
        -2708.0,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1155.5,
      "bbox_min": [
        -1155.5,
        -2776.0,
        704.5
      ],
      "bbox_max": [
        -1150.0,
        -2766.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.5,
      "bbox_min": [
        -1155.5,
        -2776.0,
        704.5
      ],
      "bbox_max": [
        -1150.0,
        -2766.5,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1155.5,
        -2776.0,
        704.5
      ],
      "bbox_max": [
        -1150.0,
        -2776.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1142.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1136.5,
        -2708.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1136.5,
      "bbox_min": [
        -1142.0,
        -2717.5,
        704.5
      ],
      "bbox_max": [
        -1136.5,
        -2708.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2717.5,
      "bbox_min": [
        -1142.0,
        -2717.5,
        704.5
      ],
      "bbox_max": [
        -1136.5,
        -2708.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2708.0,
      "bbox_min": [
        -1142.0,
        -2708.0,
        704.5
      ],
      "bbox_max": [
        -1136.5,
        -2708.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1150.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        -1145.0,
        -2783.0,
        704.5
      ],
      "bbox_max": [
        -1145.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1130.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1122.0,
        -2702.89990234375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1130.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1125.0,
        -2741.39990234375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1130.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1125.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        -1125.0,
        -2783.0,
        698.0
      ],
      "bbox_max": [
        -1125.0,
        -2780.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1130.0,
        -2744.39990234375,
        698.0
      ],
      "bbox_max": [
        -1125.0,
        -2741.39990234375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        -1125.0,
        -2744.39990234375,
        698.0
      ],
      "bbox_max": [
        -1125.0,
        -2741.39990234375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1130.0,
        -2717.5,
        698.0
      ],
      "bbox_max": [
        -1122.0,
        -2702.89990234375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1130.0,
        -2705.89990234375,
        698.0
      ],
      "bbox_max": [
        -1125.0,
        -2702.89990234375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        -1125.0,
        -2705.89990234375,
        698.0
      ],
      "bbox_max": [
        -1125.0,
        -2702.89990234375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 699.5,
      "bbox_min": [
        -1130.0,
        -2717.5,
        699.5
      ],
      "bbox_max": [
        -1122.0,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2708.0,
      "bbox_min": [
        -1130.0,
        -2708.0,
        699.5
      ],
      "bbox_max": [
        -1122.0,
        -2708.0,
        704.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.3999633789062,
      "bbox_min": [
        -1162.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1160.0,
        -2686.0,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -665.8999633789062,
      "bbox_min": [
        -1162.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1160.0,
        -2686.0,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1160.0,
        -2686.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1160.0,
        -2800.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        665.8999633789062
      ],
      "bbox_max": [
        -1160.0,
        -2686.0,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        665.8999633789062
      ],
      "bbox_max": [
        -1160.0,
        -2800.0,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1160.0,
        -2686.0,
        665.3999633789062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1160.0,
        -2686.0,
        665.3999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1162.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1160.0,
        -2800.0,
        665.3999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1160.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        696.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1160.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2686.0,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1160.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2687.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.800048828125,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2687.5,
        696.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.5,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1071.0,
        -2741.800048828125,
        696.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1126.5,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1071.0,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1146.5,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1126.5,
        -2780.5,
        696.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2782.5,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1146.5,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1148.5,
      "bbox_min": [
        -1148.5,
        -2782.5,
        650.0
      ],
      "bbox_max": [
        -1148.5,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.5,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1146.5,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2796.5,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1146.5,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1156.5,
      "bbox_min": [
        -1156.5,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1146.5,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -1156.5,
        -2796.5,
        690.0
      ],
      "bbox_max": [
        -1146.5,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1128.5,
      "bbox_min": [
        -1142.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1126.5,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2782.5,
      "bbox_min": [
        -1128.5,
        -2782.5,
        650.0
      ],
      "bbox_max": [
        -1126.5,
        -2782.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.5,
      "bbox_min": [
        -1142.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1132.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1132.0,
      "bbox_min": [
        -1142.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1132.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2796.5,
      "bbox_min": [
        -1142.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1132.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1142.0,
      "bbox_min": [
        -1142.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1132.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -1142.0,
        -2796.5,
        690.0
      ],
      "bbox_max": [
        -1132.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2782.5,
      "bbox_min": [
        -1120.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1071.0,
        -2780.5,
        696.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1106.5,
      "bbox_min": [
        -1108.5,
        -2782.5,
        650.0
      ],
      "bbox_max": [
        -1086.5,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1108.5,
      "bbox_min": [
        -1108.5,
        -2782.5,
        650.0
      ],
      "bbox_max": [
        -1108.5,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1086.5,
      "bbox_min": [
        -1088.5,
        -2782.5,
        650.0
      ],
      "bbox_max": [
        -1086.5,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1088.5,
      "bbox_min": [
        -1088.5,
        -2782.5,
        650.0
      ],
      "bbox_max": [
        -1088.5,
        -2780.5,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1071.0,
      "bbox_min": [
        -1120.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1071.0,
        -2784.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2796.5,
      "bbox_min": [
        -1120.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1071.0,
        -2784.0,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.5,
      "bbox_min": [
        -1120.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1071.0,
        -2784.0,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1091.0,
      "bbox_min": [
        -1120.0,
        -2796.5,
        650.0
      ],
      "bbox_max": [
        -1071.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1081.0,
      "bbox_min": [
        -1091.0,
        -2796.5,
        680.0
      ],
      "bbox_max": [
        -1071.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -1081.0,
        -2796.5,
        690.0
      ],
      "bbox_max": [
        -1071.0,
        -2786.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        -1091.0,
        -2796.5,
        680.0
      ],
      "bbox_max": [
        -1081.0,
        -2786.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        -1120.0,
        -2794.0,
        650.0
      ],
      "bbox_max": [
        -1100.0,
        -2786.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2794.0,
      "bbox_min": [
        -1120.0,
        -2794.0,
        650.0
      ],
      "bbox_max": [
        -1100.0,
        -2786.5,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        -1120.0,
        -2794.0,
        650.0
      ],
      "bbox_max": [
        -1100.0,
        -2786.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -1120.0,
        -2794.0,
        670.0
      ],
      "bbox_max": [
        -1100.0,
        -2786.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        -1110.0,
        -2794.0,
        680.0
      ],
      "bbox_max": [
        -1100.0,
        -2786.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1120.0,
        -2794.0,
        670.0
      ],
      "bbox_max": [
        -1110.0,
        -2786.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        -1120.0,
        -2786.5,
        650.0
      ],
      "bbox_max": [
        -1100.0,
        -2784.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2784.0,
      "bbox_min": [
        -1120.0,
        -2786.5,
        650.0
      ],
      "bbox_max": [
        -1100.0,
        -2784.0,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        -1120.0,
        -2786.5,
        650.0
      ],
      "bbox_max": [
        -1100.0,
        -2784.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        -1120.0,
        -2786.5,
        670.0
      ],
      "bbox_max": [
        -1100.0,
        -2784.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        -1110.0,
        -2786.5,
        680.0
      ],
      "bbox_max": [
        -1100.0,
        -2784.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1120.0,
        -2786.5,
        670.0
      ],
      "bbox_max": [
        -1110.0,
        -2784.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1108.5,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1073.0,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2743.800048828125,
      "bbox_min": [
        -1108.5,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1073.0,
        -2741.800048828125,
        696.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1088.5,
      "bbox_min": [
        -1106.5,
        -2743.800048828125,
        650.0
      ],
      "bbox_max": [
        -1086.5,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1086.5,
      "bbox_min": [
        -1086.5,
        -2743.800048828125,
        650.0
      ],
      "bbox_max": [
        -1086.5,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1106.5,
      "bbox_min": [
        -1106.5,
        -2743.800048828125,
        650.0
      ],
      "bbox_max": [
        -1106.5,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1073.0,
      "bbox_min": [
        -1093.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1073.0,
        -2766.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.5,
      "bbox_min": [
        -1093.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1073.0,
        -2766.5,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1093.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1073.0,
        -2766.5,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1083.0,
      "bbox_min": [
        -1093.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1073.0,
        -2766.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        -1083.0,
        -2776.5,
        680.0
      ],
      "bbox_max": [
        -1073.0,
        -2766.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        -1093.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1083.0,
        -2766.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        -1093.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1093.0,
        -2766.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2743.800048828125,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1110.0,
        -2741.800048828125,
        696.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1146.5,
      "bbox_min": [
        -1148.5,
        -2743.800048828125,
        650.0
      ],
      "bbox_max": [
        -1126.5,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1148.5,
      "bbox_min": [
        -1148.5,
        -2743.800048828125,
        650.0
      ],
      "bbox_max": [
        -1148.5,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1126.5,
      "bbox_min": [
        -1128.5,
        -2743.800048828125,
        650.0
      ],
      "bbox_max": [
        -1126.5,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1128.5,
      "bbox_min": [
        -1128.5,
        -2743.800048828125,
        650.0
      ],
      "bbox_max": [
        -1128.5,
        -2741.800048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1110.0,
        -2765.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1110.0,
        -2765.0,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1110.0,
        -2765.0,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.5,
      "bbox_min": [
        -1154.0,
        -2775.0,
        650.0
      ],
      "bbox_max": [
        -1110.0,
        -2765.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1154.0,
        -2775.0,
        650.0
      ],
      "bbox_max": [
        -1110.0,
        -2766.5,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1134.0,
      "bbox_min": [
        -1154.0,
        -2775.0,
        650.0
      ],
      "bbox_max": [
        -1130.0,
        -2766.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1154.0,
      "bbox_min": [
        -1154.0,
        -2775.0,
        650.0
      ],
      "bbox_max": [
        -1154.0,
        -2766.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        -1130.0,
        -2775.0,
        650.0
      ],
      "bbox_max": [
        -1130.0,
        -2766.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        -1120.0,
        -2775.0,
        670.0
      ],
      "bbox_max": [
        -1110.0,
        -2766.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -1120.0,
        -2775.0,
        690.0
      ],
      "bbox_max": [
        -1110.0,
        -2766.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        -1130.0,
        -2766.5,
        650.0
      ],
      "bbox_max": [
        -1110.0,
        -2765.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -1120.0,
        -2766.5,
        690.0
      ],
      "bbox_max": [
        -1110.0,
        -2765.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        -1130.0,
        -2766.5,
        650.0
      ],
      "bbox_max": [
        -1120.0,
        -2765.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1130.0,
        -2766.5,
        670.0
      ],
      "bbox_max": [
        -1120.0,
        -2765.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1134.0,
        -2775.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1134.0,
        -2775.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1134.0,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1134.0,
        -2775.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1154.0,
      "bbox_min": [
        -1154.0,
        -2776.5,
        650.0
      ],
      "bbox_max": [
        -1154.0,
        -2775.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2703.300048828125,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2687.5,
        696.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1106.5,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.300048828125,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1106.5,
        -2703.300048828125,
        696.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1128.5,
      "bbox_min": [
        -1148.5,
        -2705.300048828125,
        650.0
      ],
      "bbox_max": [
        -1108.5,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1126.5,
      "bbox_min": [
        -1126.5,
        -2705.300048828125,
        650.0
      ],
      "bbox_max": [
        -1108.5,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1108.5,
      "bbox_min": [
        -1108.5,
        -2705.300048828125,
        650.0
      ],
      "bbox_max": [
        -1108.5,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1146.5,
      "bbox_min": [
        -1148.5,
        -2705.300048828125,
        650.0
      ],
      "bbox_max": [
        -1146.5,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1148.5,
      "bbox_min": [
        -1148.5,
        -2705.300048828125,
        650.0
      ],
      "bbox_max": [
        -1148.5,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2707.0,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1120.0,
        -2707.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2717.0,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1120.0,
        -2707.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        -1156.0,
        -2717.0,
        650.0
      ],
      "bbox_max": [
        -1120.0,
        -2707.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1140.0,
        -2717.0,
        650.0
      ],
      "bbox_max": [
        -1120.0,
        -2707.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        -1120.0,
        -2717.0,
        650.0
      ],
      "bbox_max": [
        -1120.0,
        -2707.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2709.999755859375,
      "bbox_min": [
        -1156.0,
        -2717.0,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2709.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1146.0,
      "bbox_min": [
        -1156.0,
        -2717.0,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2709.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1156.0,
      "bbox_min": [
        -1156.0,
        -2717.0,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2709.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1156.0,
        -2717.0,
        670.0
      ],
      "bbox_max": [
        -1146.0,
        -2709.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2719.999755859375,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2717.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1146.0,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2717.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1156.0,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2717.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1156.0,
        -2719.999755859375,
        670.0
      ],
      "bbox_max": [
        -1146.0,
        -2717.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.300048828125,
      "bbox_min": [
        -1102.0,
        -2716.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1086.5,
      "bbox_min": [
        -1088.5,
        -2705.300048828125,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1088.5,
      "bbox_min": [
        -1088.5,
        -2705.300048828125,
        650.0
      ],
      "bbox_max": [
        -1088.5,
        -2703.300048828125,
        696.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.0,
      "bbox_min": [
        -1071.5,
        -2705.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2703.5,
        662.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2703.5,
      "bbox_min": [
        -1071.5,
        -2705.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2703.5,
        662.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1071.5,
      "bbox_min": [
        -1071.5,
        -2705.0,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2703.5,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -1253.2000732421875,
      "bbox_min": [
        -1071.5,
        -2705.0,
        660.0
      ],
      "bbox_max": [
        -1070.0,
        -2703.5,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2716.5,
      "bbox_min": [
        -1102.0,
        -2716.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2706.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2706.5,
      "bbox_min": [
        -1102.0,
        -2716.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2706.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1082.0,
      "bbox_min": [
        -1102.0,
        -2716.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2706.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1102.0,
        -2716.5,
        650.0
      ],
      "bbox_max": [
        -1082.0,
        -2706.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1102.0,
      "bbox_min": [
        -1102.0,
        -2716.5,
        650.0
      ],
      "bbox_max": [
        -1102.0,
        -2706.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2712.5,
      "bbox_min": [
        -1071.5,
        -2712.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2711.0,
        662.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2711.0,
      "bbox_min": [
        -1071.5,
        -2712.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2711.0,
        662.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1071.5,
      "bbox_min": [
        -1071.5,
        -2712.5,
        650.0
      ],
      "bbox_max": [
        -1070.0,
        -2711.0,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -1253.2000732421875,
      "bbox_min": [
        -1071.5,
        -2712.5,
        660.0
      ],
      "bbox_max": [
        -1070.0,
        -2711.0,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1117.5,
      "bbox_min": [
        -1156.0,
        -2700.999755859375,
        650.0
      ],
      "bbox_max": [
        -1082.0,
        -2687.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1107.5,
      "bbox_min": [
        -1117.5,
        -2698.5,
        650.0
      ],
      "bbox_max": [
        -1082.0,
        -2687.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2697.5,
      "bbox_min": [
        -1117.5,
        -2697.5,
        650.0
      ],
      "bbox_max": [
        -1107.5,
        -2687.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2687.5,
      "bbox_min": [
        -1117.5,
        -2697.5,
        650.0
      ],
      "bbox_max": [
        -1107.5,
        -2687.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -1117.5,
        -2697.5,
        690.0
      ],
      "bbox_max": [
        -1107.5,
        -2687.5,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1082.0,
      "bbox_min": [
        -1102.0,
        -2698.5,
        650.0
      ],
      "bbox_max": [
        -1082.0,
        -2688.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2698.5,
      "bbox_min": [
        -1102.0,
        -2698.5,
        650.0
      ],
      "bbox_max": [
        -1082.0,
        -2688.5,
        670.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.5,
      "bbox_min": [
        -1102.0,
        -2698.5,
        650.0
      ],
      "bbox_max": [
        -1082.0,
        -2688.5,
        670.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -660.0,
      "bbox_min": [
        -1102.0,
        -2698.5,
        650.0
      ],
      "bbox_max": [
        -1082.0,
        -2688.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1102.0,
      "bbox_min": [
        -1102.0,
        -2698.5,
        650.0
      ],
      "bbox_max": [
        -1102.0,
        -2688.5,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1092.0,
        -2698.5,
        660.0
      ],
      "bbox_max": [
        -1082.0,
        -2688.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1092.0,
      "bbox_min": [
        -1092.0,
        -2698.5,
        660.0
      ],
      "bbox_max": [
        -1092.0,
        -2688.5,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1143.5,
      "bbox_min": [
        -1156.0,
        -2700.999755859375,
        650.0
      ],
      "bbox_max": [
        -1123.5,
        -2688.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2698.0,
      "bbox_min": [
        -1143.5,
        -2698.0,
        650.0
      ],
      "bbox_max": [
        -1123.5,
        -2688.0,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -1143.5,
        -2698.0,
        650.0
      ],
      "bbox_max": [
        -1123.5,
        -2688.0,
        690.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1133.5,
      "bbox_min": [
        -1143.5,
        -2698.0,
        650.0
      ],
      "bbox_max": [
        -1123.5,
        -2688.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -1143.5,
        -2698.0,
        690.0
      ],
      "bbox_max": [
        -1133.5,
        -2688.0,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1123.5,
      "bbox_min": [
        -1133.5,
        -2698.0,
        650.0
      ],
      "bbox_max": [
        -1123.5,
        -2688.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1133.5,
        -2698.0,
        670.0
      ],
      "bbox_max": [
        -1123.5,
        -2688.0,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2700.999755859375,
      "bbox_min": [
        -1156.0,
        -2700.999755859375,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2690.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1146.0,
      "bbox_min": [
        -1156.0,
        -2700.999755859375,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2690.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1156.0,
      "bbox_min": [
        -1156.0,
        -2700.999755859375,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2690.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2690.999755859375,
      "bbox_min": [
        -1156.0,
        -2700.999755859375,
        650.0
      ],
      "bbox_max": [
        -1146.0,
        -2690.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -1156.0,
        -2700.999755859375,
        670.0
      ],
      "bbox_max": [
        -1146.0,
        -2690.999755859375,
        670.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -665.8999633789062,
      "bbox_min": [
        -1165.0,
        -2805.0,
        650.0
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.3999633789062,
      "bbox_min": [
        -1165.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1164.0,
      "bbox_min": [
        -1165.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1164.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1164.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1162.0,
        -2800.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1165.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1164.0,
        -2686.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1165.0,
        -2800.0,
        665.3999633789062
      ],
      "bbox_max": [
        -1164.0,
        -2800.0,
        665.8999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1165.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        665.3999633789062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1165.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        665.3999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1165.0,
        -2800.0,
        650.0
      ],
      "bbox_max": [
        -1162.0,
        -2800.0,
        665.3999633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1165.0,
        -2805.0,
        665.8999633789062
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        800.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1165.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1162.0,
        -2775.0,
        800.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1165.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1162.0,
        -2775.0,
        800.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2805.0,
      "bbox_min": [
        -1165.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1162.0,
        -2775.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -1165.0,
        -2775.0,
        795.0
      ],
      "bbox_max": [
        -1162.0,
        -2775.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1165.0,
        -2800.0,
        665.8999633789062
      ],
      "bbox_max": [
        -1162.0,
        -2686.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1165.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2771.78466796875,
        697.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1165.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2771.78466796875,
        697.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2780.0,
      "bbox_min": [
        -1165.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2777.261474609375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2783.0,
      "bbox_min": [
        -1165.0,
        -2783.0,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2783.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9393306374549866,
        -0.34301304817199707,
        0.0
      ],
      "plane_d": 138.86526489257812,
      "bbox_min": [
        -1163.0,
        -2780.0,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2777.261474609375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.939019501209259,
        -0.34386393427848816,
        -0.0
      ],
      "plane_d": -2024.4190673828125,
      "bbox_min": [
        -1165.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1165.0,
        -2714.09228515625,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1165.0,
        -2714.09228515625,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.89990234375,
      "bbox_min": [
        -1165.0,
        -2708.630859375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2702.89990234375,
      "bbox_min": [
        -1165.0,
        -2702.89990234375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2702.89990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9390179514884949,
        0.34386810660362244,
        -0.0
      ],
      "plane_d": 2022.5506591796875,
      "bbox_min": [
        -1163.0,
        -2708.630859375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2705.900146484375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 696.5,
      "bbox_min": [
        -1165.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1165.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2744.39990234375,
      "bbox_min": [
        -1165.0,
        -2744.39990234375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.39990234375,
      "bbox_min": [
        -1165.0,
        -2741.39990234375,
        696.5
      ],
      "bbox_max": [
        -1162.0,
        -2741.39990234375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2686.0,
      "bbox_min": [
        -1208.0,
        -2805.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2686.0,
        811.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1208.0,
        -2805.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2686.0,
        811.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1200.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2800.0,
        800.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1200.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2800.0,
        800.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2805.0,
      "bbox_min": [
        -1200.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2800.0,
        800.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        -1200.0,
        -2805.0,
        795.0
      ],
      "bbox_max": [
        -1200.0,
        -2800.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2770.50146484375,
      "bbox_min": [
        -1208.0,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2686.0,
        811.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2715.99853515625,
      "bbox_min": [
        -1208.0,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2686.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        1.2759659512084909e-05,
        0.0
      ],
      "plane_d": 1174.6859130859375,
      "bbox_min": [
        -1208.0,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2686.0,
        708.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940136909485,
        -0.0
      ],
      "plane_d": -2762.634033203125,
      "bbox_min": [
        -1208.0,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2686.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940136909485,
        0.0
      ],
      "plane_d": 2739.537109375,
      "bbox_min": [
        -1208.0,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2686.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2692.9013671875,
      "bbox_min": [
        -1208.0,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2686.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071131467819214,
        0.7071003913879395,
        0.0
      ],
      "plane_d": 1061.991455078125,
      "bbox_min": [
        -1208.0,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2692.9013671875,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071131467819214,
        -0.7071003913879395,
        0.0
      ],
      "plane_d": -1085.088623046875,
      "bbox_min": [
        -1202.53173828125,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2692.9013671875,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -1.2759659512084909e-05,
        -0.0
      ],
      "plane_d": -1197.782958984375,
      "bbox_min": [
        -1202.53173828125,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2692.9013671875,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1197.74853515625,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2692.9013671875,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.74853515625,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2692.9013671875,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1202.53173828125,
        -2709.2333984375,
        498.0
      ],
      "bbox_max": [
        -1197.7484130859375,
        -2699.66650390625,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1181.417724609375,
        -2716.0,
        708.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2709.2333984375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2704.449951171875,
        498.0
      ],
      "bbox_max": [
        -1190.983642578125,
        -2692.9013671875,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2704.449951171875,
        498.0
      ],
      "bbox_max": [
        -1190.983642578125,
        -2692.9013671875,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2692.9013671875,
        498.0
      ],
      "bbox_max": [
        -1181.4166259765625,
        -2686.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1188.3177490234375,
        -2699.666748046875,
        498.0
      ],
      "bbox_max": [
        -1174.6514892578125,
        -2686.0,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1190.9820556640625,
        -2698.9814453125,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1190.9820556640625,
        -2698.9814453125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1174.651611328125,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2686.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1174.651611328125,
        -2716.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2686.0,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 695.0,
      "bbox_min": [
        -1174.6514892578125,
        -2709.2333984375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2699.666259765625,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1174.6514892578125,
        -2709.2333984375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2699.666259765625,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.5295643354183994e-05,
        1.0,
        0.0
      ],
      "plane_d": 2699.63671875,
      "bbox_min": [
        -1174.6514892578125,
        -2709.2333984375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2699.666259765625,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5295963496319018e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2709.20361328125,
      "bbox_min": [
        -1174.6513671875,
        -2709.2333984375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2709.233154296875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.00146484375,
      "bbox_min": [
        -1208.0,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2716.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071131467819214,
        0.7071003913879395,
        0.0
      ],
      "plane_d": 1116.509033203125,
      "bbox_min": [
        -1208.0,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940136909485,
        0.0
      ],
      "plane_d": 2794.053955078125,
      "bbox_min": [
        -1191.4835205078125,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1191.4835205078125,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1180.9161376953125,
        -2770.0,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1191.4835205078125,
        -2770.50146484375,
        708.0
      ],
      "bbox_max": [
        -1180.9161376953125,
        -2770.0,
        708.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1181.417724609375,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.0,
        708.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1181.417724609375,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.0,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1190.9820556640625,
        -2770.0,
        708.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2770.50146484375,
        498.0
      ],
      "bbox_max": [
        -1190.9820556640625,
        -2770.0,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2759659512084909e-05,
        0.0
      ],
      "plane_d": 1174.6864013671875,
      "bbox_min": [
        -1208.0,
        -2770.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2716.0,
        708.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2731.50146484375,
      "bbox_min": [
        -1208.0,
        -2770.0,
        498.0
      ],
      "bbox_max": [
        -1174.6510009765625,
        -2716.0,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2754.5986328125,
      "bbox_min": [
        -1208.0,
        -2770.0,
        498.0
      ],
      "bbox_max": [
        -1174.6510009765625,
        -2731.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940136909485,
        0.0
      ],
      "plane_d": 2766.830810546875,
      "bbox_min": [
        -1208.0,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2731.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071131467819214,
        0.7071003913879395,
        0.0
      ],
      "plane_d": 1089.28564453125,
      "bbox_min": [
        -1208.0,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2731.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940136909485,
        -0.0
      ],
      "plane_d": -2789.927978515625,
      "bbox_min": [
        -1208.0,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2731.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071131467819214,
        -0.7071003913879395,
        0.0
      ],
      "plane_d": -1112.3826904296875,
      "bbox_min": [
        -1202.5318603515625,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2731.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -1.2759659512084909e-05,
        -0.0
      ],
      "plane_d": -1197.783447265625,
      "bbox_min": [
        -1202.5318603515625,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2731.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1197.74853515625,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2731.50146484375,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.7484130859375,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2731.50146484375,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1202.5318603515625,
        -2747.83349609375,
        498.0
      ],
      "bbox_max": [
        -1197.7484130859375,
        -2738.266357421875,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1181.41650390625,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2747.833251953125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1190.9835205078125,
        -2743.0498046875,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2754.5986328125,
        498.0
      ],
      "bbox_max": [
        -1190.9835205078125,
        -2743.0498046875,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2748.51806640625,
        498.0
      ],
      "bbox_max": [
        -1190.9835205078125,
        -2731.50146484375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1181.416259765625,
        -2738.266357421875,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2731.50146484375,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2770.0,
        498.0
      ],
      "bbox_max": [
        -1174.6510009765625,
        -2754.5986328125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2731.50146484375,
        498.0
      ],
      "bbox_max": [
        -1174.6514892578125,
        -2716.0,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 695.0,
      "bbox_min": [
        -1174.6514892578125,
        -2747.83349609375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2738.266357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1174.6514892578125,
        -2747.83349609375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2738.266357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.5295643354183994e-05,
        1.0,
        0.0
      ],
      "plane_d": 2738.23681640625,
      "bbox_min": [
        -1174.6514892578125,
        -2747.83349609375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2738.266357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5295963496319018e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2747.8037109375,
      "bbox_min": [
        -1174.6513671875,
        -2747.83349609375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2747.833251953125,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1117.0343017578125,
      "bbox_min": [
        -1208.0,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        811.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071131467819214,
        0.7071003913879395,
        0.0
      ],
      "plane_d": 1116.509033203125,
      "bbox_min": [
        -1208.0,
        -2787.725341796875,
        498.0
      ],
      "bbox_max": [
        -1190.7762451171875,
        -2770.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -1.2759659512084909e-05,
        -0.0
      ],
      "plane_d": -1197.783935546875,
      "bbox_min": [
        -1208.0,
        -2787.725341796875,
        498.0
      ],
      "bbox_max": [
        -1190.7762451171875,
        -2770.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.74853515625,
        -2777.4736328125,
        498.0
      ],
      "bbox_max": [
        -1190.7762451171875,
        -2770.50146484375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1197.74853515625,
        -2777.4736328125,
        708.0
      ],
      "bbox_max": [
        -1190.7763671875,
        -2770.50146484375,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2787.725341796875,
        498.0
      ],
      "bbox_max": [
        -1197.74853515625,
        -2776.7666015625,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2787.018310546875,
        498.0
      ],
      "bbox_max": [
        -1191.4835205078125,
        -2770.50146484375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2787.018310546875,
        708.0
      ],
      "bbox_max": [
        -1191.4835205078125,
        -2770.50146484375,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        1.3336889423953835e-05,
        0.0
      ],
      "plane_d": 1197.2855224609375,
      "bbox_min": [
        -1208.0,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        811.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940136909485,
        -0.0
      ],
      "plane_d": -2817.151123046875,
      "bbox_min": [
        -1208.0,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1197.2481689453125,
        -2776.9736328125,
        800.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -1.2759659512084909e-05,
        -0.0
      ],
      "plane_d": -1197.783935546875,
      "bbox_min": [
        -1202.1783447265625,
        -2786.833740234375,
        498.0
      ],
      "bbox_max": [
        -1197.248291015625,
        -2776.9736328125,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.74853515625,
        -2786.833740234375,
        498.0
      ],
      "bbox_max": [
        -1197.248291015625,
        -2776.9736328125,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1202.1783447265625,
        -2786.33349609375,
        498.0
      ],
      "bbox_max": [
        -1197.7484130859375,
        -2777.4736328125,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1202.1783447265625,
        -2786.33349609375,
        498.0
      ],
      "bbox_max": [
        -1197.7484130859375,
        -2777.4736328125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1208.0,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1197.2481689453125,
        -2781.903564453125,
        800.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        -1200.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -1197.2481689453125,
        -2795.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1200.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -1197.2481689453125,
        -2795.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1200.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -1197.2481689453125,
        -2795.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2795.0,
      "bbox_min": [
        -1200.0,
        -2795.0,
        795.0
      ],
      "bbox_max": [
        -1197.248291015625,
        -2795.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1208.0,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1197.2481689453125,
        -2781.903564453125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071134448051453,
        0.7071000933647156,
        0.0
      ],
      "plane_d": 2816.66064453125,
      "bbox_min": [
        -1197.24853515625,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        811.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2793.0986328125,
      "bbox_min": [
        -1197.2484130859375,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1183.3748779296875,
        -2786.12646484375,
        800.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940136909485,
        -0.0
      ],
      "plane_d": -2817.151123046875,
      "bbox_min": [
        -1197.2484130859375,
        -2793.0986328125,
        498.0
      ],
      "bbox_max": [
        -1190.2762451171875,
        -2786.12646484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.2484130859375,
        -2793.0986328125,
        498.0
      ],
      "bbox_max": [
        -1190.2762451171875,
        -2786.12646484375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1197.2484130859375,
        -2793.0986328125,
        708.0
      ],
      "bbox_max": [
        -1190.2763671875,
        -2786.12646484375,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.2484130859375,
        -2793.0986328125,
        498.0
      ],
      "bbox_max": [
        -1190.983642578125,
        -2786.83349609375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.248291015625,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1183.3748779296875,
        -2793.0986328125,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1197.248291015625,
        -2800.0,
        708.0
      ],
      "bbox_max": [
        -1183.3748779296875,
        -2793.0986328125,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1190.0,
        -2795.0,
        795.0
      ],
      "bbox_max": [
        -1188.3748779296875,
        -2793.374755859375,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1190.0,
        -2795.0,
        795.0
      ],
      "bbox_max": [
        -1188.3748779296875,
        -2793.374755859375,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1197.248291015625,
        -2800.0,
        800.0
      ],
      "bbox_max": [
        -1183.3748779296875,
        -2795.0,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2792.5986328125,
      "bbox_min": [
        -1197.24853515625,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        811.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071131467819214,
        -0.7071003913879395,
        0.0
      ],
      "plane_d": -1139.6060791015625,
      "bbox_min": [
        -1190.7763671875,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2792.5986328125,
        800.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2793.0986328125,
      "bbox_min": [
        -1190.7763671875,
        -2797.528564453125,
        498.0
      ],
      "bbox_max": [
        -1180.916259765625,
        -2792.5986328125,
        800.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1190.7763671875,
        -2793.0986328125,
        498.0
      ],
      "bbox_max": [
        -1180.916259765625,
        -2792.5986328125,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1190.7763671875,
        -2793.0986328125,
        708.0
      ],
      "bbox_max": [
        -1180.916259765625,
        -2792.5986328125,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1190.0,
        -2793.0986328125,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2792.60009765625,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1190.0,
      "bbox_min": [
        -1190.0,
        -2793.0986328125,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2792.60009765625,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1182.5,
      "bbox_min": [
        -1182.5,
        -2793.0986328125,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2792.60009765625,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1190.2763671875,
        -2797.528564453125,
        498.0
      ],
      "bbox_max": [
        -1181.4163818359375,
        -2793.0986328125,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1190.0,
        -2797.528564453125,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2793.0986328125,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1190.0,
        -2797.528564453125,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2793.0986328125,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1190.0,
      "bbox_min": [
        -1190.0,
        -2793.374755859375,
        795.0
      ],
      "bbox_max": [
        -1190.0,
        -2793.0986328125,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1190.2762451171875,
        -2797.528564453125,
        498.0
      ],
      "bbox_max": [
        -1181.4163818359375,
        -2793.0986328125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1185.8463134765625,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2792.5986328125,
        800.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1182.5,
      "bbox_min": [
        -1183.3177490234375,
        -2795.0,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2794.182373046875,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1183.3177490234375,
        -2795.0,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2794.182373046875,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1183.3177490234375,
        -2795.0,
        795.0
      ],
      "bbox_max": [
        -1182.5,
        -2794.182373046875,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1170.0,
        -2795.0,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2792.5986328125,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1185.8463134765625,
        -2800.0,
        800.0
      ],
      "bbox_max": [
        -1165.0,
        -2795.0,
        800.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1185.8463134765625,
        -2800.0,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2792.5986328125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1139.13134765625,
      "bbox_min": [
        -1197.24853515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        811.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        1.2759659512084909e-05,
        0.0
      ],
      "plane_d": 1174.6868896484375,
      "bbox_min": [
        -1181.62353515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2775.97509765625,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071131467819214,
        -0.7071003913879395,
        0.0
      ],
      "plane_d": -1139.6060791015625,
      "bbox_min": [
        -1181.62353515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2785.62646484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1181.62353515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2785.62646484375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1181.62353515625,
        -2792.5986328125,
        697.5
      ],
      "bbox_max": [
        -1174.6513671875,
        -2785.62646484375,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1175.1513671875,
        -2786.33349609375,
        697.5
      ],
      "bbox_max": [
        -1174.6513671875,
        -2785.62646484375,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1180.916259765625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6512451171875,
        -2786.33349609375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1174.6513671875,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2775.97509765625,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1170.0,
        -2792.5986328125,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2775.97509765625,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1170.0,
        -2792.5986328125,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2775.97509765625,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        -1170.0,
        -2792.5986328125,
        795.0
      ],
      "bbox_max": [
        -1170.0,
        -2780.97509765625,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 695.0,
      "bbox_min": [
        -1174.6513671875,
        -2786.33349609375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2776.766357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1174.6513671875,
        -2786.33349609375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2776.766357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.5295963496319018e-05,
        -1.0,
        0.0
      ],
      "plane_d": -2786.3037109375,
      "bbox_min": [
        -1174.6513671875,
        -2786.33349609375,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2776.766357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.5295643354183994e-05,
        1.0,
        0.0
      ],
      "plane_d": 2776.73681640625,
      "bbox_min": [
        -1165.7913818359375,
        -2776.766357421875,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2776.766357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071134448051453,
        -0.7071000933647156,
        -0.0
      ],
      "plane_d": -2794.563720703125,
      "bbox_min": [
        -1197.24853515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        811.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        1.2759659512084909e-05,
        0.0
      ],
      "plane_d": 1174.6868896484375,
      "bbox_min": [
        -1181.62353515625,
        -2781.550048828125,
        498.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940136909485,
        0.0
      ],
      "plane_d": 2794.053955078125,
      "bbox_min": [
        -1181.62353515625,
        -2777.4736328125,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2770.50146484375,
        708.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1181.62353515625,
        -2777.4736328125,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2770.50146484375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1181.62353515625,
        -2777.4736328125,
        697.5
      ],
      "bbox_max": [
        -1174.6514892578125,
        -2770.50146484375,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1175.1514892578125,
        -2777.4736328125,
        697.5
      ],
      "bbox_max": [
        -1174.6514892578125,
        -2776.7666015625,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1180.9161376953125,
        -2776.766845703125,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2770.50146484375,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1180.9161376953125,
        -2776.7666015625,
        708.0
      ],
      "bbox_max": [
        -1174.6514892578125,
        -2770.50146484375,
        708.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1174.6514892578125,
        -2781.550048828125,
        695.0
      ],
      "bbox_max": [
        -1165.0,
        -2770.50146484375,
        800.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 800.0,
      "bbox_min": [
        -1170.0,
        -2780.97509765625,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2775.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -1170.0,
        -2780.97509765625,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2775.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -1170.0,
        -2775.0,
        795.0
      ],
      "bbox_max": [
        -1165.0,
        -2775.0,
        800.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.5295643354183994e-05,
        1.0,
        0.0
      ],
      "plane_d": 2776.73681640625,
      "bbox_min": [
        -1174.6514892578125,
        -2781.550048828125,
        695.0
      ],
      "bbox_max": [
        -1165.7913818359375,
        -2776.766357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 695.0,
      "bbox_min": [
        -1174.6514892578125,
        -2781.550048828125,
        695.0
      ],
      "bbox_max": [
        -1165.7913818359375,
        -2776.766357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1174.6514892578125,
        -2781.550048828125,
        697.5
      ],
      "bbox_max": [
        -1165.7913818359375,
        -2776.766357421875,
        697.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.2759659512084909e-05,
        0.0
      ],
      "plane_d": 1174.6868896484375,
      "bbox_min": [
        -1197.24853515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1170.5750732421875,
        -2770.50146484375,
        811.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -1.3336889423953835e-05,
        -0.0
      ],
      "plane_d": -1175.1884765625,
      "bbox_min": [
        -1197.24853515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2770.50146484375,
        811.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -697.5,
      "bbox_min": [
        -1175.1514892578125,
        -2786.12646484375,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2776.9736328125,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1175.1514892578125,
        -2786.12646484375,
        498.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2776.9736328125,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        -1175.1514892578125,
        -2786.12646484375,
        708.0
      ],
      "bbox_max": [
        -1174.6513671875,
        -2776.9736328125,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -553.0999755859375,
      "bbox_min": [
        -1197.24853515625,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1175.1513671875,
        -2770.50146484375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -498.0,
      "bbox_min": [
        -1197.2484130859375,
        -2792.5986328125,
        498.0
      ],
      "bbox_max": [
        -1175.1513671875,
        -2770.50146484375,
        498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 811.0,
      "bbox_min": [
        -1197.24853515625,
        -2792.5986328125,
        811.0
      ],
      "bbox_max": [
        -1175.1513671875,
        -2770.50146484375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7473034858703613,
        -0.6633269190788269,
        0.039178479462862015
      ],
      "plane_d": -1945.5296630859375,
      "bbox_min": [
        -656.0,
        -2305.515380859375,
        498.3907775878906
      ],
      "bbox_max": [
        -563.099609375,
        -2152.899169921875,
        694.83642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -615.3544921875,
        -2246.5771484375,
        639.28125
      ],
      "bbox_max": [
        -563.099609375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -615.3544921875,
        -2205.430908203125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -612.2839965820312,
        -2205.430908203125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2195.33203125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -656.0,
        -2305.515380859375,
        639.28125
      ],
      "bbox_max": [
        -575.7611694335938,
        -2201.833251953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -656.0,
        -2236.7548828125,
        639.2813110351562
      ],
      "bbox_max": [
        -612.2088623046875,
        -2201.833251953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -656.0,
        -2236.7548828125,
        641.6248779296875
      ],
      "bbox_max": [
        -612.2088623046875,
        -2201.833251953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7473034858703613,
        -0.6633269190788269,
        0.039178479462862015
      ],
      "plane_d": -1945.5296630859375,
      "bbox_min": [
        -732.0,
        -2377.76953125,
        466.048828125
      ],
      "bbox_max": [
        -656.0,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -732.0,
        -2377.76953125,
        639.28125
      ],
      "bbox_max": [
        -656.0,
        -2230.853271484375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -732.0,
        -2377.76953125,
        639.28125
      ],
      "bbox_max": [
        -656.0,
        -2230.853271484375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -732.0,
        -2370.76171875,
        639.28125
      ],
      "bbox_max": [
        -656.0,
        -2236.7548828125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -732.0,
        -2370.76171875,
        639.28125
      ],
      "bbox_max": [
        -708.852294921875,
        -2322.6015625,
        639.57861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -732.0,
        -2377.76953125,
        667.65771484375
      ],
      "bbox_max": [
        -712.98974609375,
        -2353.859130859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -824.0,
        -2508.8759765625,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -824.0,
        -2422.7626953125,
        639.5219116210938
      ],
      "bbox_max": [
        -753.8310546875,
        -2300.702880859375,
        687.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2300.75,
        641.6248779296875
      ],
      "bbox_max": [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -824.0,
        -2422.7626953125,
        639.5219116210938
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        687.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -824.0,
        -2422.7626953125,
        639.5219116210938
      ],
      "bbox_max": [
        -769.4964599609375,
        -2328.412109375,
        687.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -824.0,
        -2422.7626953125,
        640.3125
      ],
      "bbox_max": [
        -789.2903442382812,
        -2353.5068359375,
        687.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -824.0,
        -2422.7626953125,
        640.3125
      ],
      "bbox_max": [
        -819.0576171875,
        -2410.626220703125,
        640.4518432617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2304.79736328125,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -750.960693359375,
        -2322.6015625,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2304.79736328125,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -824.0,
        -2508.8759765625,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2285.115966796875,
        687.14501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -824.0,
        -2508.8759765625,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2285.115966796875,
        673.1868896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7906190752983093,
        0.49548137187957764,
        0.3597496747970581
      ],
      "plane_d": 352.2090148925781,
      "bbox_min": [
        -824.0,
        -2508.8759765625,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2435.9833984375,
        665.5243530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.794124960899353,
        0.5035092234611511,
        0.3403586447238922
      ],
      "plane_d": 381.9332275390625,
      "bbox_min": [
        -824.0,
        -2496.4072265625,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2435.9833984375,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -824.0,
        -2491.637939453125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2435.9833984375,
        641.2958374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -824.0,
        -2455.29345703125,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2285.115966796875,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -769.4964599609375,
        -2328.412109375,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2285.115966796875,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.8582153320312,
        -2303.782470703125,
        641.6248779296875
      ],
      "bbox_max": [
        -743.6061401367188,
        -2293.402587890625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -751.685302734375,
        -2318.593017578125,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2285.115966796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -751.685302734375,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -732.0,
        -2285.115966796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -751.685302734375,
        -2304.796142578125,
        641.6248779296875
      ],
      "bbox_max": [
        -732.0,
        -2285.115966796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2737.0,
      "bbox_min": [
        -824.0,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -824.0,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -795.0,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2753.0,
      "bbox_min": [
        -824.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2745.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -824.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2745.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -795.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2745.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.304443359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.304443359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.304443359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        663.75
      ],
      "bbox_max": [
        -824.0,
        -2384.304443359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        663.75
      ],
      "bbox_max": [
        -824.0,
        -2384.304443359375,
        716.2435302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262522339820862,
        0.08588957786560059
      ],
      "plane_d": -911.859375,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -824.0,
        -2384.304443359375,
        665.7431030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -952.3094482421875,
        -2640.0,
        723.5732421875
      ],
      "bbox_max": [
        -913.3468627929688,
        -2572.969482421875,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -952.3094482421875,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -920.77587890625,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -947.58984375,
        -2640.0,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -928.4061279296875,
        -2585.4599609375,
        716.2435302734375
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        723.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -922.527099609375,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -915.2293090820312,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -933.75,
        -2640.0,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -916.80810546875,
        -2640.0,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -916.80810546875,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -912.8217163085938,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -933.75,
        -2640.0,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -909.609375,
        -2566.875,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -904.1224975585938,
        -2499.389404296875,
        665.9375
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        668.7374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -933.75,
        -2640.0,
        667.6315307617188
      ],
      "bbox_max": [
        -889.9989624023438,
        -2497.905517578125,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -909.609375,
        -2570.603515625,
        667.6315307617188
      ],
      "bbox_max": [
        -891.3015747070312,
        -2497.905517578125,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -906.3084716796875,
        -2503.815185546875,
        667.6315307617188
      ],
      "bbox_max": [
        -903.125732421875,
        -2497.905517578125,
        669.7528686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -933.75,
        -2640.0,
        668.3117065429688
      ],
      "bbox_max": [
        -889.9989624023438,
        -2502.209716796875,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -898.75,
        -2640.0,
        758.7876586914062
      ],
      "bbox_max": [
        -891.8818969726562,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -914.9521484375,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -957.8712158203125,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.376953125,
        760.302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -924.609375,
        -2640.0,
        641.370849609375
      ],
      "bbox_max": [
        -826.6605834960938,
        -2495.885009765625,
        666.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038054414093494415,
        0.13913646340370178,
        0.98954176902771
      ],
      "plane_d": -254.50421142578125,
      "bbox_min": [
        -924.609375,
        -2640.0,
        641.370849609375
      ],
      "bbox_max": [
        -826.6605834960938,
        -2495.885009765625,
        666.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -879.0,
        -2576.875,
        641.5447998046875
      ],
      "bbox_max": [
        -832.8280639648438,
        -2497.705078125,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.794124960899353,
        0.5035092234611511,
        0.3403586447238922
      ],
      "plane_d": 381.9332275390625,
      "bbox_min": [
        -841.7667236328125,
        -2520.411376953125,
        641.5447998046875
      ],
      "bbox_max": [
        -832.8280639648438,
        -2505.729736328125,
        643.9255981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7906190752983093,
        0.49548137187957764,
        0.3597496747970581
      ],
      "plane_d": 352.2090148925781,
      "bbox_min": [
        -841.7667236328125,
        -2520.411376953125,
        641.796875
      ],
      "bbox_max": [
        -838.2353515625,
        -2515.308837890625,
        643.9255981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -879.0,
        -2519.998046875,
        641.5477905273438
      ],
      "bbox_max": [
        -833.508544921875,
        -2497.705078125,
        641.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -869.765625,
        -2577.1015625,
        641.370849609375
      ],
      "bbox_max": [
        -826.6605834960938,
        -2495.885009765625,
        655.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7906190752983093,
        0.49548137187957764,
        0.3597496747970581
      ],
      "plane_d": 352.2090148925781,
      "bbox_min": [
        -841.05712890625,
        -2520.764404296875,
        643.0996704101562
      ],
      "bbox_max": [
        -835.4375610351562,
        -2511.593994140625,
        645.7434692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -833.508544921875,
        -2505.729736328125,
        641.370849609375
      ],
      "bbox_max": [
        -826.6605834960938,
        -2495.885009765625,
        641.5477905273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -869.765625,
        -2577.1015625,
        641.3817749023438
      ],
      "bbox_max": [
        -828.005615234375,
        -2495.947265625,
        655.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -869.765625,
        -2577.1015625,
        652.96875
      ],
      "bbox_max": [
        -865.4737548828125,
        -2570.660888671875,
        655.6448364257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -865.96435546875,
        -2499.665283203125,
        641.6211547851562
      ],
      "bbox_max": [
        -857.4056396484375,
        -2497.308837890625,
        641.6907958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7571871280670166,
        0.14177244901657104,
        -0.6376270055770874
      ],
      "plane_d": 151.26864624023438,
      "bbox_min": [
        -932.1755981445312,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.376953125,
        760.302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -892.0723266601562,
        -2640.0,
        658.9685668945312
      ],
      "bbox_max": [
        -824.0,
        -2403.040283203125,
        760.302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -892.0723266601562,
        -2640.0,
        658.9685668945312
      ],
      "bbox_max": [
        -824.0,
        -2403.040283203125,
        760.302978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.10595703125,
        -2640.0,
        684.7120361328125
      ],
      "bbox_max": [
        -860.8434448242188,
        -2585.10986328125,
        705.8839111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -891.8812866210938,
        -2640.0,
        684.7179565429688
      ],
      "bbox_max": [
        -862.9396362304688,
        -2571.875,
        731.292236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -891.8812866210938,
        -2587.13720703125,
        719.03125
      ],
      "bbox_max": [
        -887.265625,
        -2571.875,
        731.292236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7724054455757141,
        0.19714896380901337,
        -0.6037565469741821
      ],
      "plane_d": 255.83349609375,
      "bbox_min": [
        -932.1755981445312,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.376953125,
        723.4655151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -891.8904418945312,
        -2640.0,
        679.010009765625
      ],
      "bbox_max": [
        -860.625,
        -2571.875,
        723.4655151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -891.8904418945312,
        -2585.10986328125,
        682.5
      ],
      "bbox_max": [
        -860.625,
        -2571.875,
        723.4655151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -891.8904418945312,
        -2576.5830078125,
        719.03125
      ],
      "bbox_max": [
        -887.265625,
        -2571.875,
        723.4655151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -932.1755981445312,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.376953125,
        723.4274291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -924.609375,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2384.376953125,
        723.4274291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -892.94775390625,
        -2576.531494140625,
        646.86328125
      ],
      "bbox_max": [
        -824.0,
        -2384.376953125,
        723.4274291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262522339820862,
        0.08588957786560059
      ],
      "plane_d": -911.859375,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -824.0,
        -2384.376953125,
        665.213623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -892.94775390625,
        -2576.531494140625,
        646.86328125
      ],
      "bbox_max": [
        -824.0,
        -2384.515869140625,
        723.4274291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -892.94775390625,
        -2576.531494140625,
        719.03125
      ],
      "bbox_max": [
        -887.265625,
        -2570.603515625,
        723.4274291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -924.609375,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2393.66357421875,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -833.6382446289062,
        -2404.50830078125,
        642.4641723632812
      ],
      "bbox_max": [
        -824.0,
        -2393.66357421875,
        651.4063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038054414093494415,
        0.13913646340370178,
        0.98954176902771
      ],
      "plane_d": -254.50421142578125,
      "bbox_min": [
        -924.609375,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2396.299072265625,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -890.0479736328125,
        -2498.308837890625,
        641.6907958984375
      ],
      "bbox_max": [
        -865.96435546875,
        -2491.873046875,
        641.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -890.0479736328125,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2396.299072265625,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.0274047851562,
        -2640.0,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2396.299072265625,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -868.9373168945312,
        -2579.375,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2396.299072265625,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -865.4737548828125,
        -2570.660888671875,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2396.299072265625,
        665.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7906190752983093,
        0.49548137187957764,
        0.3597496747970581
      ],
      "plane_d": 352.2090148925781,
      "bbox_min": [
        -840.451171875,
        -2524.685546875,
        641.2958374023438
      ],
      "bbox_max": [
        -824.0,
        -2491.637939453125,
        665.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.794124960899353,
        0.5035092234611511,
        0.3403586447238922
      ],
      "plane_d": 381.9332275390625,
      "bbox_min": [
        -835.4375610351562,
        -2511.593994140625,
        641.2958374023438
      ],
      "bbox_max": [
        -824.0,
        -2491.637939453125,
        648.3512573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -832.4124145507812,
        -2410.626220703125,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2396.299072265625,
        647.2273559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -830.384033203125,
        -2405.9833984375,
        640.2296142578125
      ],
      "bbox_max": [
        -824.0,
        -2397.08740234375,
        641.1480712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2859.5,
      "bbox_min": [
        -1070.0,
        -2930.0,
        650.0
      ],
      "bbox_max": [
        -824.0,
        -2640.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -959.8472290039062,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2919.999755859375,
      "bbox_min": [
        -906.0615234375,
        -2930.0,
        769.9266357421875
      ],
      "bbox_max": [
        -877.9636840820312,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": -1200.1966552734375,
      "bbox_min": [
        -906.0615234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -902.3636474609375,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0615234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -953.0294189453125,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8156455159187317,
        -0.09158384799957275,
        -0.5712573528289795
      ],
      "plane_d": -519.972900390625,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -914.6135864257812,
        -2920.0,
        790.1911010742188
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.22314453125,
        -2863.125,
        790.1911010742188
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        792.14794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -870.625,
        -2863.125,
        790.1911010742188
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920820951461792,
        0.2899842858314514,
        0.26076391339302063
      ],
      "plane_d": -177.9209442138672,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.4382934570312,
        -2930.0,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -889.6334228515625,
        -2920.0,
        784.3419189453125
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        816.5783081054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.5030517578125,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.7681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162713289260864,
        0.28804752230644226,
        0.27834439277648926
      ],
      "plane_d": -193.42660522460938,
      "bbox_min": [
        -932.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -889.681884765625,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -889.681884765625,
        -2920.0,
        761.111083984375
      ],
      "bbox_max": [
        -877.9344482421875,
        -2859.5,
        790.3522338867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2919.999755859375,
      "bbox_min": [
        -889.681884765625,
        -2920.0,
        788.0
      ],
      "bbox_max": [
        -888.96728515625,
        -2920.0,
        790.3522338867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -927.2113037109375,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.5282592773438,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.9566040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        842.5675659179688
      ],
      "bbox_max": [
        -906.88134765625,
        -2916.164306640625,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2920.0,
        842.5675659179688
      ],
      "bbox_max": [
        -914.0,
        -2916.164306640625,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2920.0,
        817.4066162109375
      ],
      "bbox_max": [
        -889.0310668945312,
        -2859.5,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        817.4066162109375
      ],
      "bbox_max": [
        -889.0310668945312,
        -2859.5,
        843.216552734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -899.84375,
        -2863.125,
        821.4066162109375
      ],
      "bbox_max": [
        -891.8325805664062,
        -2859.5,
        833.59375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.8587036132812,
        -2863.125,
        791.875
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        840.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        838.0
      ],
      "bbox_max": [
        -901.729248046875,
        -2920.0,
        840.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8115347027778625,
        0.0,
        -0.5843042731285095
      ],
      "plane_d": -245.60345458984375,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -906.0,
        -2920.0,
        807.571044921875
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        838.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2919.999755859375,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -884.0911865234375,
        -2920.0,
        821.3333129882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -894.0,
        -2930.0,
        789.7291870117188
      ],
      "bbox_max": [
        -890.5786743164062,
        -2923.890625,
        792.794677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -894.0,
        -2920.0,
        792.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -901.9560546875,
        -2920.0,
        792.9763793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -903.77392578125,
        -2920.0,
        792.9763793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -953.0294189453125,
        -2930.0,
        832.5732421875
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -951.1181640625,
        -2920.0,
        843.216552734375
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -953.0294189453125,
        -2930.0,
        832.5732421875
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        843.216552734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -940.6522827148438,
        -2920.0,
        838.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2712.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        650.0
      ],
      "bbox_max": [
        -824.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1070.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -970.0,
        -2677.65380859375,
        752.3527221679688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1070.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -970.0,
        -2677.65380859375,
        695.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1070.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        -1070.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -1070.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -1070.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1067.9998779296875,
      "bbox_min": [
        -1070.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2705.0,
      "bbox_min": [
        -1070.0,
        -2711.0,
        650.0
      ],
      "bbox_max": [
        -1068.0,
        -2705.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2711.0,
      "bbox_min": [
        -1070.0,
        -2711.0,
        650.0
      ],
      "bbox_max": [
        -1068.0,
        -2705.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        -1070.0,
        -2711.0,
        660.0
      ],
      "bbox_max": [
        -1068.0,
        -2705.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1061.25,
      "bbox_min": [
        -1068.0,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        660.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2693.0,
      "bbox_min": [
        -1068.0,
        -2693.0,
        650.0
      ],
      "bbox_max": [
        -1061.25,
        -2690.0,
        660.75
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -2041.9207763671875,
      "bbox_min": [
        -1068.0,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1061.25,
        -2690.0,
        660.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1064.25,
      "bbox_min": [
        -1067.5,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1061.75,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.5,
      "bbox_min": [
        -1067.5,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1065.0,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.5,
      "bbox_min": [
        -1067.5,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1065.0,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1065.0,
      "bbox_min": [
        -1067.5,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1065.0,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -1067.5,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1065.0,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        -1067.5,
        -2693.0,
        657.25
      ],
      "bbox_max": [
        -1065.0,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.5,
      "bbox_min": [
        -1064.25,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1061.75,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1061.75,
      "bbox_min": [
        -1064.25,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1061.75,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -1064.25,
        -2693.0,
        651.0
      ],
      "bbox_max": [
        -1061.75,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        -1064.25,
        -2693.0,
        657.25
      ],
      "bbox_max": [
        -1061.75,
        -2690.5,
        657.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2692.5,
      "bbox_min": [
        -1056.75,
        -2712.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        657.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1046.0,
      "bbox_min": [
        -1049.5,
        -2692.5,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1042.5,
      "bbox_min": [
        -1046.0,
        -2692.5,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -657.5,
      "bbox_min": [
        -1042.5,
        -2692.5,
        657.5
      ],
      "bbox_max": [
        -1040.0,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1043.5,
      "bbox_min": [
        -1046.0,
        -2692.5,
        650.0
      ],
      "bbox_max": [
        -1043.5,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -657.5,
      "bbox_min": [
        -1046.0,
        -2692.5,
        657.5
      ],
      "bbox_max": [
        -1043.5,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1049.5,
      "bbox_min": [
        -1049.5,
        -2692.5,
        650.0
      ],
      "bbox_max": [
        -1047.0,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1047.0,
      "bbox_min": [
        -1049.5,
        -2692.5,
        650.0
      ],
      "bbox_max": [
        -1047.0,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -657.5,
      "bbox_min": [
        -1049.5,
        -2692.5,
        657.5
      ],
      "bbox_max": [
        -1047.0,
        -2690.0,
        657.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -652.5,
      "bbox_min": [
        -1056.75,
        -2712.0,
        652.0
      ],
      "bbox_max": [
        -1042.5885009765625,
        -2708.904296875,
        656.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -1056.75,
        -2712.0,
        652.0
      ],
      "bbox_max": [
        -1043.050048828125,
        -2709.35009765625,
        652.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2709.35009765625,
      "bbox_min": [
        -1056.75,
        -2712.0,
        652.0
      ],
      "bbox_max": [
        -1043.050048828125,
        -2709.35009765625,
        652.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1056.75,
      "bbox_min": [
        -1056.75,
        -2712.0,
        652.0
      ],
      "bbox_max": [
        -1043.050048828125,
        -2709.35009765625,
        652.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1043.050048828125,
      "bbox_min": [
        -1043.050048828125,
        -2712.0,
        652.0
      ],
      "bbox_max": [
        -1043.050048828125,
        -2709.35009765625,
        652.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15551351010799408,
        -0.18532076478004456,
        0.970294713973999
      ],
      "plane_d": -976.5799560546875,
      "bbox_min": [
        -1047.4583740234375,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.5885009765625,
        -2708.904296875,
        656.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6237318515777588,
        0.7432824373245239,
        0.24184662103652954
      ],
      "plane_d": 1203.4068603515625,
      "bbox_min": [
        -1047.4583740234375,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.5885009765625,
        -2708.904296875,
        656.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7660663723945618,
        -0.6427614688873291,
        -3.8601458072662354e-05
      ],
      "plane_d": -2544.81591796875,
      "bbox_min": [
        -1047.4583740234375,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.5885009765625,
        -2708.904296875,
        656.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6236733198165894,
        -0.7433067560195923,
        -0.2419227659702301
      ],
      "plane_d": -1206.9840087890625,
      "bbox_min": [
        -1047.4583740234375,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.5885009765625,
        -2708.904296875,
        656.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2709.35009765625,
      "bbox_min": [
        -1047.4583740234375,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.5885009765625,
        -2708.904296875,
        656.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7660566568374634,
        0.6427730917930603,
        -2.2313954104902223e-05
      ],
      "plane_d": 2541.877197265625,
      "bbox_min": [
        -1047.4583740234375,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.5885009765625,
        -2709.35009765625,
        656.4541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1045.7498779296875,
      "bbox_min": [
        -1047.4583740234375,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.9771728515625,
        -2709.35009765625,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15549270808696747,
        0.1853194236755371,
        -0.9702982902526855
      ],
      "plane_d": 974.1004638671875,
      "bbox_min": [
        -1045.7498779296875,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1042.9771728515625,
        -2709.35009765625,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1044.4500732421875,
      "bbox_min": [
        -1045.7498779296875,
        -2712.0,
        653.3234252929688
      ],
      "bbox_max": [
        -1044.4500732421875,
        -2710.75,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2710.75,
      "bbox_min": [
        -1045.7498779296875,
        -2710.75,
        653.5621337890625
      ],
      "bbox_max": [
        -1044.4500732421875,
        -2710.75,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -22.68560791015625,
      "bbox_min": [
        -1044.4500732421875,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1043.4500732421875,
        -2710.2939453125,
        653.4505615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1044.4500732421875,
      "bbox_min": [
        -1044.4500732421875,
        -2711.334228515625,
        653.0999755859375
      ],
      "bbox_max": [
        -1044.4500732421875,
        -2710.75,
        653.5621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -1098.052490234375,
      "bbox_min": [
        -1046.7498779296875,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1045.7498779296875,
        -2709.75,
        653.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": 834.5929565429688,
      "bbox_min": [
        -1044.450439453125,
        -2710.2939453125,
        652.5
      ],
      "bbox_max": [
        -1043.4500732421875,
        -2709.75,
        652.8263549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7660566568374634,
        0.6427730917930603,
        -2.2313954104902223e-05
      ],
      "plane_d": 2541.877197265625,
      "bbox_min": [
        -1045.6912841796875,
        -2709.35009765625,
        653.88330078125
      ],
      "bbox_max": [
        -1044.785888671875,
        -2708.904296875,
        656.3633422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15549270808696747,
        0.1853194236755371,
        -0.9702982902526855
      ],
      "plane_d": 974.1004638671875,
      "bbox_min": [
        -1045.6912841796875,
        -2709.35009765625,
        653.88330078125
      ],
      "bbox_max": [
        -1044.7860107421875,
        -2708.904296875,
        654.0283813476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -22.68560791015625,
      "bbox_min": [
        -1043.7587890625,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1043.4500732421875,
        -2711.6806640625,
        652.6851806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -1098.052490234375,
      "bbox_min": [
        -1046.7498779296875,
        -2712.0,
        652.5
      ],
      "bbox_max": [
        -1046.4786376953125,
        -2711.6767578125,
        652.6627807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2709.35009765625,
      "bbox_min": [
        -1047.3499755859375,
        -2709.35009765625,
        652.5
      ],
      "bbox_max": [
        -1045.7022705078125,
        -2709.35009765625,
        654.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -971.9118041992188,
        -2710.0,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -894.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -853.0,
        -2674.543212890625,
        752.3528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -853.125,
        -2674.543212890625,
        752.3528442382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -870.4964599609375,
        -2697.0,
        678.9081420898438
      ],
      "bbox_max": [
        -856.3112182617188,
        -2674.543212890625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -870.4964599609375,
        -2697.0,
        678.9081420898438
      ],
      "bbox_max": [
        -864.9321899414062,
        -2674.543212890625,
        694.219482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2695.5,
        752.3528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -868.5,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2695.5,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -868.5,
        -2700.0,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        728.8235473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -856.3504028320312,
        -2697.0,
        720.0
      ],
      "bbox_max": [
        -855.4293823242188,
        -2696.22900390625,
        722.940673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -856.40234375,
        -2696.355224609375,
        720.0
      ],
      "bbox_max": [
        -855.9296264648438,
        -2695.500244140625,
        721.4287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -1015.0,
        -2712.0,
        658.0
      ],
      "bbox_max": [
        -841.0,
        -2640.0,
        860.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        658.0
      ],
      "bbox_max": [
        -858.5,
        -2650.0,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -1015.0,
        -2712.0,
        665.7777709960938
      ],
      "bbox_max": [
        -853.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -858.5,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -882.9166870117188,
        -2645.0,
        704.4489135742188
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        742.6649169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -864.775634765625,
        -2645.0,
        705.4423828125
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        708.57958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.125,
        -2645.0,
        705.4423828125
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        707.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.4918212890625,
        -2645.0,
        704.4489135742188
      ],
      "bbox_max": [
        -863.10595703125,
        -2640.0,
        707.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -932.0,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -862.1634521484375,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -876.8843383789062,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -875.80322265625,
        -2645.0,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -932.0,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -862.1634521484375,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -878.75,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -862.1634521484375,
        -2640.0,
        710.0059814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.75,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2650.0,
        757.0
      ],
      "bbox_max": [
        -888.2786865234375,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -915.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -909.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -921.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -921.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -927.0,
        -2650.0,
        757.0
      ],
      "bbox_max": [
        -888.2786865234375,
        -2640.0,
        775.49560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -915.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -915.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -915.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": -1116.6708984375,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.763513445854187,
        -0.0,
        -0.6457920074462891
      ],
      "plane_d": -200.36721801757812,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        725.420166015625
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -932.0,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -932.0,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        714.3930053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        730.5896606445312
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        737.9435424804688
      ],
      "bbox_max": [
        -858.5,
        -2697.0,
        762.2891845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        752.6119384765625
      ],
      "bbox_max": [
        -868.5,
        -2700.0,
        762.2891845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -854.1096801757812,
        -2695.682861328125,
        730.1375122070312
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        731.486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -855.9295654296875,
        -2696.228759765625,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        729.67822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.5,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        -932.0,
        -2679.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2668.288818359375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -898.28125,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -890.8987426757812,
        -2697.0,
        795.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -873.6409912109375,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.5,
        -2660.0,
        762.09228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        721.4291381835938
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        762.09228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -868.5,
        -2700.0,
        721.4291381835938
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        752.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -991.0,
        -2660.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -988.625,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -988.625,
        -2645.0,
        705.8635864257812
      ],
      "bbox_max": [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -952.901611328125,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -932.0,
        -2647.400634765625,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -934.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -940.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -952.901611328125,
        -2647.400634765625,
        668.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -953.8565673828125,
        -2660.0,
        775.49560546875
      ],
      "bbox_max": [
        -932.0,
        -2650.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -972.8922729492188,
        -2712.0,
        748.4310302734375
      ],
      "bbox_max": [
        -932.0,
        -2697.0,
        795.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -873.5,
        -2859.5,
        683.0
      ],
      "bbox_max": [
        -824.0,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2762.5,
        695.5555419921875
      ],
      "bbox_max": [
        -863.1127319335938,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -873.5,
        -2781.199951171875,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        783.045654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -873.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2735.5,
        735.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2748.5,
      "bbox_min": [
        -872.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2741.5,
      "bbox_min": [
        -872.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -872.5,
        -2748.5,
        730.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -872.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -872.5,
        -2754.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -873.5,
        -2859.5,
        748.3642578125
      ],
      "bbox_max": [
        -871.5,
        -2775.000244140625,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -873.5,
        -2846.85400390625,
        748.3642578125
      ],
      "bbox_max": [
        -871.5,
        -2830.819580078125,
        763.2899169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -873.5,
        -2788.75,
        782.2899780273438
      ],
      "bbox_max": [
        -871.5,
        -2775.000244140625,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -872.3709106445312,
        -2712.0,
        764.8575439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -872.3709106445312,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2766169011592865,
        0.9609803557395935,
        0.0
      ],
      "plane_d": 2415.906982421875,
      "bbox_min": [
        -853.0,
        -2757.53857421875,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2735.5,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -830.288330078125,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2751.18994140625,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -835.5,
      "bbox_min": [
        -853.0,
        -2754.5,
        718.0
      ],
      "bbox_max": [
        -824.0,
        -2735.5,
        744.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2737.0,
      "bbox_min": [
        -835.5,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -835.5,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -824.0,
        -2737.0,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2741.5,
      "bbox_min": [
        -835.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -834.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -835.5,
        -2748.5,
        730.0
      ],
      "bbox_max": [
        -834.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -853.0,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -835.5,
        -2741.5,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -835.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -719.0,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -841.5,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -841.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -839.5,
      "bbox_min": [
        -839.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -837.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -835.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -837.5,
      "bbox_min": [
        -837.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -837.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        792.4702758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -871.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        790.45849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -864.6350708007812,
        -2795.0,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2791.659423828125,
        765.134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2830.819580078125,
        720.0
      ],
      "bbox_max": [
        -855.143798828125,
        -2784.784912109375,
        762.859619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -866.8314208984375,
        -2792.40966796875,
        720.0
      ],
      "bbox_max": [
        -862.1342163085938,
        -2791.00048828125,
        731.2930297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -863.8129272460938,
        -2794.5068359375,
        731.0692138671875
      ],
      "bbox_max": [
        -855.143798828125,
        -2791.906005859375,
        762.859619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -871.5,
        -2799.7216796875,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        782.2899780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.0
      ],
      "bbox_max": [
        -869.5,
        -2712.0,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -871.5,
        -2713.5,
        720.0
      ],
      "bbox_max": [
        -870.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -871.5,
        -2788.75,
        781.3698120117188
      ],
      "bbox_max": [
        -869.0645141601562,
        -2781.199951171875,
        784.2052612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        -1070.0,
        -2852.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.26195064187049866,
        0.0,
        -0.9650813341140747
      ],
      "plane_d": 1079.0987548828125,
      "bbox_min": [
        -1070.0,
        -2852.0,
        822.7142944335938
      ],
      "bbox_max": [
        -970.0,
        -2822.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2829.999755859375,
      "bbox_min": [
        -1070.0,
        -2852.0,
        822.7142944335938
      ],
      "bbox_max": [
        -970.0,
        -2822.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2830.0,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -839.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2830.0,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2830.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -980.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -980.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2852.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 989.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -980.0,
        -2830.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -980.0,
        -2852.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -2821.999755859375,
      "bbox_min": [
        -1070.0,
        -2830.0,
        822.7142944335938
      ],
      "bbox_max": [
        -980.0,
        -2822.0,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.26195064187049866,
        0.0,
        0.9650813341140747
      ],
      "plane_d": -1074.2734375,
      "bbox_min": [
        -1070.0,
        -2830.0,
        822.7142944335938
      ],
      "bbox_max": [
        -980.0,
        -2822.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -839.0,
      "bbox_min": [
        -1010.0,
        -2830.0,
        839.0
      ],
      "bbox_max": [
        -980.0,
        -2822.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -991.579345703125,
        -2830.0,
        839.0
      ],
      "bbox_max": [
        -980.0,
        -2822.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        -980.0,
        -2830.0,
        839.0
      ],
      "bbox_max": [
        -980.0,
        -2822.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -1010.0,
        -2830.0,
        844.0
      ],
      "bbox_max": [
        -991.579345703125,
        -2822.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1070.0,
        -2831.384521484375,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1070.0,
        -2831.384521484375,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2774.0,
        748.6153564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1070.0,
        -2800.0,
        720.0
      ],
      "bbox_max": [
        -1045.0,
        -2774.0,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -1070.0,
        -2800.0,
        720.0
      ],
      "bbox_max": [
        -1047.0,
        -2774.0,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2785.60009765625,
      "bbox_min": [
        -1070.0,
        -2800.0,
        720.0
      ],
      "bbox_max": [
        -1047.0,
        -2785.0,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        -1070.0,
        -2785.60009765625,
        720.0
      ],
      "bbox_max": [
        -1053.0,
        -2785.0,
        725.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1053.0,
      "bbox_min": [
        -1053.0,
        -2785.60009765625,
        720.0
      ],
      "bbox_max": [
        -1053.0,
        -2785.0,
        725.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 733.5,
      "bbox_min": [
        -1066.5,
        -2800.0,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2797.374755859375,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -1066.5,
        -2800.0,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2797.374755859375,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1047.0,
      "bbox_min": [
        -1047.0,
        -2800.0,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2797.374755859375,
        734.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 733.9999389648438,
      "bbox_min": [
        -1066.5,
        -2800.0,
        734.0
      ],
      "bbox_max": [
        -1064.0,
        -2798.499755859375,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1064.0,
      "bbox_min": [
        -1066.5,
        -2800.0,
        734.0
      ],
      "bbox_max": [
        -1064.0,
        -2798.499755859375,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1066.5,
      "bbox_min": [
        -1066.5,
        -2800.0,
        734.0
      ],
      "bbox_max": [
        -1066.5,
        -2798.499755859375,
        734.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2778.0,
      "bbox_min": [
        -1070.0,
        -2778.345703125,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        725.0023803710938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -723.0,
      "bbox_min": [
        -1070.0,
        -2778.0,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        724.8889770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 722.5,
      "bbox_min": [
        -1070.0,
        -2778.0,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1053.0,
      "bbox_min": [
        -1053.0,
        -2778.0,
        722.5
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        723.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1053.0,
        -2776.5,
        722.5
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1052.0,
      "bbox_min": [
        -1053.0,
        -2776.5,
        722.5
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1053.0,
        -2776.5,
        722.5
      ],
      "bbox_max": [
        -1052.0,
        -2776.5,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1070.0,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        722.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1070.0,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        722.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5812382102012634,
        0.0,
        -0.8137334585189819
      ],
      "plane_d": 1201.128662109375,
      "bbox_min": [
        -1058.5,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        722.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1052.0,
      "bbox_min": [
        -1053.0,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        722.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -1053.0,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1053.0,
        -2775.5,
        722.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6237319111824036,
        -0.7432824969291687,
        0.24184662103652954
      ],
      "plane_d": -1575.1790771484375,
      "bbox_min": [
        -1070.0,
        -2778.0,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.199951171875,
        724.8889770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1070.0,
        -2776.5,
        723.0
      ],
      "bbox_max": [
        -1069.0,
        -2775.5,
        724.2223510742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1070.0,
        -2775.5,
        723.0
      ],
      "bbox_max": [
        -1069.0,
        -2775.5,
        723.7779541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1068.60302734375,
        -2778.0,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2774.199951171875,
        724.8889770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6236686110496521,
        0.7433011531829834,
        -0.2419523298740387
      ],
      "plane_d": 1571.875,
      "bbox_min": [
        -1068.60302734375,
        -2775.744140625,
        723.6817016601562
      ],
      "bbox_max": [
        -1068.0238037109375,
        -2775.283447265625,
        723.8704223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -72.15533447265625,
      "bbox_min": [
        -1068.0999755859375,
        -2777.5,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2774.199951171875,
        724.222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": 807.29736328125,
      "bbox_min": [
        -1068.0999755859375,
        -2777.5,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2774.199951171875,
        724.1290893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -1169.490478515625,
      "bbox_min": [
        -1068.0999755859375,
        -2777.5,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2774.199951171875,
        724.1290893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": -2048.943359375,
      "bbox_min": [
        -1068.0999755859375,
        -2777.5,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2776.5,
        723.9899291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1067.0999755859375,
        -2776.5,
        723.5999755859375
      ],
      "bbox_max": [
        -1066.449951171875,
        -2776.5,
        724.1290893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.199951171875,
      "bbox_min": [
        -1067.0999755859375,
        -2775.486328125,
        723.5999755859375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        723.7718505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1067.0999755859375,
      "bbox_min": [
        -1067.0999755859375,
        -2775.486328125,
        723.5999755859375
      ],
      "bbox_max": [
        -1067.0999755859375,
        -2775.199951171875,
        723.7718505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1065.800048828125,
      "bbox_min": [
        -1066.681884765625,
        -2776.5,
        723.5999755859375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        724.222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1066.681884765625,
        -2776.5,
        723.5999755859375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        724.222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.199951171875,
      "bbox_min": [
        -1065.874267578125,
        -2775.199951171875,
        723.5999755859375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        723.64453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1053.0,
        -2776.5,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        724.2222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1052.0,
      "bbox_min": [
        -1053.0,
        -2776.5,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        724.2222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -1053.0,
        -2776.5,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        724.2222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1053.0,
        -2775.5,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        723.7778930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1066.679931640625,
        -2778.345703125,
        724.4158935546875
      ],
      "bbox_max": [
        -1065.9779052734375,
        -2778.0,
        725.0023803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7660508751869202,
        -0.6427800059318542,
        -5.8613717555999756e-05
      ],
      "plane_d": -2602.7314453125,
      "bbox_min": [
        -1066.679931640625,
        -2778.345703125,
        724.4158935546875
      ],
      "bbox_max": [
        -1066.389892578125,
        -2778.0,
        725.0023803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -1070.0,
        -2800.0,
        723.64453125
      ],
      "bbox_max": [
        -1045.0,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1057.4000244140625,
      "bbox_min": [
        -1070.0,
        -2800.0,
        723.64453125
      ],
      "bbox_max": [
        -1047.0,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1054.4000244140625,
      "bbox_min": [
        -1057.4000244140625,
        -2800.0,
        723.7778930664062
      ],
      "bbox_max": [
        -1047.0,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 734.4000244140625,
      "bbox_min": [
        -1057.4000244140625,
        -2798.800048828125,
        733.2727661132812
      ],
      "bbox_max": [
        -1054.4000244140625,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2777.60009765625,
      "bbox_min": [
        -1057.4000244140625,
        -2777.60009765625,
        734.4000244140625
      ],
      "bbox_max": [
        -1054.4000244140625,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1056.2999267578125,
        -2776.5,
        734.4000244140625
      ],
      "bbox_max": [
        -1054.469970703125,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1056.2999267578125,
        -2776.5,
        734.4000244140625
      ],
      "bbox_max": [
        -1054.469970703125,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6726809740066528,
        -0.0,
        -0.739932656288147
      ],
      "plane_d": -166.702392578125,
      "bbox_min": [
        -1056.2999267578125,
        -2776.5,
        734.4000244140625
      ],
      "bbox_max": [
        -1054.469970703125,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6896594166755676,
        -0.0,
        0.7241339683532715
      ],
      "plane_d": 195.421142578125,
      "bbox_min": [
        -1055.0999755859375,
        -2776.5,
        734.4000244140625
      ],
      "bbox_max": [
        -1054.469970703125,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6726809740066528,
        -0.0,
        -0.739932656288147
      ],
      "plane_d": -166.702392578125,
      "bbox_min": [
        -1055.6400146484375,
        -2776.5,
        733.2727661132812
      ],
      "bbox_max": [
        -1054.4000244140625,
        -2775.5,
        734.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1055.6400146484375,
        -2776.5,
        733.2727661132812
      ],
      "bbox_max": [
        -1054.4000244140625,
        -2775.5,
        734.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1055.6400146484375,
        -2776.5,
        733.2727661132812
      ],
      "bbox_max": [
        -1054.4000244140625,
        -2775.5,
        734.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6896594166755676,
        -0.0,
        0.7241339683532715
      ],
      "plane_d": 195.421142578125,
      "bbox_min": [
        -1054.469970703125,
        -2776.5,
        734.3333740234375
      ],
      "bbox_max": [
        -1054.4000244140625,
        -2775.5,
        734.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1054.4000244140625,
        -2800.0,
        723.7778930664062
      ],
      "bbox_max": [
        -1047.0,
        -2775.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1052.0,
      "bbox_min": [
        -1054.4000244140625,
        -2776.5,
        723.7778930664062
      ],
      "bbox_max": [
        -1047.0,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1054.4000244140625,
        -2776.5,
        723.7778930664062
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -1054.4000244140625,
        -2776.5,
        723.7778930664062
      ],
      "bbox_max": [
        -1053.0,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6896594166755676,
        -0.0,
        0.7241339683532715
      ],
      "plane_d": 195.421142578125,
      "bbox_min": [
        -1054.4000244140625,
        -2776.5,
        732.0
      ],
      "bbox_max": [
        -1053.0,
        -2775.5,
        734.3333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6726809740066528,
        -0.0,
        -0.739932656288147
      ],
      "plane_d": -166.702392578125,
      "bbox_min": [
        -1054.4000244140625,
        -2776.5,
        732.0
      ],
      "bbox_max": [
        -1053.0,
        -2775.5,
        733.2727661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2481.94482421875,
      "bbox_min": [
        -1051.0,
        -2776.5,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1047.0,
      "bbox_min": [
        -1051.0,
        -2776.5,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1050.9998779296875,
      "bbox_min": [
        -1051.0,
        -2776.5,
        733.5
      ],
      "bbox_max": [
        -1051.0,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 733.5,
      "bbox_min": [
        -1052.5,
        -2800.0,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2776.5,
        735.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9743912220001221,
        0.22485950589179993,
        0.0
      ],
      "plane_d": -398.86334228515625,
      "bbox_min": [
        -1052.5,
        -2800.0,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2776.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1047.0,
      "bbox_min": [
        -1052.5,
        -2800.0,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2776.5,
        735.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -1052.5,
        -2800.0,
        733.5
      ],
      "bbox_max": [
        -1052.5,
        -2787.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1051.0,
      "bbox_min": [
        -1051.0,
        -2780.5,
        733.5
      ],
      "bbox_max": [
        -1051.0,
        -2776.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -1070.0,
        -2800.0,
        723.64453125
      ],
      "bbox_max": [
        -1060.0,
        -2774.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1069.0,
      "bbox_min": [
        -1070.0,
        -2800.0,
        723.64453125
      ],
      "bbox_max": [
        -1060.0,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1070.0,
        -2776.5,
        723.7779541015625
      ],
      "bbox_max": [
        -1069.0,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1070.0,
        -2776.5,
        724.2223510742188
      ],
      "bbox_max": [
        -1069.0,
        -2776.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1062.5,
      "bbox_min": [
        -1069.0,
        -2800.0,
        723.64453125
      ],
      "bbox_max": [
        -1060.0,
        -2774.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 734.0,
      "bbox_min": [
        -1062.5,
        -2795.0,
        734.0
      ],
      "bbox_max": [
        -1060.0,
        -2777.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2795.0,
      "bbox_min": [
        -1062.5,
        -2795.0,
        734.0
      ],
      "bbox_max": [
        -1060.0,
        -2795.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15551012754440308,
        0.18531674146652222,
        0.9702960252761841
      ],
      "plane_d": -356.4674377441406,
      "bbox_min": [
        -1069.0,
        -2800.0,
        723.64453125
      ],
      "bbox_max": [
        -1062.5,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7660508751869202,
        -0.6427800059318542,
        -5.8613717555999756e-05
      ],
      "plane_d": -2602.7314453125,
      "bbox_min": [
        -1068.9615478515625,
        -2778.255126953125,
        723.64453125
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7660439610481262,
        0.642788290977478,
        -8.769334272074047e-06
      ],
      "plane_d": 2599.7958984375,
      "bbox_min": [
        -1068.9615478515625,
        -2778.255126953125,
        723.64453125
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6237319111824036,
        -0.7432824969291687,
        0.24184662103652954
      ],
      "plane_d": -1575.1790771484375,
      "bbox_min": [
        -1068.9615478515625,
        -2778.255126953125,
        723.64453125
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6236686110496521,
        0.7433011531829834,
        -0.2419523298740387
      ],
      "plane_d": 1571.875,
      "bbox_min": [
        -1068.9615478515625,
        -2777.188720703125,
        723.64453125
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.199951171875,
      "bbox_min": [
        -1068.0238037109375,
        -2777.188720703125,
        723.64453125
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        725.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1065.800048828125,
      "bbox_min": [
        -1068.0238037109375,
        -2777.188720703125,
        723.64453125
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2775.199951171875,
        725.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1067.0999755859375,
      "bbox_min": [
        -1068.0238037109375,
        -2776.689697265625,
        723.64453125
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        725.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1067.0999755859375,
        -2776.689697265625,
        723.8138427734375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        725.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1067.0999755859375,
        -2776.5,
        724.222412109375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2776.5,
        725.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1066.0994873046875,
        -2776.5,
        724.222412109375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2776.5,
        724.2703857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1068.0238037109375,
        -2775.86767578125,
        723.6817016601562
      ],
      "bbox_max": [
        -1067.0999755859375,
        -2775.199951171875,
        723.9413452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1065.800048828125,
        -2777.188720703125,
        724.0221557617188
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2775.199951171875,
        724.5283813476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1067.92431640625,
        -2775.199951171875,
        723.6817016601562
      ],
      "bbox_max": [
        -1065.11328125,
        -2774.0,
        724.1322021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2792.5,
      "bbox_min": [
        -1069.0,
        -2800.0,
        732.0
      ],
      "bbox_max": [
        -1062.5,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1066.5,
      "bbox_min": [
        -1066.5,
        -2800.0,
        734.0
      ],
      "bbox_max": [
        -1062.5,
        -2792.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 733.9999389648438,
      "bbox_min": [
        -1066.5,
        -2800.0,
        734.0
      ],
      "bbox_max": [
        -1062.5,
        -2792.5,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2795.0,
      "bbox_min": [
        -1064.0,
        -2795.0,
        734.0
      ],
      "bbox_max": [
        -1062.5,
        -2795.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726809740066528,
        0.0,
        -0.739932656288147
      ],
      "plane_d": 1260.7265625,
      "bbox_min": [
        -1069.0,
        -2776.5,
        732.0
      ],
      "bbox_max": [
        -1065.7000732421875,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2775.499755859375,
      "bbox_min": [
        -1069.0,
        -2776.5,
        732.0
      ],
      "bbox_max": [
        -1065.7000732421875,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.5,
      "bbox_min": [
        -1069.0,
        -2776.5,
        732.0
      ],
      "bbox_max": [
        -1065.7000732421875,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6896594166755676,
        0.0,
        0.7241339683532715
      ],
      "plane_d": -1268.0361328125,
      "bbox_min": [
        -1069.0,
        -2776.5,
        733.0
      ],
      "bbox_max": [
        -1066.9000244140625,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -993.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2720.0,
      "bbox_min": [
        -993.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2720.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.0,
      "bbox_min": [
        -993.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2720.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -990.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2767.0,
        723.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -993.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2720.0,
        760.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2762.0,
      "bbox_min": [
        -993.0,
        -2762.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2724.0,
      "bbox_min": [
        -993.0,
        -2762.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 756.0,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2485.48046875,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1393.7076416015625,
      "bbox_min": [
        -993.0,
        -2727.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 758.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1060.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1068.0,
      "bbox_min": [
        -1070.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1060.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1068.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1060.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1068.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1060.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2761.5,
      "bbox_min": [
        -1068.0,
        -2761.5,
        758.0
      ],
      "bbox_max": [
        -1060.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2724.5,
      "bbox_min": [
        -1068.0,
        -2724.5,
        758.0
      ],
      "bbox_max": [
        -1060.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1070.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1068.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1064.5,
        -2728.5,
        750.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -628.4752807617188,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1067.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1068.0,
      "bbox_min": [
        -1070.0,
        -2738.0,
        720.0
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 745.0,
      "bbox_min": [
        -1070.0,
        -2738.0,
        727.6666870117188
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.0,
      "bbox_min": [
        -1070.0,
        -2735.0,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2728.5,
      "bbox_min": [
        -1070.0,
        -2728.5,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2736.5,
      "bbox_min": [
        -1070.0,
        -2738.0,
        727.6666870117188
      ],
      "bbox_max": [
        -1069.0001220703125,
        -2736.5,
        731.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        -0.0,
        -0.9486833810806274
      ],
      "plane_d": 352.2777404785156,
      "bbox_min": [
        -1070.0,
        -2738.0,
        727.6666870117188
      ],
      "bbox_max": [
        -1069.0001220703125,
        -2736.5,
        731.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        0.9486833810806274
      ],
      "plane_d": -1031.851318359375,
      "bbox_min": [
        -1070.0,
        -2738.0,
        731.0
      ],
      "bbox_max": [
        -1069.0001220703125,
        -2736.5,
        731.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1067.0,
        -2733.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1068.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1068.0,
        -2748.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 745.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1068.0,
        -2748.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2757.5,
      "bbox_min": [
        -1070.0,
        -2757.5,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2751.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2751.0,
      "bbox_min": [
        -1070.0,
        -2751.0,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2751.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2749.5,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1069.0,
        -2748.0,
        731.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        0.9486833810806274
      ],
      "plane_d": -1031.851318359375,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1069.0,
        -2748.0,
        731.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        -0.0,
        -0.9486833810806274
      ],
      "plane_d": 352.2777404785156,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1069.0,
        -2748.0,
        728.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.0,
      "bbox_min": [
        -1070.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1067.0,
        -2733.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 723.0,
      "bbox_min": [
        -1068.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1067.0,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1068.0,
      "bbox_min": [
        -1068.0,
        -2751.0,
        723.0
      ],
      "bbox_max": [
        -1068.0,
        -2735.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        0.9486833810806274
      ],
      "plane_d": -1031.851318359375,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        -0.0,
        -0.9486833810806274
      ],
      "plane_d": 352.2777404785156,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2744.0,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2749.5,
      "bbox_min": [
        -1069.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2749.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2742.0,
      "bbox_min": [
        -1070.0,
        -2742.0,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2736.5,
      "bbox_min": [
        -1069.0001220703125,
        -2736.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        -0.0,
        0.9805806875228882
      ],
      "plane_d": -500.68450927734375,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 722.9999389648438,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1064.5,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3713906705379486,
        -0.9284766912460327,
        0.0
      ],
      "plane_d": -2159.358154296875,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284766912460327,
        0.0
      ],
      "plane_d": 2934.264892578125,
      "bbox_min": [
        -1067.0,
        -2734.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1070.0,
        -2720.5,
        754.5
      ],
      "bbox_max": [
        -1060.0,
        -2712.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1070.0,
        -2774.0,
        723.6817016601562
      ],
      "bbox_max": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1070.0,
        -2769.0,
        754.5
      ],
      "bbox_max": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15551012754440308,
        0.18531674146652222,
        0.9702960252761841
      ],
      "plane_d": -356.4674377441406,
      "bbox_min": [
        -1067.43505859375,
        -2774.0,
        723.6817016601562
      ],
      "bbox_max": [
        -1066.1201171875,
        -2773.3525390625,
        726.3181762695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1066.4940185546875,
        -2774.0,
        723.6817016601562
      ],
      "bbox_max": [
        -1066.1202392578125,
        -2773.81591796875,
        723.7416381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2769.5,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 756.5,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2769.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2771.5,
      "bbox_min": [
        -1058.0,
        -2774.0,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2769.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        -1058.0,
        -2771.5,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2769.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2771.5,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2769.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2771.5,
        756.5
      ],
      "bbox_max": [
        -1058.0,
        -2769.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        -1058.0,
        -2774.0,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2771.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2774.0,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2771.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2774.0,
        756.5
      ],
      "bbox_max": [
        -1058.0,
        -2771.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.5,
      "bbox_min": [
        -1018.5,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2769.5,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1018.5,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2770.5,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1018.5,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2770.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1018.5,
        -2770.5,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2769.5,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1018.5,
        -2770.5,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2769.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1009.5,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1008.0,
        -2769.5,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1009.5,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1008.0,
        -2769.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1018.5,
        -2769.5,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1030.0,
        -2769.5,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1045.0,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1040.0,
        -2769.5,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2771.5,
      "bbox_min": [
        -1045.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1040.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1045.0,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1040.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2774.0,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2769.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2771.5,
      "bbox_min": [
        -1035.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1030.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1035.0,
      "bbox_min": [
        -1035.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1030.0,
        -2771.5,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1035.0,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1030.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        -1025.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1018.5,
        -2769.5,
        756.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1025.0,
      "bbox_min": [
        -1025.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1020.0,
        -2771.5,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1025.0,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1020.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1020.0,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1018.5,
        -2769.5,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 758.0,
      "bbox_min": [
        -1060.0,
        -2769.5,
        720.0
      ],
      "bbox_max": [
        -1034.5,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1042.5,
      "bbox_min": [
        -1060.0,
        -2769.5,
        758.0
      ],
      "bbox_max": [
        -1034.5,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2724.5,
      "bbox_min": [
        -1042.5,
        -2761.5,
        758.0
      ],
      "bbox_max": [
        -1034.5,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2761.5,
      "bbox_min": [
        -1042.5,
        -2761.5,
        758.0
      ],
      "bbox_max": [
        -1034.5,
        -2761.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1058.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1058.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2714.5,
      "bbox_min": [
        -1060.0,
        -2769.5,
        720.0
      ],
      "bbox_max": [
        -1034.5,
        -2712.0,
        758.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2716.5,
      "bbox_min": [
        -1060.0,
        -2769.5,
        754.5
      ],
      "bbox_max": [
        -1034.5,
        -2714.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 756.5,
      "bbox_min": [
        -1060.0,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1034.5,
        -2714.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2716.5,
        756.5
      ],
      "bbox_max": [
        -1058.0,
        -2714.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1060.0,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2714.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2714.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1060.0,
        -2769.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1045.0,
      "bbox_min": [
        -1060.0,
        -2714.5,
        720.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        758.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -2691.970703125,
      "bbox_min": [
        -1045.0,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1060.0,
        -2714.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2712.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -2691.970703125,
      "bbox_min": [
        -1035.0,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1034.5,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 758.0,
      "bbox_min": [
        -1034.5,
        -2769.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1018.0,
      "bbox_min": [
        -1020.0,
        -2769.5,
        758.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        -1018.0,
        -2769.5,
        758.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1018.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1010.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1018.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1010.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2761.5,
      "bbox_min": [
        -1018.0,
        -2761.5,
        758.0
      ],
      "bbox_max": [
        -1010.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2724.5,
      "bbox_min": [
        -1018.0,
        -2724.5,
        758.0
      ],
      "bbox_max": [
        -1010.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1010.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1008.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1010.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1020.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1018.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1018.5,
      "bbox_min": [
        -1034.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1009.5,
      "bbox_min": [
        -1018.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1018.5,
        -2715.5,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2712.0,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1018.5,
        -2715.5,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2712.0,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1009.5,
        -2715.5,
        725.5
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1009.5,
        -2715.5,
        725.5
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        -1034.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1018.5,
        -2712.0,
        758.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2714.5,
      "bbox_min": [
        -1034.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1020.0,
        -2712.0,
        758.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1025.0,
      "bbox_min": [
        -1034.5,
        -2714.5,
        720.0
      ],
      "bbox_max": [
        -1020.0,
        -2712.0,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -2691.970703125,
      "bbox_min": [
        -1025.0,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1020.0,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1034.5,
        -2714.5,
        720.0
      ],
      "bbox_max": [
        -1030.0,
        -2712.0,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -2691.970703125,
      "bbox_min": [
        -1034.5,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1030.0,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1020.0,
        -2715.5,
        725.5
      ],
      "bbox_max": [
        -1018.5,
        -2712.0,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2722.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1020.0,
      "bbox_min": [
        -1020.0,
        -2722.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2722.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1444.9727783203125,
      "bbox_min": [
        -1034.5,
        -2769.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2769.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1019.9999389648438,
      "bbox_min": [
        -1020.0,
        -2769.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2769.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1034.5,
        -2769.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1034.5,
        -2720.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2716.5,
      "bbox_min": [
        -1034.5,
        -2720.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 756.5,
      "bbox_min": [
        -1034.5,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2716.5,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1019.9999389648438,
      "bbox_min": [
        -1020.0,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2715.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1019.9999389648438,
      "bbox_min": [
        -1020.0,
        -2720.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1020.0,
        -2769.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -2396.998291015625,
      "bbox_min": [
        -1070.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 646.0870361328125,
      "bbox_min": [
        -1070.0,
        -2767.0,
        650.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1042.5,
      "bbox_min": [
        -1052.166748046875,
        -2767.0,
        650.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        720.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1043.5,
      "bbox_min": [
        -1052.166748046875,
        -2757.500244140625,
        650.0
      ],
      "bbox_max": [
        -1042.5,
        -2728.5,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 658.5677490234375,
      "bbox_min": [
        -1043.5,
        -2757.500244140625,
        650.0
      ],
      "bbox_max": [
        -1042.5,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1043.5,
        -2757.500244140625,
        650.0
      ],
      "bbox_max": [
        -1042.5,
        -2751.0,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -2384.517578125,
      "bbox_min": [
        -1043.5,
        -2752.5,
        650.0
      ],
      "bbox_max": [
        -1042.5,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1043.5,
        -2735.0,
        650.0
      ],
      "bbox_max": [
        -1042.5,
        -2728.5,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1043.5,
        -2752.5,
        650.0
      ],
      "bbox_max": [
        -1042.5,
        -2733.5,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1052.166748046875,
        -2756.000244140625,
        650.0
      ],
      "bbox_max": [
        -1043.5,
        -2730.0,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -1042.5,
        -2761.250244140625,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2724.75,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1042.5,
        -2761.250244140625,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2724.75,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1042.5,
        -2761.250244140625,
        680.0
      ],
      "bbox_max": [
        -1040.0,
        -2724.75,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2722.0,
      "bbox_min": [
        -1070.0,
        -2743.000244140625,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2716.0,
      "bbox_min": [
        -1070.0,
        -2722.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        680.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1068.0,
        -2716.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        -1068.0,
        -2716.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2714.0,
      "bbox_min": [
        -1068.0,
        -2716.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        665.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -654.0,
      "bbox_min": [
        -1066.0,
        -2716.0,
        654.0
      ],
      "bbox_max": [
        -1043.0,
        -2714.0,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 662.0,
      "bbox_min": [
        -1066.0,
        -2716.0,
        654.0
      ],
      "bbox_max": [
        -1043.0,
        -2714.0,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1066.0,
      "bbox_min": [
        -1066.0,
        -2716.0,
        654.0
      ],
      "bbox_max": [
        -1043.0,
        -2714.0,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1043.0,
      "bbox_min": [
        -1043.0,
        -2716.0,
        654.0
      ],
      "bbox_max": [
        -1043.0,
        -2714.0,
        662.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -1068.0,
        -2714.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1068.0,
      "bbox_min": [
        -1068.0,
        -2714.0,
        650.0
      ],
      "bbox_max": [
        -1042.62548828125,
        -2712.0,
        665.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -652.5,
      "bbox_min": [
        -1056.75,
        -2714.0,
        652.0
      ],
      "bbox_max": [
        -1042.62548828125,
        -2712.0,
        656.2249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 652.0,
      "bbox_min": [
        -1056.75,
        -2714.0,
        652.0
      ],
      "bbox_max": [
        -1043.050048828125,
        -2712.0,
        652.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1056.75,
      "bbox_min": [
        -1056.75,
        -2714.0,
        652.0
      ],
      "bbox_max": [
        -1043.050048828125,
        -2712.0,
        652.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1043.050048828125,
      "bbox_min": [
        -1043.050048828125,
        -2714.0,
        652.0
      ],
      "bbox_max": [
        -1043.050048828125,
        -2712.0,
        652.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15551351010799408,
        -0.18532076478004456,
        0.970294713973999
      ],
      "plane_d": -976.5799560546875,
      "bbox_min": [
        -1046.7498779296875,
        -2713.8974609375,
        652.5
      ],
      "bbox_max": [
        -1042.62548828125,
        -2712.0,
        656.2249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6236733198165894,
        -0.7433067560195923,
        -0.2419227659702301
      ],
      "plane_d": -1206.9840087890625,
      "bbox_min": [
        -1046.7498779296875,
        -2713.8974609375,
        652.5
      ],
      "bbox_max": [
        -1042.62548828125,
        -2712.0,
        656.2249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7660663723945618,
        -0.6427614688873291,
        -3.8601458072662354e-05
      ],
      "plane_d": -2544.81591796875,
      "bbox_min": [
        -1046.7498779296875,
        -2713.8974609375,
        652.5
      ],
      "bbox_max": [
        -1043.5660400390625,
        -2712.0,
        656.2249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": -1955.3311767578125,
      "bbox_min": [
        -1046.478759765625,
        -2713.43408203125,
        652.5
      ],
      "bbox_max": [
        -1043.5660400390625,
        -2712.0,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -1098.052490234375,
      "bbox_min": [
        -1046.4786376953125,
        -2712.42333984375,
        652.6627807617188
      ],
      "bbox_max": [
        -1043.7587890625,
        -2712.0,
        653.1300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -22.68560791015625,
      "bbox_min": [
        -1044.4500732421875,
        -2712.376953125,
        652.6851806640625
      ],
      "bbox_max": [
        -1043.7587890625,
        -2712.0,
        653.1300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1044.4500732421875,
      "bbox_min": [
        -1044.4500732421875,
        -2712.050048828125,
        653.0999755859375
      ],
      "bbox_max": [
        -1044.4500732421875,
        -2712.0,
        653.1300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1045.7498779296875,
      "bbox_min": [
        -1045.7498779296875,
        -2712.050048828125,
        653.0999755859375
      ],
      "bbox_max": [
        -1045.7498779296875,
        -2712.0,
        653.1300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2712.050048828125,
      "bbox_min": [
        -1046.478759765625,
        -2713.43408203125,
        653.0999755859375
      ],
      "bbox_max": [
        -1043.5660400390625,
        -2712.0,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1045.7498779296875,
      "bbox_min": [
        -1046.478759765625,
        -2712.050048828125,
        653.0999755859375
      ],
      "bbox_max": [
        -1043.5660400390625,
        -2712.0,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15549270808696747,
        0.1853194236755371,
        -0.9702982902526855
      ],
      "plane_d": 974.1004638671875,
      "bbox_min": [
        -1045.7498779296875,
        -2712.050048828125,
        653.0999755859375
      ],
      "bbox_max": [
        -1043.5660400390625,
        -2712.0,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1044.4500732421875,
      "bbox_min": [
        -1044.4500732421875,
        -2712.050048828125,
        653.3138427734375
      ],
      "bbox_max": [
        -1044.4500732421875,
        -2712.0,
        654.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1044.4500732421875,
      "bbox_min": [
        -1044.4500732421875,
        -2712.050048828125,
        653.0999755859375
      ],
      "bbox_max": [
        -1044.4500732421875,
        -2712.0,
        653.3233642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15549270808696747,
        0.1853194236755371,
        -0.9702982902526855
      ],
      "plane_d": 974.1004638671875,
      "bbox_min": [
        -1046.478759765625,
        -2712.050048828125,
        653.5220947265625
      ],
      "bbox_max": [
        -1045.7498779296875,
        -2712.0,
        653.6484985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15549270808696747,
        0.1853194236755371,
        -0.9702982902526855
      ],
      "plane_d": 974.1004638671875,
      "bbox_min": [
        -1046.436767578125,
        -2713.43408203125,
        653.1817016601562
      ],
      "bbox_max": [
        -1043.625732421875,
        -2712.050048828125,
        653.6322021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": -1955.3311767578125,
      "bbox_min": [
        -1046.7498779296875,
        -2713.050048828125,
        652.5
      ],
      "bbox_max": [
        -1045.59765625,
        -2712.0,
        652.8759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": -1955.3311767578125,
      "bbox_min": [
        -1045.08203125,
        -2713.050048828125,
        652.5
      ],
      "bbox_max": [
        -1043.4500732421875,
        -2712.0,
        652.9038696289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -22.68560791015625,
      "bbox_min": [
        -1044.1231689453125,
        -2713.050048828125,
        652.5
      ],
      "bbox_max": [
        -1043.4500732421875,
        -2712.0,
        652.9038696289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1070.0,
        -2722.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2716.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1070.0,
        -2722.0,
        680.0
      ],
      "bbox_max": [
        -1040.0,
        -2716.0,
        680.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1066.1669921875,
        -2723.30029296875,
        650.0
      ],
      "bbox_max": [
        -1063.9998779296875,
        -2722.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1066.166748046875,
        -2723.300048828125,
        680.0
      ],
      "bbox_max": [
        -1064.0,
        -2722.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -2664.732177734375,
      "bbox_min": [
        -1065.3001708984375,
        -2743.000244140625,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2722.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -1046.500244140625,
        -2727.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2722.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1046.500244140625,
        -2727.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2722.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1046.5,
        -2727.0,
        680.0
      ],
      "bbox_max": [
        -1040.0,
        -2722.0,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1042.5,
      "bbox_min": [
        -1065.3001708984375,
        -2743.000244140625,
        650.0
      ],
      "bbox_max": [
        -1041.5,
        -2722.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1042.5,
        -2728.5,
        650.0
      ],
      "bbox_max": [
        -1041.5,
        -2726.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1042.5,
        -2728.5,
        680.0
      ],
      "bbox_max": [
        -1041.5,
        -2726.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1065.3001708984375,
        -2743.000244140625,
        650.0
      ],
      "bbox_max": [
        -1042.5,
        -2722.0,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -1070.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2716.25048828125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1068.0,
      "bbox_min": [
        -1070.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2716.25048828125,
        720.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1070.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -1068.0,
        -2716.25048828125,
        680.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -1070.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -1068.0,
        -2770.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2764.0,
      "bbox_min": [
        -1068.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2719.250244140625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -1068.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2764.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -1068.0,
        -2770.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2764.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 2706.804931640625,
      "bbox_min": [
        -1068.0,
        -2764.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2719.250244140625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1064.0,
        -2760.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1172.3831787109375,
      "bbox_min": [
        -1068.0,
        -2764.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2719.250244140625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1068.0,
        -2726.0,
        680.0
      ],
      "bbox_max": [
        -1065.300048828125,
        -2719.250244140625,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2728.5,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -628.4752807617188,
      "bbox_min": [
        -1068.0,
        -2757.5,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2402.129150390625,
      "bbox_min": [
        -1068.0,
        -2735.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1068.0,
        -2735.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2728.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -640.9561157226562,
      "bbox_min": [
        -1068.0,
        -2757.5,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2751.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1068.0,
        -2757.5,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2751.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1068.0,
        -2757.5,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2751.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1214.4560546875,
      "bbox_min": [
        -1046.5,
        -2764.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2757.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -1046.5,
        -2764.0,
        650.0
      ],
      "bbox_max": [
        -1040.0,
        -2759.0,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1046.5,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1040.0,
        -2759.0,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        -1042.5,
        -2760.0,
        680.0
      ],
      "bbox_max": [
        -1041.5,
        -2757.5,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -970.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -960.0,
        -2820.0,
        670.0
      ],
      "bbox_max": [
        -880.5184326171875,
        -2712.0,
        729.6666259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.857492983341217,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4620361328125,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -885.3666381835938,
        -2766.999755859375,
        723.5556030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -970.0,
        -2859.5,
        695.5555419921875
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -894.0,
        -2854.677490234375,
        766.4002075195312
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        811.0656127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -884.5225219726562,
        -2747.351318359375,
        766.4002075195312
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        783.182861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -878.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        778.097412109375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -877.9344482421875,
        -2859.5,
        763.2899169921875
      ],
      "bbox_max": [
        -873.5,
        -2846.85400390625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        774.0131225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -878.5,
        -2722.191650390625,
        763.6296997070312
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        774.0131225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -874.5,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -874.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -874.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -874.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2754.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -878.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -874.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4619140625,
      "bbox_min": [
        -890.8987426757812,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -887.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -887.5,
        -2735.5,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -890.8987426757812,
        -2724.955322265625,
        770.4376831054688
      ],
      "bbox_max": [
        -878.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -960.3125,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -914.0,
        -2712.0,
        790.9854736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -897.8980712890625,
        -2788.75,
        790.9302978515625
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -960.3125,
        -2788.75,
        795.468505859375
      ],
      "bbox_max": [
        -932.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -914.0,
        -2788.75,
        817.4066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -932.0,
        -2859.5,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -895.9375,
        -2794.44287109375,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.4982432503529708e-06,
        -0.270979642868042,
        -0.9625850319862366
      ],
      "plane_d": 26.5576171875,
      "bbox_min": [
        -932.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -895.9375,
        -2788.75,
        844.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 927.0,
      "bbox_min": [
        -932.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -919.0,
        -2843.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -839.0,
      "bbox_min": [
        -932.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -927.0,
        -2843.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -928.0,
        -2843.0,
        837.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -932.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -927.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -932.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -927.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -932.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -927.0,
        -2852.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        828.2097778320312
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        828.2097778320312
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        844.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2843.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 822.9999389648438,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4618530273438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 927.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -927.0,
        -2844.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        828.2097778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.996506378229242e-07,
        -0.2709798812866211,
        -0.9625849723815918
      ],
      "plane_d": 26.5545654296875,
      "bbox_min": [
        -970.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -932.0,
        -2788.75,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -970.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -932.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -970.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -932.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -970.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -932.0,
        -2852.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6411095261573792,
        -0.19564983248710632,
        -0.7420914173126221
      ],
      "plane_d": -530.467529296875,
      "bbox_min": [
        -915.298095703125,
        -2978.0,
        790.5328369140625
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7073557376861572,
        -0.10758212953805923,
        -0.6986229419708252
      ],
      "plane_d": -366.921630859375,
      "bbox_min": [
        -915.298095703125,
        -2969.43994140625,
        823.2562255859375
      ],
      "bbox_max": [
        -886.190185546875,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -915.298095703125,
        -2978.0,
        790.5328369140625
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.3569946289062,
        -2978.0,
        790.5328369140625
      ],
      "bbox_max": [
        -893.0887451171875,
        -2930.0,
        816.8629150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -915.298095703125,
        -2978.0,
        792.7325439453125
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -915.298095703125,
        -2978.0,
        818.8846435546875
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -893.3917236328125,
        -2978.0,
        838.7080078125
      ],
      "bbox_max": [
        -892.9408569335938,
        -2976.87353515625,
        842.0806884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -893.3917236328125,
        -2978.0,
        841.642578125
      ],
      "bbox_max": [
        -893.0785522460938,
        -2976.87353515625,
        842.0806884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -893.377685546875,
        -2978.0,
        841.642578125
      ],
      "bbox_max": [
        -893.0785522460938,
        -2976.87353515625,
        842.0687866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -915.298095703125,
        -2978.0,
        841.642578125
      ],
      "bbox_max": [
        -893.16796875,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -914.2279052734375,
        -3073.32177734375,
        802.6903076171875
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.4345703125,
        -2990.6005859375,
        802.6903076171875
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.98046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -893.0887451171875,
        -2985.04052734375,
        816.8317260742188
      ],
      "bbox_max": [
        -890.670654296875,
        -2978.0,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.521484375,
        -2985.04052734375,
        816.8317260742188
      ],
      "bbox_max": [
        -890.670654296875,
        -2978.0,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.521484375,
        -2985.04052734375,
        819.4458618164062
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.98046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -891.521484375,
        -2985.04052734375,
        820.1769409179688
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.98046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -914.2279052734375,
        -3073.32177734375,
        820.3665161132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -891.6133422851562,
        -2985.04052734375,
        820.3665161132812
      ],
      "bbox_max": [
        -890.571044921875,
        -2978.0,
        828.7775268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -914.2279052734375,
        -3060.28271484375,
        820.3665161132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -892.9408569335938,
        -2985.04052734375,
        820.3665161132812
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        838.7080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -914.2279052734375,
        -3060.28271484375,
        841.7567138671875
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -914.2279052734375,
        -3044.99755859375,
        842.0687866210938
      ],
      "bbox_max": [
        -893.377685546875,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt03a",
      "entity_class": "CGameArea",
      "piece_name": "mt03a",
      "offset": 54,
      "centroid": [
        -957.25,
        -2795.625,
        784.0
      ],
      "bbox_min": [
        -991.5,
        -2854.5,
        720.0
      ],
      "bbox_max": [
        -917.5,
        -2723.0,
        828.0
      ],
      "dimensions_source": {
        "span_x": 74.0,
        "span_y": 131.5,
        "height_z": 108.0,
        "door_width": 131.5,
        "door_depth": 74.0,
        "leaf_depth": 74.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -991.5,
          -2763.0,
          720.0
        ],
        [
          -991.5,
          -2723.0,
          720.0
        ],
        [
          -991.5,
          -2723.0,
          760.0
        ],
        [
          -991.5,
          -2763.0,
          760.0
        ],
        [
          -928.5,
          -2854.5,
          828.0
        ],
        [
          -928.5,
          -2842.0,
          828.0
        ],
        [
          -917.5,
          -2842.0,
          828.0
        ],
        [
          -917.5,
          -2854.5,
          828.0
        ]
      ],
      "plane_distance": -991.5
    }
  ],
  "tutorial_messages": []
}